export const portalData = {
  "Succeeded": true,
  "Message": "Dcoument Type Received Successfully!!",
  "Errors": null,
  "Data": [
    {
      "PortalID": 1,
      "PortalName": "Account Inquiry",
      "PortalDescription": "Account Inquiry",
      "PortalKey": "AI"
    },
    {
      "PortalID": 2,
      "PortalName": "Energy Assistance",
      "PortalDescription": "Energy Assistance",
      "PortalKey": "EA"
    },
    {
      "PortalID": 3,
      "PortalName": "Map Center",
      "PortalDescription": "Map Center",
      "PortalKey": "MC"
    },
    {
      "PortalID": 4,
      "PortalName": "Marketer & BBS",
      "PortalDescription": "Marketer & BBS",
      "PortalKey": "MB"
    },
    {
      "PortalID": 5,
      "PortalName": "Supplier Diversity",
      "PortalDescription": "Supplier Diversity",
      "PortalKey": "SD"
    }
  ]
};

export const userRegistrationVerified = {
  "Data": {
    "Id": 70,
    "FirstName": "Ravi",
    "LastName": "Soni",
    "Email": "Ravi.Soni1@sutherlandglobal.com",
    "IsVerified": true,
    "PortalId": 3,
    "PortlaName": "Map Center",
    "PortalKey": "MC",
    "IsMandateDone": false,
    "status": "submitted"
  }
};

export const userDetails = {
  id: null,
  firstName: '',
  lastName: '',
  companyName: '',
  telephone: null,
  email: '',
  confirmEmail: '',
  password: '',
  confirmPassword: '',
  createdDate: '',
  status: null,
  portalId: null,
  securityQuestions: [],
  firstSecurityQuestion: '',
  firstSecurityAnswer: '',
  secondSecurityQuestion: '',
  secondSecurityAnswer: '',
  thirdSecurityQuestion: '',
  thirdSecurityAnswer: '',
  organizationList: [],
  assignToAgency: '',
  assignToJurisdiction: ''
}

export const portalAccessData = {
  "Succeeded": true,
  "Message": "UserPortalRoleMappingResult Recieved",
  "Errors": null,
  "Data": [
    {
      "PortalID": 1,
      "PortalName": "Account Inquiry",
      "UserDetails": null,
      "PortalRoleAccess": [
        {
          "RoleID": 2,
          "RoleName": "Admin",
          "FeatureAccess": [
            {
              "AccessID": 1,
              "AccessName": "Unlock Profile ",
              "RoleAccessMappingID": 1,
              "IsActive": true
            },
            {
              "AccessID": 2,
              "AccessName": "Reset Password",
              "RoleAccessMappingID": 2,
              "IsActive": true
            },
            {
              "AccessID": 3,
              "AccessName": "Delete Profile",
              "RoleAccessMappingID": 3,
              "IsActive": true
            },
            {
              "AccessID": 4,
              "AccessName": "Forgot Password",
              "RoleAccessMappingID": 4,
              "IsActive": true
            },
            {
              "AccessID": 5,
              "AccessName": "Assign Agency",
              "RoleAccessMappingID": 5,
              "IsActive": true
            },
            {
              "AccessID": 6,
              "AccessName": "User Registration",
              "RoleAccessMappingID": 6,
              "IsActive": true
            },
            {
              "AccessID": 7,
              "AccessName": "Approve Profile Registration",
              "RoleAccessMappingID": 7,
              "IsActive": true
            },
            {
              "AccessID": 8,
              "AccessName": "Reject Profile Registration",
              "RoleAccessMappingID": 8,
              "IsActive": true
            },
            {
              "AccessID": 9,
              "AccessName": "Search by Account Holder",
              "RoleAccessMappingID": 9,
              "IsActive": true
            },
            {
              "AccessID": 10,
              "AccessName": "Washington Gas Account",
              "RoleAccessMappingID": 10,
              "IsActive": true
            },
            {
              "AccessID": 11,
              "AccessName": "Telephone Number",
              "RoleAccessMappingID": 11,
              "IsActive": true
            },
            {
              "AccessID": 12,
              "AccessName": "Service Address",
              "RoleAccessMappingID": 12,
              "IsActive": true
            },
            {
              "AccessID": 13,
              "AccessName": "Search Result",
              "RoleAccessMappingID": 13,
              "IsActive": true
            },
            {
              "AccessID": 14,
              "AccessName": "View Organization Profiles",
              "RoleAccessMappingID": 14,
              "IsActive": true
            }
          ]
        },
        {
          "RoleID": 3,
          "RoleName": "Contributor",
          "FeatureAccess": [
            {
              "AccessID": 1,
              "AccessName": "Unlock Profile ",
              "RoleAccessMappingID": 15,
              "IsActive": false
            },
            {
              "AccessID": 2,
              "AccessName": "Reset Password",
              "RoleAccessMappingID": 16,
              "IsActive": true
            },
            {
              "AccessID": 3,
              "AccessName": "Delete Profile",
              "RoleAccessMappingID": 17,
              "IsActive": true
            },
            {
              "AccessID": 4,
              "AccessName": "Forgot Password",
              "RoleAccessMappingID": 18,
              "IsActive": true
            },
            {
              "AccessID": 5,
              "AccessName": "Assign Agency",
              "RoleAccessMappingID": 19,
              "IsActive": false
            },
            {
              "AccessID": 6,
              "AccessName": "User Registration",
              "RoleAccessMappingID": 20,
              "IsActive": true
            },
            {
              "AccessID": 7,
              "AccessName": "Approve Profile Registration",
              "RoleAccessMappingID": 21,
              "IsActive": false
            },
            {
              "AccessID": 8,
              "AccessName": "Reject Profile Registration",
              "RoleAccessMappingID": 22,
              "IsActive": false
            },
            {
              "AccessID": 9,
              "AccessName": "Search by Account Holder",
              "RoleAccessMappingID": 23,
              "IsActive": true
            },
            {
              "AccessID": 10,
              "AccessName": "Washington Gas Account",
              "RoleAccessMappingID": 24,
              "IsActive": true
            },
            {
              "AccessID": 11,
              "AccessName": "Telephone Number",
              "RoleAccessMappingID": 25,
              "IsActive": true
            },
            {
              "AccessID": 12,
              "AccessName": "Service Address",
              "RoleAccessMappingID": 26,
              "IsActive": true
            },
            {
              "AccessID": 13,
              "AccessName": "Search Result",
              "RoleAccessMappingID": 27,
              "IsActive": true
            },
            {
              "AccessID": 14,
              "AccessName": "View Organization Profiles",
              "RoleAccessMappingID": 28,
              "IsActive": false
            }
          ]
        },
        {
          "RoleID": 4,
          "RoleName": "Owner",
          "FeatureAccess": [
            {
              "AccessID": 1,
              "AccessName": "Unlock Profile ",
              "RoleAccessMappingID": 29,
              "IsActive": true
            },
            {
              "AccessID": 2,
              "AccessName": "Reset Password",
              "RoleAccessMappingID": 30,
              "IsActive": true
            },
            {
              "AccessID": 3,
              "AccessName": "Delete Profile",
              "RoleAccessMappingID": 31,
              "IsActive": true
            },
            {
              "AccessID": 4,
              "AccessName": "Forgot Password",
              "RoleAccessMappingID": 32,
              "IsActive": true
            },
            {
              "AccessID": 5,
              "AccessName": "Assign Agency",
              "RoleAccessMappingID": 33,
              "IsActive": true
            },
            {
              "AccessID": 6,
              "AccessName": "User Registration",
              "RoleAccessMappingID": 34,
              "IsActive": true
            },
            {
              "AccessID": 7,
              "AccessName": "Approve Profile Registration",
              "RoleAccessMappingID": 35,
              "IsActive": true
            },
            {
              "AccessID": 8,
              "AccessName": "Reject Profile Registration",
              "RoleAccessMappingID": 36,
              "IsActive": true
            },
            {
              "AccessID": 9,
              "AccessName": "Search by Account Holder",
              "RoleAccessMappingID": 37,
              "IsActive": true
            },
            {
              "AccessID": 10,
              "AccessName": "Washington Gas Account",
              "RoleAccessMappingID": 38,
              "IsActive": true
            },
            {
              "AccessID": 11,
              "AccessName": "Telephone Number",
              "RoleAccessMappingID": 39,
              "IsActive": true
            },
            {
              "AccessID": 12,
              "AccessName": "Service Address",
              "RoleAccessMappingID": 40,
              "IsActive": true
            }
          ]
        }
      ]
    }
  ]
}

export const statusData = {
  "Succeeded": true,
  "Message": "Status Recieved",
  "Errors": null,
  "Data": [
    {
      "StatusId": 1,
      "StatusKey": "submitted",
      "StatusDescription": "Submitted"
    },
    {
      "StatusId": 2,
      "StatusKey": "verified",
      "StatusDescription": "Verified"
    },
    {
      "StatusId": 3,
      "StatusKey": "partiallyverified",
      "StatusDescription": "Partially Verified"
    },
    {
      "StatusId": 4,
      "StatusKey": "approved",
      "StatusDescription": "Approved"
    },
    {
      "StatusId": 5,
      "StatusKey": "deny",
      "StatusDescription": "Deny"
    },
  ]
}

export const documentTypeData = [
  {
    DocumentTypeID: "1",
    DocumentType: "drivingLicenseFront",
    DocumentDescription: "Driving License(Front)"
  },
  {
    DocumentTypeID: "2",
    DocumentType: "drivingLicenseLast",
    DocumentDescription: "Driving License(Last)"
  },
  {
    DocumentTypeID: "3",
    DocumentType: "nondisclosureagreement",
    DocumentDescription: "Non disclosure agreement"
  }
]

export const supplierDocumentTypeData = [
  {
    DocumentTypeID: "1",
    DocumentType: "certificationDocument",
    DocumentDescription: "Certification Document"
  },
  {
    DocumentTypeID: "2",
    DocumentType: "capabilityStatement",
    DocumentDescription: "Capability Statement"
  },
  {
    DocumentTypeID: "3",
    DocumentType: "additionalDocuments",
    DocumentDescription: "Additional Documents"
  }
]

export const supplierClassificationData = [
  {
    DocumentTypeID: "1",
    DocumentType: "minorityOwnedBusiness",
    DocumentDescription: "Minority-Owned Business"
  },
  {
    DocumentTypeID: "2",
    DocumentType: "womenOwnedBusiness",
    DocumentDescription: "Women-Owned Business"
  },
  {
    DocumentTypeID: "3",
    DocumentType: "hubZone",
    DocumentDescription: "Hub-Zone"
  },
  {
    DocumentTypeID: "4",
    DocumentType: "serviceDisabledVeteranBusiness",
    DocumentDescription: "Service Disabled Veteran Business"
  },
  {
    DocumentTypeID: "5",
    DocumentType: "veteranOwnedBusiness",
    DocumentDescription: "Veteran Owned Business"
  },
  {
    DocumentTypeID: "6",
    DocumentType: "notForProfitEntity",
    DocumentDescription: "Not For Profit Entity"
  }
]

export const supplierBusinessData = [
  {
    DocumentTypeID: "1",
    DocumentType: "constructionSupportServices",
    DocumentDescription: "Construction Support Services"
  },
  {
    DocumentTypeID: "2",
    DocumentType: "digitalIt",
    DocumentDescription: "Digital/IT"
  },
  {
    DocumentTypeID: "3",
    DocumentType: "electrical",
    DocumentDescription: "Electrical"
  },
  {
    DocumentTypeID: "4",
    DocumentType: "energyEfficiency",
    DocumentDescription: "Energy Efficiency"
  },
  {
    DocumentTypeID: "5",
    DocumentType: "fuel",
    DocumentDescription: "Fuel"
  }
]

export const supportedFormat = ['.jpeg', '.png', '.docx', '.pdf']

export const supplierSupportedFormat = ['.jpg', '.png', '.docx', '.pdf']

export const supportSupportedFormat = ['.jpg', '.png', '.docx','.doc', '.pdf','.xls', '.xlsx', '.txt', '.csv', '.zip']

export const announcementFormat = ['.jpg', '.png', '.docx', '.pdf', '.xls', '.xlsx', '.txt', '.zip', '.csv']

export const firmSupportedFormat = ['.xls', '.xlsx']

export const mapRequestFormat = ['.pdf', '.PNG', '.jpg', '.jpeg', '.jpe', '.png', '.tif', '.tiff', '.bmp', '.jxr', '.dwg', '.zip', '.7z', '.rar', '.tar.gz', '.gz', '.bz2', '.shp', '.kmz'];

export const supplierDiversityFormat = ['.pdf', '.doc', '.docx', '.docs', '.csv', '.xlsx', '.xls', '.txt', '.bmp', '.jpg', '.gif']

export const registerMapCenter =
{
  "Data": {
    "UserID": 1,
    "FullName": "Anu Vijay",
    "AlternateEmail": "rar@test.com",
    "DLState": "CA",
    "DLNumber": "CA45154",
    "HomeStreetAddress1": "TEST",
    "HomeStreetAddress2": "TES",
    "HomeCity": "TES",
    "HomeState": "TES",
    "HomeZipCode": "125487",
    "CompanyName": "TESA",
    "TaxIdentificationNumber": "41254SAW",
    "CompanyStreetAddress1": "DADAS",
    "CompanyStreetAddress2": "DASD",
    "CompanyCity": "DASD",
    "CompanyState": "DASD",
    "CompanyZipCode": "DASD",
    "CompanyContactName": "DASD",
    "CompanyContactTelephone": "1234567890",
    "CompanyContactEmailAddress": "DAS@test.com",
    "AuthorizedWGLContact": "REWR",    
    "AdditionalID": null,
    "FileData": []
  }
}

export const getMapCenterData =
{
  "Data": {
    "UserID": 70,
    "FullName": "Ravi",
    "DLState": 2,
    "DLNumber": "CA45154",
    "HomeStreetAddress1": "TEST",
    "HomeStreetAddress2": "TES",
    "HomeCity": "TES",
    "HomeState": 5,
    "HomeZipCode": "125487",
    "CompanyName": "TESA",
    "TaxIdentificationNumber": "41254SAW",
    "CompanyStreetAddress1": "DADAS",
    "CompanyStreetAddress2": "DASD",
    "CompanyCity": "DASD",
    "CompanyState": 4,
    "CompanyZipCode": "DASD",
    "CompanyContactName": "DASD",
    "CompanyContactTelephone": "1234567890",
    "CompanyContactEmailAddress": "DAS@test.com",
    "AuthorizedWGLContact": "REWR",
    "AdditionalID": null,
    "FileData": [],
    StatusID: 1,
    "DocumentData": [
      {
        "DocumentTypeID": 1,
        "DocumentType": "Driving License Front",
        "DocumentDescription": "Driving License Front"
      },
      {
        "DocumentTypeID": 2,
        "DocumentType": "Drving License Back",
        "DocumentDescription": "Driving License Back"
      },
      {
        "DocumentTypeID": 3,
        "DocumentType": "NDA",
        "DocumentDescription": "NDA"
      }
    ],
    "State": [
      {
        "StateId": 2,
        "StateName": "AL"
      },
      {
        "StateId": 3,
        "StateName": "NY"
      },
      {
        "StateId": 4,
        "StateName": "WC"
      },
      {
        "StateId": 5,
        "StateName": "CL"
      }
    ]
  }
}

export const getSupplierDiversityData = {
  "Succeeded": true,
  "Message": "Successfull",
  "Errors": null,
  "Data": {
    "AdditionalID": 12,
    "UserID": 1068,
    "CompanyName": "SGS",
    "ContactPerson": "Anil",
    "Title": "Mr",
    "Address": "Anil Street",
    "City": "NY",
    "State": 3,
    "CompanyWebsite": "www.sgs.com",
    "Email": "anil@sgs.com",
    "ZipCode": "123456",
    "PhoneNumber": "9987123456",
    "Fax": "9987123456",
    "CellPhone": "9987123456",
    "CategoryID": 1,
    "ClassificationID": "1,2",
    "ServicesProductsProvided": "product and services",
    "ExpiryDate": "2027-01-07T08:44:00.38",
    "AgencyID": 1,
    "AgencyStateID": 4,
    "FileData": [
      {
        "ID": 73,
        "AdditionalID": 12,
        "DocumentTypeID": 5,
        "FileName": "Certification.pdf",
        "Format": "PDF",
        "Size": 300,
        "PortalKey": "SD",
        "File": "",
        "Url": "Certification.pdf_1068"
      }
    ],
    "DocumentData": [
      {
        "DocumentTypeID": 4,
        "DocumentType": "Certification Document",
        "DocumentDescription": "Certification Documnet"
      },
      {
        "DocumentTypeID": 5,
        "DocumentType": "Capability Statement",
        "DocumentDescription": "Capability Statement"
      },
      {
        "DocumentTypeID": 6,
        "DocumentType": "Additional1 Document",
        "DocumentDescription": "Additional1 Document"
      },
      {
        "DocumentTypeID": 7,
        "DocumentType": "Additional2 Documnet",
        "DocumentDescription": "Additional2 Documnet"
      },
      {
        "DocumentTypeID": 8,
        "DocumentType": "Additional3 Document",
        "DocumentDescription": "Additional3 Document"
      }
    ],
    "State1": [
      {
        "StateId": 2,
        "StateName": "AL"
      },
      {
        "StateId": 3,
        "StateName": "NY"
      },
      {
        "StateId": 4,
        "StateName": "WC"
      },
      {
        "StateId": 5,
        "StateName": "CL"
      }
    ],
    "BusinessCategory": [
      {
        "CategoryID": 1,
        "CategoryName": "Advertising/Marketing"
      },
      {
        "CategoryID": 2,
        "CategoryName": "Construction Support Services"
      },
      {
        "CategoryID": 3,
        "CategoryName": "Digital/IT"
      },
      {
        "CategoryID": 4,
        "CategoryName": "Electrical"
      },
      {
        "CategoryID": 5,
        "CategoryName": "Energy Efficiency"
      }
    ],
    "Classification": [
      {
        "ClassificationID": 1,
        "ClassificationName": "Minority-Owned Business"
      },
      {
        "ClassificationID": 2,
        "ClassificationName": "Women-Owned Business"
      },
      {
        "ClassificationID": 3,
        "ClassificationName": "Service Disabled Veteran Business"
      },
      {
        "ClassificationID": 4,
        "ClassificationName": "Veteran Owned Business"
      }
    ],
    "Agency": [
      {
        "AgencyID": 1,
        "AgencyName": "Test1 Agency"
      },
      {
        "AgencyID": 2,
        "AgencyName": "Test2 Agency"
      }
    ]
  }
}

export const getAIUserProfileData = {
  "Succeeded": true,
  "Message": null,
  "Errors": null,
  "Data":
  {
    "User": [
      {
        "UserId": 1000,
        "FirstName": "Majid Husain",
        "LastName": "Choudhary",
        "FullName": "Majid Choudhary",
        "EmailID": "MajidHusain.Choudhary@sutherlandglobal.com",
        "IsVerified": true,
        "IsMandateDone": true,
        "Status": "Approved",
        "AgencyID": null,
        "RoleID": 1,
        "locked": true
      },
      {
        "UserId": 1001,
        "FirstName": "Ravi",
        "LastName": "Soni",
        "FullName": "Ravi Soni",
        "EmailID": "Ravi.Soni10@sutherlandglobal.com",
        "IsVerified": false,
        "IsMandateDone": true,
        "Status": "Email Verified",
        "AgencyID": null,
        "RoleID": 3,
        "locked": true
      },
      {
        "UserId": 1034,
        "FirstName": "string",
        "LastName": "string",
        "FullName": "Raghav",
        "EmailID": "me@me.com",
        "IsVerified": false,
        "IsMandateDone": false,
        "Status": "Submitted",
        "AgencyID": null,
        "RoleID": 2,
        "locked": true
      },
      {
        "UserId": 1035,
        "FirstName": "string",
        "LastName": "string",
        "FullName": null,
        "EmailID": "ms@ms.com",
        "IsVerified": false,
        "IsMandateDone": false,
        "Status": "Submitted",
        "AgencyID": null,
        "RoleID": 4,
        "locked": true
      },
      {
        "UserId": 1036,
        "FirstName": "Anu Muthir",
        "LastName": "",
        "FullName": null,
        "EmailID": "anu.muthiri@test.com",
        "IsVerified": false,
        "IsMandateDone": false,
        "Status": "Submitted",
        "AgencyID": null,
        "RoleID": 5,
        "locked": true
      },
      {
        "UserId": 1038,
        "FirstName": "Brian",
        "LastName": "Lara",
        "FullName": null,
        "EmailID": "brian@gmail.com",
        "IsVerified": false,
        "IsMandateDone": false,
        "Status": "Submitted",
        "AgencyID": null,
        "RoleID": 6,
        "locked": true
      },
      {
        "UserId": 1039,
        "FirstName": "Anil",
        "LastName": "Kumble",
        "FullName": "Anil Kumble",
        "EmailID": "anil@sgs.com",
        "IsVerified": false,
        "IsMandateDone": false,
        "Status": "Submitted",
        "AgencyID": null,
        "RoleID": 7,
        "locked": true
      },
      {
        "UserId": 1063,
        "FirstName": "Bret",
        "LastName": "Lee",
        "FullName": "Bret Lee",
        "EmailID": "Bret.Lee@SGS.com",
        "IsVerified": false,
        "IsMandateDone": false,
        "Status": "Submitted",
        "AgencyID": null,
        "RoleID": 8,
        "locked": true
      },
      {
        "UserId": 1071,
        "FirstName": "Harsha",
        "LastName": "Mekala",
        "FullName": "HarshaM",
        "EmailID": "harsha.m@deloit.com",
        "IsVerified": false,
        "IsMandateDone": false,
        "Status": "Submitted",
        "AgencyID": null,
        "RoleID": 7,
        "locked": true
      },
      {
        "UserId": 1074,
        "FirstName": "Anu Vijay",
        "LastName": "",
        "FullName": "Anu Vijay",
        "EmailID": "anu.vijay@test.com",
        "IsVerified": false,
        "IsMandateDone": false,
        "Status": "Submitted",
        "AgencyID": null,
        "RoleID": 6,
        "locked": false
      },
      {
        "UserId": 1073,
        "FirstName": "Ramesh",
        "LastName": "puvvala",
        "FullName": "RameshP",
        "EmailID": "ramesh.p@suther.com",
        "IsVerified": false,
        "IsMandateDone": false,
        "Status": "Submitted",
        "AgencyID": null,
        "RoleID": 5,
        "locked": false
      }
    ],
    "Agency": [
      {
        "AgencyID": 1,
        "AgencyName": "Test1 Agency"
      },
      {
        "AgencyID": 2,
        "AgencyName": "Test2 Agency"
      }
    ],
    "Roles": [
      {
        "RoleID": 1,
        "RoleName": "SuperAdmin"
      },
      {
        "RoleID": 2,
        "RoleName": "Admin"
      },
      {
        "RoleID": 3,
        "RoleName": "Contributor"
      },
      {
        "RoleID": 4,
        "RoleName": "Owner"
      },
      {
        "RoleID": 5,
        "RoleName": "Reviewer"
      },
      {
        "RoleID": 6,
        "RoleName": "Approver"
      },
      {
        "RoleID": 7,
        "RoleName": "MapReadOnly"
      },
      {
        "RoleID": 8,
        "RoleName": "MarketerAdminReadOnly"
      }
    ],
    "Marketer": [
      {
        "MarketerID": 1,
        "MarketerName": "Marketer 1"
      },
      {
        "MarketerID": 2,
        "MarketerName": "Marketer 2"
      }
    ],
    "Jurisdictions": [
      {
        "JurisdictionID": 1,
        "JurisdictionName": "Jurisdiction 1"
      },
      {
        "JurisdictionID": 2,
        "JurisdictionName": "Jurisdiction 2"
      }
    ]
  }
}

export const getMBUserProfileData = [
  { ID: 3, FullName: 'Item 3', RoleID: null, StatusID: null, JurisdictionID: null },
  { ID: 4, FullName: 'Item 4', RoleID: null, StatusID: null, JurisdictionID: null },
]

export const getMyProfileData = {
  "Succeeded": true,
  "Message": "User Details Received Successfully!!",
  "Errors": null,
  "Data":
  {
    "UserID": 1072,
    "FullName": "Anu Muthiri",
    "FirstName": "Anu Muthiri",
    "LastName": "",
    "CompanyName": "Suth COmpany",
    "PhoneNumber": "234-567-8987",
    "EmailAddress": "Anuragapriya.muthiri@sutherlandglobal.com",
    "StateID": 3,
    "Address": "Test Address",
    "ZipCode": "56757",
    "TaxIdentificationNumber": "456789",
    "State": [
      {
        "StateId": 2,
        "StateName": "AL"
      },
      {
        "StateId": 3,
        "StateName": "NY"
      },
      {
        "StateId": 4,
        "StateName": "WC"
      },
      {
        "StateId": 5,
        "StateName": "CL"
      }
    ]
  },

}

export const getSupportData = {
  "Succeeded": true,
  "Message": "Successful",
  "Errors": null,
  "Data": {
    "PhoneNumber": "234-567-8987",
    "EmailAddress": "support@wgl.com",
    "Fax": "45678978",
    "AdditionalID": 0,
    "PortalKey": null,
    "PortalID": 3,
    "FileData": [
      {
        "ID": 118,
        "AdditionalID": 0,
        "DocumentTypeID": 0,
        "FileName": "testsupport2.pdf",
        "Format": "pdf",
        "Size": 1,
        "PortalKey": "TM",
        "File": "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",
        "Url": "testsupport2_0.pdf"
      },
      {
        "ID": 119,
        "AdditionalID": 0,
        "DocumentTypeID": 0,
        "FileName": "testsupport3.pdf",
        "Format": "pdf",
        "Size": 1,
        "PortalKey": "TM",
        "File": "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",
        "Url": "testsupport3_0.pdf"
      }
    ]
  }
}

export const announcementData = {
  "Succeeded": true,
  "Message": "Successfull",
  "Errors": null,
  "Data": {
    "AnnouncementData": [
      {
        "ID": 15,
        "Title": "testann",
        "Data": "testannc",
        "StartDate": "2025-01-16T17:36:30.363",
        "EndDate": "2025-01-16T17:36:30.363",
        "PortalID": 5,
        "RoleID": "1,2",
        "IsActive": false,
        "IsPinned": false,
        "FileData": null,
      },
      {
        "ID": 16,
        "Title": "testann",
        "Data": "testannc",
        "StartDate": "2025-01-16T17:36:30.363",
        "EndDate": "2025-01-16T17:36:30.363",
        "PortalID": 3,
        "RoleID": "3",
        "IsActive": false,
        "IsPinned": false,
        "FileData": null,
      },
      {
        "ID": 17,
        "Title": "testann",
        "Data": "testannc",
        "StartDate": "2025-01-16T17:36:30.363",
        "EndDate": "2025-01-16T17:36:30.363",
        "PortalID": 5,
        "RoleID": "3,2",
        "IsActive": false,
        "IsPinned": false,
        "FileData": null,
      },
      {
        "ID": 18,
        "Title": "string",
        "Data": "string",
        "StartDate": "2025-01-15T11:39:21.883",
        "EndDate": "2025-01-15T11:39:21.883",
        "PortalID": 3,
        "RoleID": "1,3",
        "IsActive": false,
        "IsPinned": false,
        "FileData": null,
      }
    ],
    "Roles": [
      {
        "RoleID": 1,
        "RoleName": "Test1",
        "PortalID": 3
      },
      {
        "RoleID": 2,
        "RoleName": "Test2",
        "PortalID": 3
      },
      {
        "RoleID": 3,
        "RoleName": "Test3",
        "PortalID": 3
      }
    ]
  }
}

export const IndividualUserData = {
  "Succeeded": true,
  "Message": "Successfull",
  "Errors": null,
  "Data": {
    "AdditionalID": 16,
    "UserID": 1057,
    "FullName": "Raghavendra WGL",
    "AlternateEmail": "Raghavendra.CN@sutherlandglobal.com",
    "DLState": 4,
    "DLNumber": "WES7541",
    "HomeStreetAddress1": "Miami",
    "HomeStreetAddress2": "Miami",
    "HomeCity": "Miami",
    "HomeState": 2,
    "HomeZipCode": "54251",
    "TaxIdentificationNumber": "TAN4515487458745565877",
    "CompanyStreetAddress1": "Miami",
    "CompanyStreetAddress2": "Miami",
    "CompanyCity": "Miami",
    "CompanyState": 3,
    "CompanyZipCode": "45875",
    "CompanyContactName": "PNR",
    "CompanyContactTelephone": "858-585-9034",
    "CompanyContactEmailAddress": "test@test.com",
    "AuthorizedWGLContact": "PNR",
    "FileData": [
      {
        "ID": 30,
        "AdditionalID": 16,
        "DocumentTypeID": 1,
        "FileName": "Test.pdf",
        "Format": "pdf",
        "Size": 1024,
        "PortalKey": "MC",
        "File": "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",
        "Url": "Test.pdf"
      }
    ],
    "DocumentData": [
      {
        "DocumentTypeID": 1,
        "DocumentType": "Driving License Front",
        "DocumentDescription": "Driving License Front"
      },
      {
        "DocumentTypeID": 2,
        "DocumentType": "Drving License Back",
        "DocumentDescription": "Driving License Back"
      },
      {
        "DocumentTypeID": 3,
        "DocumentType": "NDA",
        "DocumentDescription": "NDA"
      }
    ],
    "State": [
      {
        "StateId": 2,
        "StateName": "AL"
      },
      {
        "StateId": 3,
        "StateName": "NY"
      },
      {
        "StateId": 4,
        "StateName": "WC"
      },
      {
        "StateId": 5,
        "StateName": "CL"
      }
    ]
  }
}

export const faqData = {
  "Succeeded": true,
  "Message": "Successfull",
  "Errors": null,
  "Data": [
    {
      "ID": 2,
      "Question": "What is my Name",
      "Answer": "<b>I am from Sutherland so don't know<b/>",
      "PortalID": 1,
      "IsActive": true
    },
    {
      "ID": 3,
      "Question": "Where is London",
      "Answer": "in UK",
      "PortalID": 1,
      "IsActive": true
    },
    {
      "ID": 4,
      "Question": "Where is London",
      "Answer": "In UK",
      "PortalID": 1,
      "IsActive": true
    },
    {
      "ID": 7,
      "Question": "What is the purpose of an FAQ page?",
      "Answer": "The purpose of an FAQ page is to provide quick answers to common questions that your business can anticipate. An FAQ page empowers customers to self-serve, enabling them to find solutions quickly on their own. FAQ pages aren't meant to solve every issue, which is why it's important to include an option for customers to contact a live agent.",
      "PortalID": 2,
      "IsActive": true
    },
    {
      "ID": 8,
      "Question": "Where can you put an FAQ page?",
      "Answer": "You can put an FAQ page inside your help center, on a checkout or product page, or anywhere where your customers might get stuck. You can also deploy a chatbot to answer FAQs anywhere on your website or mobile app.",
      "PortalID": 3,
      "IsActive": true
    },
    {
      "ID": 10,
      "Question": "Use data to pick the right questions",
      "Answer": "To really meet your customers where they are, harness your CRM data to discover the most common questions across all channels and see how support reps categorize them.",
      "PortalID": 5,
      "IsActive": true
    },
    {
      "ID": 6,
      "Question": "What is an FAQ page?",
      "Answer": "An FAQ (Frequently Asked Questions) page is a key part of a knowledge base because it addresses the most common questions customerss",
      "PortalID": 1,
      "IsActive": true
    },
    {
      "ID": 11,
      "Question": "Is FAQ Completed",
      "Answer": "Yes Sir",
      "PortalID": 2,
      "IsActive": true
    },
    {
      "ID": 12,
      "Question": "Is Announcement Completed",
      "Answer": "Yes Sir",
      "PortalID": 5,
      "IsActive": true
    }
  ]
}

export const marketerGetData = {
  "Succeeded": true,
  "Message": null,
  "Errors": null,
  "Data": {
    "Marketers": [
      {
        "MarketerID": 1,
        "PortalID": "123476983",
        "MarketerName": "Anu",
        "StartDate": "2025-01-29T04:00:00",
        "ServiceProvider": "123434",
        "UETFileID": "2,3",
        "IsActive": true,
      },
      {
        "MarketerID": 2,
        "PortalID": "678908766",
        "MarketerName": "Ravi",
        "StartDate": "2025-01-21T04:00:00",
        "ServiceProvider": "354675",
        "UETFileID": "4,5,6",
        "IsActive": false,
      },
      {
        "MarketerID": 3,
        "PortalID": "87576554",
        "MarketerName": "Boom",
        "StartDate": "2025-01-30T04:00:00",
        "ServiceProvider": "757654",
        "UETFileID": "1,3",
        "IsActive": true,
      },

    ],
    "UETFileDate": [
      {
        "UETFileID": 1,
        "UETFileName": "UETFile One"
      },
      {
        "UETFileID": 2,
        "UETFileName": "UET File 2"
      },
      {
        "UETFileID": 3,
        "UETFileName": "UET File 3"
      },
      {
        "UETFileID": 4,
        "UETFileName": "UET File 4"
      },
      {
        "UETFileID": 5,
        "UETFileName": "UET File 5"
      },
      {
        "UETFileID": 6,
        "UETFileName": "UET File 6"
      }
    ]
  }
}

export const marketerGroupGetData = {
  "Data": {
    "MarketerID": 1,
    "MarketerName": "Marketer1",
    "MarketerStartDate": "2024-01-27T12:25:22.747Z",
    "MarketerGroups": [
      {
        "ID": 1,
        "GroupName": "string",
        "GroupType": "Firm",
        "JurisdictionID": 0,
        "JurisdictionName": null,
        "StartMonth": "2025-01-27T12:25:22.747Z",
        "EndMonth": "2025-01-27T12:25:22.747Z",
        "BalancingModelID": 4,
        "BalancingModelHistory": [
          {
            "BalancingModelName": "BalancingModel1",
            "StartMonth": "2025-01-27T12:25:22.747Z",
            "EndMonth": "2025-01-27T12:25:22.747Z"
          },
          {
            "BalancingModelName": "BalancingModel2",
            "StartMonth": "2025-01-27T12:25:22.747Z",
            "EndMonth": "2025-01-27T12:25:22.747Z"
          },
        ]
      },
      {
        "ID": 2,
        "GroupName": "string",
        "GroupType": "Firm",
        "JurisdictionID": 0,
        "JurisdictionName": "",
        "StartMonth": "2025-01-27T12:25:22.747Z",
        "EndMonth": "2025-01-27T12:25:22.747Z",
        "BalancingModelID": 0,
        "BalancingModelHistory": [
          {
            "BalancingModelName": "BalancingModel1",
            "StartMonth": "2025-01-27T12:25:22.747Z",
            "EndMonth": "2025-01-27T12:25:22.747Z"
          },
          {
            "BalancingModelName": "BalancingModel2",
            "StartMonth": "2025-01-27T12:25:22.747Z",
            "EndMonth": "2025-01-27T12:25:22.747Z"
          },
        ]
      },
      {
        "ID": 3,
        "GroupName": "string",
        "GroupType": "Interruptible",
        "JurisdictionID": 1,
        "JurisdictionName": "Jurd 1",
        "StartMonth": "2025-01-27T12:25:22.747Z",
        "EndMonth": "2025-01-27T12:25:22.747Z",
        "BalancingModelID": 0,
        "BalancingModelHistory": [
          {
            "BalancingModelName": "BalancingModel1",
            "StartMonth": "2025-01-27T12:25:22.747Z",
            "EndMonth": "2025-01-27T12:25:22.747Z"
          },
          {
            "BalancingModelName": "BalancingModel2",
            "StartMonth": "2025-01-27T12:25:22.747Z",
            "EndMonth": "2025-01-27T12:25:22.747Z"
          },
        ]
      }
    ],
    "GroupType": [
      {

        "GroupTypeName": "Firm"
      },
      {

        "GroupTypeName": "Interruptible"
      }
    ],
    "Jurisdiction": [
      {
        "JurisdictionID": 1,
        "JurisdictionName": "DC"
      },
      {
        "JurisdictionID": 2,
        "JurisdictionName": "MD"
      },
      {
        "JurisdictionID": 3,
        "JurisdictionName": "VA"
      }
    ],
    "BalancingModel": [
      {
        "BalancingModelID": 1,
        "BalancingModelName": "Aggregate balancing with tolerance"
      },
      {
        "BalancingModelID": 2,
        "BalancingModelName": "Aggregate balancing"
      },
      {
        "BalancingModelID": 3,
        "BalancingModelName": "Self balancing"
      }
    ],
    "Marketer": [
      {
        "MarketerID": 1,
        "MarketerName": "Marketer1"
      },
      {
        "MarketerID": 2,
        "MarketerName": "Marketer2"
      }
    ]
  }
}
export const pipelineMatrixData = {
  "Succeeded": true,
  "Message": "Get Pipeline Matrix successfully!!",
  "Errors": null,
  "Data": [
    {
      "Range": "0-200000",
      "Matrix": [
        {
          "MatrixID": 7,
          "PipelineID": 2,
          "MatrixTypeID": 1,
          "MatrixTypeName": "Actual DRV Consumption",
          "PipelineName": "Cove Pt",
          "Min": 0,
          "Max": 15
        },
        {
          "MatrixID": 13,
          "PipelineID": 3,
          "MatrixTypeID": 1,
          "MatrixTypeName": "Actual DRV Consumption",
          "PipelineName": "Dominion",
          "Min": 0,
          "Max": 15
        },
        {
          "MatrixID": 19,
          "PipelineID": 4,
          "MatrixTypeID": 1,
          "MatrixTypeName": "Actual DRV Consumption",
          "PipelineName": "Transco",
          "Min": 0,
          "Max": 10
        },
        {
          "MatrixID": 25,
          "PipelineID": 5,
          "MatrixTypeID": 1,
          "MatrixTypeName": "Actual DRV Consumption",
          "PipelineName": "Transco Z6",
          "Min": 0,
          "Max": 5
        },
        {
          "MatrixID": 31,
          "PipelineID": 6,
          "MatrixTypeID": 1,
          "MatrixTypeName": "Actual DRV Consumption",
          "PipelineName": "TCO Transit",
          "Min": 55,
          "Max": 60
        }
      ]
    },
    {
      "Range": "200001-600000",
      "Matrix": [
        {
          "MatrixID": 8,
          "PipelineID": 2,
          "MatrixTypeID": 1,
          "MatrixTypeName": "Actual DRV Consumption",
          "PipelineName": "Cove Pt",
          "Min": 10,
          "Max": 30
        },
        {
          "MatrixID": 14,
          "PipelineID": 3,
          "MatrixTypeID": 1,
          "MatrixTypeName": "Actual DRV Consumption",
          "PipelineName": "Dominion",
          "Min": 5,
          "Max": 15
        },
        {
          "MatrixID": 20,
          "PipelineID": 4,
          "MatrixTypeID": 1,
          "MatrixTypeName": "Actual DRV Consumption",
          "PipelineName": "Transco",
          "Min": 5,
          "Max": 10
        },
        {
          "MatrixID": 26,
          "PipelineID": 5,
          "MatrixTypeID": 1,
          "MatrixTypeName": "Actual DRV Consumption",
          "PipelineName": "Transco Z6",
          "Min": 0,
          "Max": 5
        },
        {
          "MatrixID": 32,
          "PipelineID": 6,
          "MatrixTypeID": 1,
          "MatrixTypeName": "Actual DRV Consumption",
          "PipelineName": "TCO Transit",
          "Min": 45,
          "Max": 80
        }
      ]
    },
    {
      "Range": "600001-1000000",
      "Matrix": [
        {
          "MatrixID": 9,
          "PipelineID": 2,
          "MatrixTypeID": 1,
          "MatrixTypeName": "Actual DRV Consumption",
          "PipelineName": "Cove Pt",
          "Min": 10,
          "Max": 35
        },
        {
          "MatrixID": 15,
          "PipelineID": 3,
          "MatrixTypeID": 1,
          "MatrixTypeName": "Actual DRV Consumption",
          "PipelineName": "Dominion",
          "Min": 5,
          "Max": 20
        },
        {
          "MatrixID": 21,
          "PipelineID": 4,
          "MatrixTypeID": 1,
          "MatrixTypeName": "Actual DRV Consumption",
          "PipelineName": "Transco",
          "Min": 5,
          "Max": 15
        },
        {
          "MatrixID": 27,
          "PipelineID": 5,
          "MatrixTypeID": 1,
          "MatrixTypeName": "Actual DRV Consumption",
          "PipelineName": "Transco Z6",
          "Min": 0,
          "Max": 10
        },
        {
          "MatrixID": 33,
          "PipelineID": 6,
          "MatrixTypeID": 1,
          "MatrixTypeName": "Actual DRV Consumption",
          "PipelineName": "TCO Transit",
          "Min": 30,
          "Max": 80
        }
      ]
    },
    {
      "Range": "1000001-1400000",
      "Matrix": [
        {
          "MatrixID": 10,
          "PipelineID": 2,
          "MatrixTypeID": 1,
          "MatrixTypeName": "Actual DRV Consumption",
          "PipelineName": "Cove Pt",
          "Min": 10,
          "Max": 40
        },
        {
          "MatrixID": 16,
          "PipelineID": 3,
          "MatrixTypeID": 1,
          "MatrixTypeName": "Actual DRV Consumption",
          "PipelineName": "Dominion",
          "Min": 5,
          "Max": 25
        },
        {
          "MatrixID": 22,
          "PipelineID": 4,
          "MatrixTypeID": 1,
          "MatrixTypeName": "Actual DRV Consumption",
          "PipelineName": "Transco",
          "Min": 5,
          "Max": 20
        },
        {
          "MatrixID": 28,
          "PipelineID": 5,
          "MatrixTypeID": 1,
          "MatrixTypeName": "Actual DRV Consumption",
          "PipelineName": "Transco Z6",
          "Min": 0,
          "Max": 20
        },
        {
          "MatrixID": 34,
          "PipelineID": 6,
          "MatrixTypeID": 1,
          "MatrixTypeName": "Actual DRV Consumption",
          "PipelineName": "TCO Transit",
          "Min": 35,
          "Max": 80
        }
      ]
    },
    {
      "Range": "1400001-1800000",
      "Matrix": [
        {
          "MatrixID": 11,
          "PipelineID": 2,
          "MatrixTypeID": 1,
          "MatrixTypeName": "Actual DRV Consumption",
          "PipelineName": "Cove Pt",
          "Min": 15,
          "Max": 40
        },
        {
          "MatrixID": 17,
          "PipelineID": 3,
          "MatrixTypeID": 1,
          "MatrixTypeName": "Actual DRV Consumption",
          "PipelineName": "Dominion",
          "Min": 10,
          "Max": 30
        },
        {
          "MatrixID": 23,
          "PipelineID": 4,
          "MatrixTypeID": 1,
          "MatrixTypeName": "Actual DRV Consumption",
          "PipelineName": "Transco",
          "Min": 10,
          "Max": 25
        },
        {
          "MatrixID": 29,
          "PipelineID": 5,
          "MatrixTypeID": 1,
          "MatrixTypeName": "Actual DRV Consumption",
          "PipelineName": "Transco Z6",
          "Min": 0,
          "Max": 25
        },
        {
          "MatrixID": 35,
          "PipelineID": 6,
          "MatrixTypeID": 1,
          "MatrixTypeName": "Actual DRV Consumption",
          "PipelineName": "TCO Transit",
          "Min": 40,
          "Max": 75
        }
      ]
    },
    {
      "Range": "1800001+",
      "Matrix": [
        {
          "MatrixID": 12,
          "PipelineID": 2,
          "MatrixTypeID": 1,
          "MatrixTypeName": "Actual DRV Consumption",
          "PipelineName": "Cove Pt",
          "Min": 20,
          "Max": 40
        },
        {
          "MatrixID": 18,
          "PipelineID": 3,
          "MatrixTypeID": 1,
          "MatrixTypeName": "Actual DRV Consumption",
          "PipelineName": "Dominion",
          "Min": 10,
          "Max": 40
        },
        {
          "MatrixID": 24,
          "PipelineID": 4,
          "MatrixTypeID": 1,
          "MatrixTypeName": "Actual DRV Consumption",
          "PipelineName": "Transco",
          "Min": 10,
          "Max": 30
        },
        {
          "MatrixID": 30,
          "PipelineID": 5,
          "MatrixTypeID": 1,
          "MatrixTypeName": "Actual DRV Consumption",
          "PipelineName": "Transco Z6",
          "Min": 0,
          "Max": 25
        },
        {
          "MatrixID": 36,
          "PipelineID": 6,
          "MatrixTypeID": 1,
          "MatrixTypeName": "Actual DRV Consumption",
          "PipelineName": "TCO Transit",
          "Min": 45,
          "Max": 80
        }
      ]
    }
  ]
}

export const pipelineGuideData = {
  "Succeeded": true,
  "Message": "Get PipelineDeliveryGuid successfully",
  "Errors": null,
  "Data": {
    "PipelineGuide": {
      "SystemLoad": 600000,
      "DRVAssigned": 5000,
      "StorageWithdral": 0,
      "RemainingFTLoad": 4000
    },
    "PipeLines": [
      {
        "MatrixID": 8,
        "PipeNomination": 2000,
        "PipelineName": "Cove Pt",
        "MinValue": "10",
        "MaxValue": "30"
      },
      {
        "MatrixID": 14,
        "PipeNomination": 2000,
        "PipelineName": "Dominion",
        "MinValue": "5",
        "MaxValue": "15"
      },
      {
        "MatrixID": 20,
        "PipeNomination": 2000,
        "PipelineName": "Transco",
        "MinValue": "5",
        "MaxValue": "10"
      },
      {
        "MatrixID": 26,
        "PipeNomination": 2000,
        "PipelineName": "Transco Z6",
        "MinValue": "0",
        "MaxValue": "5"
      },
      {
        "MatrixID": 32,
        "PipeNomination": 2000,
        "PipelineName": "TCO Transit",
        "MinValue": "45",
        "MaxValue": "80"
      }
    ]
  }
}

export const getNominationPipeline = {
  "Succeeded": true,
  "Message": null,
  "Errors": null,
  "Data": {
    "NominationData": {
      "PipelineID": 101,
      "PipelineName": "Columbia",
      "CompanyId": 173,
      "ContractData": [
        {
          "ContractID": 3934,
          "ContractDetails": [
            {
              "ContractDate": "2025-02-13T00:00:00",
              "ContractValue": "500"
            },
            {
              "ContractDate": "2025-02-14T00:00:00",
              "ContractValue": "600"
            },
            {
              "ContractDate": "2025-02-14T00:00:00",
              "ContractValue": "600"
            },
            {
              "ContractDate": "2025-02-14T00:00:00",
              "ContractValue": "700"
            },
            {
              "ContractDate": "2025-02-02T00:00:00",
              "ContractValue": "100"
            }
          ]
        },
        {
          "ContractID": 86149,
          "ContractDetails": [
            {
              "ContractDate": "2025-02-01T00:00:00",
              "ContractValue": "40"
            }
          ]
        },
        {
          "ContractID": 1234,
          "ContractDetails": [
            {
              "ContractDate": "2025-02-13T00:00:00",
              "ContractValue": "500"
            },
            {
              "ContractDate": "2025-02-14T00:00:00",
              "ContractValue": "600"
            },
            {
              "ContractDate": "2025-02-14T00:00:00",
              "ContractValue": "600"
            },
            {
              "ContractDate": "2025-02-14T00:00:00",
              "ContractValue": "700"
            },
            {
              "ContractDate": "2025-02-02T00:00:00",
              "ContractValue": "100"
            }
          ]
        },
        {
          "ContractID": 3456,
          "ContractDetails": [
            {
              "ContractDate": "2025-02-13T00:00:00",
              "ContractValue": "500"
            },
            {
              "ContractDate": "2025-02-14T00:00:00",
              "ContractValue": "600"
            },
            {
              "ContractDate": "2025-02-14T00:00:00",
              "ContractValue": "600"
            },
            {
              "ContractDate": "2025-02-14T00:00:00",
              "ContractValue": "700"
            },
            {
              "ContractDate": "2025-02-02T00:00:00",
              "ContractValue": "100"
            }
          ]
        },
        {
          "ContractID": 7890,
          "ContractDetails": [
            {
              "ContractDate": "2025-02-13T00:00:00",
              "ContractValue": "500"
            },
            {
              "ContractDate": "2025-02-14T00:00:00",
              "ContractValue": "600"
            },
            {
              "ContractDate": "2025-02-14T00:00:00",
              "ContractValue": "600"
            },
            {
              "ContractDate": "2025-02-14T00:00:00",
              "ContractValue": "700"
            },
            {
              "ContractDate": "2025-02-02T00:00:00",
              "ContractValue": "100"
            }
          ]
        },
        {
          "ContractID": 4567,
          "ContractDetails": [
            {
              "ContractDate": "2025-02-13T00:00:00",
              "ContractValue": "500"
            },
            {
              "ContractDate": "2025-02-14T00:00:00",
              "ContractValue": "600"
            },
            {
              "ContractDate": "2025-02-14T00:00:00",
              "ContractValue": "600"
            },
            {
              "ContractDate": "2025-02-14T00:00:00",
              "ContractValue": "700"
            },
            {
              "ContractDate": "2025-02-02T00:00:00",
              "ContractValue": "100"
            }
          ]
        },
      ],
      "TotalPipelineData": {
        "ContractName": "Columbia",
        "ContractDetails": [
          {
            "ContractDate": "2025-02-01T00:00:00",
            "ContractValue": "40"
          },
          {
            "ContractDate": "2025-02-02T00:00:00",
            "ContractValue": "100"
          },
          {
            "ContractDate": "2025-02-13T00:00:00",
            "ContractValue": "500"
          },
          {
            "ContractDate": "2025-02-14T00:00:00",
            "ContractValue": "1900"
          }
        ]
      },
      "TotalAllPipelineData": {
        "ContractName": "Pipeline",
        "ContractDetails": [
          {
            "ContractDate": "2025-02-01T00:00:00",
            "ContractValue": "40"
          },
          {
            "ContractDate": "2025-02-02T00:00:00",
            "ContractValue": "100"
          },
          {
            "ContractDate": "2025-02-13T00:00:00",
            "ContractValue": "500"
          },
          {
            "ContractDate": "2025-02-14T00:00:00",
            "ContractValue": "1900" //total of all contracts for the pipeline Columbia for the month of February 14th 600+600+700
          }
        ]
      },
      "TotalGroupData": {
        "ContractName": "Group",
        "ContractDetails": []
      }
    },
    "PipelineData": [
      {
        "PipelineID": 101,
        "Name": "Columbia"
      }
    ],
    "MarketerData": [
      {
        "MarketerID": 173,
        "MarketerName": "Amerada Hess Corp"
      }
    ]
  }
}

export const getByInterruptible = {
  "Succeeded": true,
  "Message": null,
  "Errors": null,
  "Data": {
    "InterruptibleData": [
      {
        "AllocationGroupID": 743,
        "CompanyID": 100914,
        "CompanyName": "NRG Business Market,LLC - 145",
        "AllocationGroup": "HEM MD IP",
        "EffectiveDate": "2024-12-01T00:00:00",
        "EndDate": "2024-12-31T00:00:00",
        "PreviousBalanceFirm": 0,
        "PreviousBalanceInterruptible": -7630,
        "CashOutAdjustmentAmount": 0,
        "ImbalanceAdjustedVolume": 0,
        "DailyRequiredVolume": 0,
        "ShipmentMonth": "2024-12-01T00:00:00",
        "TotalForecastImbal": 0,
        "TotalNominationAllocations": 0,
        "TotalUsage": 508,
        "ThresholdValue": 76,
        "MonthEndImbalanceInterruptible": -8138,
        "MonthEndImbalanceFirm": -7630,
        "OutsideThresholdAmount": -8062
      }
    ],
    "Marketers": [
      {
        "MarketerID": 101,
        "MarketerName": "Washington Gas"
      },
      {
        "MarketerID": 103,
        "MarketerName": "Constellation Energy Source"
      },
      {
        "MarketerID": 134,
        "MarketerName": "UGI Energy Services - 33"
      },
      {
        "MarketerID": 136,
        "MarketerName": "WGL Energy Svcs - 35"
      },
      {
        "MarketerID": 161,
        "MarketerName": "Colonial Energy"
      },
      {
        "MarketerID": 177,
        "MarketerName": "NOVEC Energy Solutions – 76"
      },
      {
        "MarketerID": 179,
        "MarketerName": "Sprague Op Res LLC - 78"
      },
      {
        "MarketerID": 182,
        "MarketerName": "Bollinger Energy"
      },
      {
        "MarketerID": 203,
        "MarketerName": "Sprague Op Res LLC - 102"
      },
      {
        "MarketerID": 204,
        "MarketerName": "Gateway Energy Services"
      },
      {
        "MarketerID": 205,
        "MarketerName": "Stand Energy"
      },
      {
        "MarketerID": 210,
        "MarketerName": "A-Advantage Heating & A/C, Inc."
      },
      {
        "MarketerID": 211,
        "MarketerName": "Argent Heating & Cooling, LLC"
      },
      {
        "MarketerID": 212,
        "MarketerName": "ARS of MD d/b/a John C. Dorsey"
      },
      {
        "MarketerID": 213,
        "MarketerName": "R. A. Dobson, Inc."
      },
      {
        "MarketerID": 214,
        "MarketerName": "Home Appliance Repair"
      },
      {
        "MarketerID": 215,
        "MarketerName": "JED Mechanical"
      },
      {
        "MarketerID": 216,
        "MarketerName": "Jiffy Plumbing and Heating, Inc."
      },
      {
        "MarketerID": 217,
        "MarketerName": "Mindte Heating & A/C"
      },
      {
        "MarketerID": 218,
        "MarketerName": "Moran's Refrigeration Service"
      },
      {
        "MarketerID": 219,
        "MarketerName": "My Plumber"
      },
      {
        "MarketerID": 220,
        "MarketerName": "A-One Air, Inc."
      },
      {
        "MarketerID": 221,
        "MarketerName": "All-Pro Services, Inc."
      },
      {
        "MarketerID": 222,
        "MarketerName": "Brennan's Heating & A/C Service"
      },
      {
        "MarketerID": 223,
        "MarketerName": "Central Services, Inc."
      },
      {
        "MarketerID": 224,
        "MarketerName": "Mann-In, Inc."
      },
      {
        "MarketerID": 226,
        "MarketerName": "Spartan Plumbing, Heating"
      },
      {
        "MarketerID": 227,
        "MarketerName": "Utility Service Express"
      },
      {
        "MarketerID": 228,
        "MarketerName": "Cropp-Metcalfe"
      },
      {
        "MarketerID": 229,
        "MarketerName": "John C. Flood"
      },
      {
        "MarketerID": 230,
        "MarketerName": "S. J. Burdick, Inc."
      },
      {
        "MarketerID": 231,
        "MarketerName": "Featherstone A/C & Heating, Inc."
      },
      {
        "MarketerID": 232,
        "MarketerName": "Foley Mechanical"
      },
      {
        "MarketerID": 233,
        "MarketerName": "Jim's Inc. (Plumbing & Heating)"
      },
      {
        "MarketerID": 234,
        "MarketerName": "Jolles Brothers, Inc."
      },
      {
        "MarketerID": 235,
        "MarketerName": "Jones-Rogers, Inc."
      },
      {
        "MarketerID": 236,
        "MarketerName": "M & M Mechanical, Inc."
      },
      {
        "MarketerID": 237,
        "MarketerName": "Pope's Heating & A/C Service"
      },
      {
        "MarketerID": 238,
        "MarketerName": "Air Pro Heating and A/C, Inc."
      },
      {
        "MarketerID": 239,
        "MarketerName": "John C. Flood, Inc. of Va."
      },
      {
        "MarketerID": 240,
        "MarketerName": "C. B. Lucas Co., Inc."
      },
      {
        "MarketerID": 241,
        "MarketerName": "Robinsons Air Cond. & Htg."
      },
      {
        "MarketerID": 242,
        "MarketerName": "Vernon Heating & A/C"
      },
      {
        "MarketerID": 243,
        "MarketerName": "Woodbridge Plumbing, Inc."
      },
      {
        "MarketerID": 244,
        "MarketerName": "Ace A/C & Heating Co."
      },
      {
        "MarketerID": 245,
        "MarketerName": "Hamby Services Corp."
      },
      {
        "MarketerID": 246,
        "MarketerName": "Combustioneer Corp."
      },
      {
        "MarketerID": 247,
        "MarketerName": "Northstar Heating & A/C, Inc."
      },
      {
        "MarketerID": 248,
        "MarketerName": "Airon, Inc."
      },
      {
        "MarketerID": 249,
        "MarketerName": "Airflow Service Company"
      },
      {
        "MarketerID": 250,
        "MarketerName": "Bowman's Heating & Air Cond."
      },
      {
        "MarketerID": 251,
        "MarketerName": "Cyprus Heating & A/C, Inc."
      },
      {
        "MarketerID": 252,
        "MarketerName": "M.E. Flow, Inc."
      },
      {
        "MarketerID": 253,
        "MarketerName": "RAM Company Heating & A/C, Inc."
      },
      {
        "MarketerID": 254,
        "MarketerName": "Richards' Air Cond. Co., Inc."
      },
      {
        "MarketerID": 255,
        "MarketerName": "Service Specialties, Inc."
      },
      {
        "MarketerID": 256,
        "MarketerName": "Silver Spring A/C & Heating Co."
      },
      {
        "MarketerID": 257,
        "MarketerName": "David Snell & Son, Inc."
      },
      {
        "MarketerID": 259,
        "MarketerName": "Parrish Services"
      },
      {
        "MarketerID": 260,
        "MarketerName": "Aaron Gas Solutions"
      },
      {
        "MarketerID": 263,
        "MarketerName": "A-1 Heating & A/C"
      },
      {
        "MarketerID": 266,
        "MarketerName": "A-Annandale Plumbing"
      },
      {
        "MarketerID": 267,
        "MarketerName": "Air Distribution Co. Inc. (Adco)"
      },
      {
        "MarketerID": 268,
        "MarketerName": "Capitol Services Plumbing"
      },
      {
        "MarketerID": 270,
        "MarketerName": "C. L. Hibbard Plumbing"
      },
      {
        "MarketerID": 271,
        "MarketerName": "Wachter & Norwood"
      },
      {
        "MarketerID": 272,
        "MarketerName": "Sanford Kramer Plumbing & Heatin"
      },
      {
        "MarketerID": 273,
        "MarketerName": "Refrigeration Systems"
      },
      {
        "MarketerID": 274,
        "MarketerName": "Northern Virginia Heating"
      },
      {
        "MarketerID": 275,
        "MarketerName": "Nichols & Phipps Plumbing & Heat"
      },
      {
        "MarketerID": 276,
        "MarketerName": "McCarthy Heating and A/C"
      },
      {
        "MarketerID": 277,
        "MarketerName": "Leonard-Splaine Co, Inc."
      },
      {
        "MarketerID": 278,
        "MarketerName": "General Heating/ARS"
      },
      {
        "MarketerID": 279,
        "MarketerName": "Garneski Air Conditioning & Heat"
      },
      {
        "MarketerID": 280,
        "MarketerName": "Galaxy Heating & A/C"
      },
      {
        "MarketerID": 281,
        "MarketerName": "Climate Heating & Cooling"
      },
      {
        "MarketerID": 286,
        "MarketerName": "Mark's AC"
      },
      {
        "MarketerID": 305,
        "MarketerName": "D. H. Stevens, Inc."
      },
      {
        "MarketerID": 306,
        "MarketerName": "Trademasters Service Corp."
      },
      {
        "MarketerID": 307,
        "MarketerName": "Washington Enterprises1"
      },
      {
        "MarketerID": 308,
        "MarketerName": "Washington Enterprises"
      },
      {
        "MarketerID": 309,
        "MarketerName": "John G. Webster Company"
      },
      {
        "MarketerID": 310,
        "MarketerName": "James A. Wheat & Sons"
      },
      {
        "MarketerID": 311,
        "MarketerName": "Fry Plumbing and Heating Corp."
      },
      {
        "MarketerID": 312,
        "MarketerName": "Hawkins Plumbing"
      },
      {
        "MarketerID": 313,
        "MarketerName": "Krafft Air Conditioning Service "
      },
      {
        "MarketerID": 314,
        "MarketerName": "3-D Plumbing & Heating, Inc."
      },
      {
        "MarketerID": 315,
        "MarketerName": "A-Wayne's Heating and Cooling"
      },
      {
        "MarketerID": 316,
        "MarketerName": "Kensington Heating & Cooling"
      },
      {
        "MarketerID": 325,
        "MarketerName": "United Air Temp"
      },
      {
        "MarketerID": 326,
        "MarketerName": "Constellation New Energy"
      },
      {
        "MarketerID": 385,
        "MarketerName": "Home Air"
      },
      {
        "MarketerID": 433,
        "MarketerName": "Stehle Engineering Corp"
      },
      {
        "MarketerID": 434,
        "MarketerName": "Rodgers Consulting"
      },
      {
        "MarketerID": 435,
        "MarketerName": "Constellation Design Group, Inc"
      },
      {
        "MarketerID": 437,
        "MarketerName": "A. Morton Thomas and Associates"
      },
      {
        "MarketerID": 438,
        "MarketerName": "Inframap"
      },
      {
        "MarketerID": 439,
        "MarketerName": "Control Point Associates, Inc"
      },
      {
        "MarketerID": 440,
        "MarketerName": "Loiederman Soltesz Associates"
      },
      {
        "MarketerID": 445,
        "MarketerName": "Bolton-Latham,LLC."
      },
      {
        "MarketerID": 446,
        "MarketerName": "Macris,hendricks & Glascock P.A."
      },
      {
        "MarketerID": 447,
        "MarketerName": "The Wilson T. Ballard Company"
      },
      {
        "MarketerID": 465,
        "MarketerName": "R.C. Fields, Jr. & Associates"
      },
      {
        "MarketerID": 466,
        "MarketerName": "VIKA, Inc"
      },
      {
        "MarketerID": 467,
        "MarketerName": "Earth Tech, Inc."
      },
      {
        "MarketerID": 468,
        "MarketerName": "Christopher Consultants, Ltd"
      },
      {
        "MarketerID": 469,
        "MarketerName": "Mid-Atlantic Utility Locating "
      },
      {
        "MarketerID": 470,
        "MarketerName": "Washington Gas Co."
      },
      {
        "MarketerID": 471,
        "MarketerName": "Town of Leesburg, VA"
      },
      {
        "MarketerID": 485,
        "MarketerName": "CAS Engineering"
      },
      {
        "MarketerID": 486,
        "MarketerName": "VSA Construction Services, LLC"
      },
      {
        "MarketerID": 487,
        "MarketerName": "VIKA"
      },
      {
        "MarketerID": 488,
        "MarketerName": "Greenhorne & O'Mara, Inc."
      },
      {
        "MarketerID": 505,
        "MarketerName": "Patton, Harris, Rust & Associate"
      },
      {
        "MarketerID": 525,
        "MarketerName": "Baker and Associates"
      },
      {
        "MarketerID": 545,
        "MarketerName": "National Cable Construction, Inc"
      },
      {
        "MarketerID": 565,
        "MarketerName": "christopher consultants, ltd."
      },
      {
        "MarketerID": 566,
        "MarketerName": "century eng"
      },
      {
        "MarketerID": 567,
        "MarketerName": "Wiles Mensch Corporation"
      },
      {
        "MarketerID": 585,
        "MarketerName": "Rodger's consulting"
      },
      {
        "MarketerID": 586,
        "MarketerName": "RODGERS CONSULTING, INC."
      },
      {
        "MarketerID": 587,
        "MarketerName": "tbe group"
      },
      {
        "MarketerID": 588,
        "MarketerName": "Mercado Consultants, Inc."
      },
      {
        "MarketerID": 589,
        "MarketerName": "Control Point Associates, Inc."
      },
      {
        "MarketerID": 590,
        "MarketerName": "Bolton & Associates LLC"
      },
      {
        "MarketerID": 591,
        "MarketerName": "VIKA, Inc, Attn:Ms J.J. Mashburn"
      },
      {
        "MarketerID": 592,
        "MarketerName": "The Tech Group, Inc."
      },
      {
        "MarketerID": 593,
        "MarketerName": "the techgroup, inc"
      },
      {
        "MarketerID": 594,
        "MarketerName": "THE TECH GROUP, INC"
      },
      {
        "MarketerID": 595,
        "MarketerName": "Johnson, Mirmiran & Thompson"
      },
      {
        "MarketerID": 605,
        "MarketerName": "Cervantes & Associates, P.C."
      },
      {
        "MarketerID": 606,
        "MarketerName": "Wiley & Wilson, Inc."
      },
      {
        "MarketerID": 625,
        "MarketerName": "Fibernet Construction, LLC "
      },
      {
        "MarketerID": 626,
        "MarketerName": "PEPCO"
      },
      {
        "MarketerID": 645,
        "MarketerName": "Dewberry and Davis, LLC"
      },
      {
        "MarketerID": 646,
        "MarketerName": "Arlington County DES"
      },
      {
        "MarketerID": 665,
        "MarketerName": "Fairfax County, DPWES"
      },
      {
        "MarketerID": 685,
        "MarketerName": "Delon Hampton & Associates"
      },
      {
        "MarketerID": 705,
        "MarketerName": "So-Deep, Inc."
      },
      {
        "MarketerID": 725,
        "MarketerName": "So Deep Inc."
      },
      {
        "MarketerID": 726,
        "MarketerName": "So Deep, Inc."
      },
      {
        "MarketerID": 727,
        "MarketerName": "Whitney, Bailey, Cox & Magnani "
      },
      {
        "MarketerID": 745,
        "MarketerName": "Accurate Infrastructure Data Inc"
      },
      {
        "MarketerID": 765,
        "MarketerName": "Capitol Engineers, P.C."
      },
      {
        "MarketerID": 785,
        "MarketerName": "the Engineering Groupe, Inc."
      },
      {
        "MarketerID": 786,
        "MarketerName": "Maddox Engineers & Surveyors"
      },
      {
        "MarketerID": 787,
        "MarketerName": "dominion surveyors inc."
      },
      {
        "MarketerID": 788,
        "MarketerName": "EBA Engineering Inc."
      },
      {
        "MarketerID": 789,
        "MarketerName": "William H. Gordon Associates"
      },
      {
        "MarketerID": 790,
        "MarketerName": "VIKA, Incorporated"
      },
      {
        "MarketerID": 791,
        "MarketerName": "Legion Design/Campbell & Assoc."
      },
      {
        "MarketerID": 792,
        "MarketerName": "Design/Build Concepts, Ltd."
      },
      {
        "MarketerID": 805,
        "MarketerName": "Dewberry"
      },
      {
        "MarketerID": 825,
        "MarketerName": "KCI"
      },
      {
        "MarketerID": 826,
        "MarketerName": "KCW ENGINEERING TECHNOLOGIES,INC"
      },
      {
        "MarketerID": 827,
        "MarketerName": "kcw wngineering tec."
      },
      {
        "MarketerID": 828,
        "MarketerName": "FAIRFAX WATER"
      },
      {
        "MarketerID": 829,
        "MarketerName": "Adtek Engineers, Inc"
      },
      {
        "MarketerID": 830,
        "MarketerName": "fairfax county water"
      },
      {
        "MarketerID": 831,
        "MarketerName": "KCI Technologies, Inc."
      },
      {
        "MarketerID": 832,
        "MarketerName": "Landmark Engineering, Inc."
      },
      {
        "MarketerID": 833,
        "MarketerName": "Fairfax County Water Authority"
      },
      {
        "MarketerID": 834,
        "MarketerName": "Vika Inc."
      },
      {
        "MarketerID": 835,
        "MarketerName": "KCI Technologies"
      },
      {
        "MarketerID": 846,
        "MarketerName": "Loudoun County"
      },
      {
        "MarketerID": 866,
        "MarketerName": "Fairfax Water"
      },
      {
        "MarketerID": 886,
        "MarketerName": "Burgess & Niple"
      },
      {
        "MarketerID": 906,
        "MarketerName": "Gutschick, Little & Weber, PA"
      },
      {
        "MarketerID": 907,
        "MarketerName": "Dulles Transit Engineers, JV"
      },
      {
        "MarketerID": 908,
        "MarketerName": "Gutschick Little & Weber"
      },
      {
        "MarketerID": 910,
        "MarketerName": "Delon Hampton and Associates"
      },
      {
        "MarketerID": 926,
        "MarketerName": "Richter & Associates"
      },
      {
        "MarketerID": 946,
        "MarketerName": "Clark Pinnacle"
      },
      {
        "MarketerID": 947,
        "MarketerName": "JMT Engineering"
      },
      {
        "MarketerID": 949,
        "MarketerName": "Marlboro Engineering Cons., Inc."
      },
      {
        "MarketerID": 950,
        "MarketerName": "CAPITOL DEVELOPMENT DESIGN"
      },
      {
        "MarketerID": 951,
        "MarketerName": "Woolpert, Inc."
      },
      {
        "MarketerID": 952,
        "MarketerName": "Charles P. Johnson & Associates"
      },
      {
        "MarketerID": 953,
        "MarketerName": "Adtek Engineers, Inc."
      },
      {
        "MarketerID": 954,
        "MarketerName": "Land Design Consultants"
      },
      {
        "MarketerID": 967,
        "MarketerName": "Capitol Development Design Inc."
      },
      {
        "MarketerID": 968,
        "MarketerName": "Capitol Development Design, inc."
      },
      {
        "MarketerID": 969,
        "MarketerName": "ECC"
      },
      {
        "MarketerID": 970,
        "MarketerName": "Ben Dyer Associates, Inc."
      },
      {
        "MarketerID": 971,
        "MarketerName": "Clark Realty Capital, L.L.C."
      },
      {
        "MarketerID": 972,
        "MarketerName": "metcalf & eddy"
      },
      {
        "MarketerID": 987,
        "MarketerName": "C.C. Johnson & Malhotra, P.C."
      },
      {
        "MarketerID": 988,
        "MarketerName": "Infrasource(Mid Atlantic Pipelin"
      },
      {
        "MarketerID": 989,
        "MarketerName": "Rummel, Klepper & Kahl, LLP"
      },
      {
        "MarketerID": 990,
        "MarketerName": "PEPCO / Henkels & McCoy"
      },
      {
        "MarketerID": 1007,
        "MarketerName": "URS Corporation"
      },
      {
        "MarketerID": 1008,
        "MarketerName": "Patton Harris Rust & Associates"
      },
      {
        "MarketerID": 1009,
        "MarketerName": "Greenhorne & O'Mara"
      },
      {
        "MarketerID": 1010,
        "MarketerName": "BOWMAN CONSULTING"
      },
      {
        "MarketerID": 1027,
        "MarketerName": "Greenman-Pedersen, Inc."
      },
      {
        "MarketerID": 1028,
        "MarketerName": "DEWBERRY"
      },
      {
        "MarketerID": 1047,
        "MarketerName": "Pepco"
      },
      {
        "MarketerID": 1048,
        "MarketerName": "DCWASA"
      },
      {
        "MarketerID": 1049,
        "MarketerName": "D.C. Water & Sewer Authority"
      },
      {
        "MarketerID": 1050,
        "MarketerName": "DC WASA"
      },
      {
        "MarketerID": 1067,
        "MarketerName": "Water and Sewer Authority"
      },
      {
        "MarketerID": 1090,
        "MarketerName": "Capitol Recovery Services"
      },
      {
        "MarketerID": 1110,
        "MarketerName": "Morris & Ritchie Associates, Inc"
      },
      {
        "MarketerID": 1148,
        "MarketerName": "McKissack and Mckissack"
      },
      {
        "MarketerID": 1168,
        "MarketerName": "Greenhorne & O'Mara, Inc."
      },
      {
        "MarketerID": 1190,
        "MarketerName": "Greenhorne & O'Mara, Inc."
      },
      {
        "MarketerID": 1207,
        "MarketerName": "Adtek Engineers"
      },
      {
        "MarketerID": 1227,
        "MarketerName": "Huron Consulting"
      },
      {
        "MarketerID": 1228,
        "MarketerName": "Bolton and Associates, LLC"
      },
      {
        "MarketerID": 1229,
        "MarketerName": "Prince George's County, Maryland"
      },
      {
        "MarketerID": 1247,
        "MarketerName": "ADTEK"
      },
      {
        "MarketerID": 1267,
        "MarketerName": "Meridian Surveys"
      },
      {
        "MarketerID": 1268,
        "MarketerName": "Johnson Mirmiran and Thompson In"
      },
      {
        "MarketerID": 1269,
        "MarketerName": "Sheladia Associates Inc"
      },
      {
        "MarketerID": 1270,
        "MarketerName": "Washington Suburban Sanitary Commission"
      },
      {
        "MarketerID": 1271,
        "MarketerName": "WSSC"
      },
      {
        "MarketerID": 1288,
        "MarketerName": "Rinker Design Associates"
      },
      {
        "MarketerID": 1289,
        "MarketerName": "LR Engineering, LLC"
      },
      {
        "MarketerID": 1308,
        "MarketerName": "Michael Baker Jr"
      },
      {
        "MarketerID": 1309,
        "MarketerName": "Greenhorne & O'Mara, Inc."
      },
      {
        "MarketerID": 1368,
        "MarketerName": "Bromley's Utility Consulting Svc"
      },
      {
        "MarketerID": 1369,
        "MarketerName": "William H. Gordon Assoc., Inc."
      },
      {
        "MarketerID": 1391,
        "MarketerName": "URS Corp."
      },
      {
        "MarketerID": 1408,
        "MarketerName": "CLARK NEXSEN"
      },
      {
        "MarketerID": 1428,
        "MarketerName": "George Mason University"
      },
      {
        "MarketerID": 1429,
        "MarketerName": "Morris & Ritchie Associates"
      },
      {
        "MarketerID": 1448,
        "MarketerName": "AB Consultants Inc."
      },
      {
        "MarketerID": 1449,
        "MarketerName": "AECOM Technical Services, Inc"
      },
      {
        "MarketerID": 1488,
        "MarketerName": "Washington Suburban Sanit Comm"
      },
      {
        "MarketerID": 1508,
        "MarketerName": "AULtec Inc."
      },
      {
        "MarketerID": 1509,
        "MarketerName": "CH2M HILL INC"
      },
      {
        "MarketerID": 1510,
        "MarketerName": "BRUDIS AND ASSOCIATES INC."
      },
      {
        "MarketerID": 1528,
        "MarketerName": "Walter L. Phillips Inc."
      },
      {
        "MarketerID": 1548,
        "MarketerName": "A. Morton Thomas & Associates"
      },
      {
        "MarketerID": 1549,
        "MarketerName": "BURGESS & NIPLE, INC."
      },
      {
        "MarketerID": 1568,
        "MarketerName": "Paciulli, Simmons & Associates"
      },
      {
        "MarketerID": 1588,
        "MarketerName": "Precision Surveying and Consulti"
      },
      {
        "MarketerID": 1589,
        "MarketerName": "Volkert Engineering PC"
      },
      {
        "MarketerID": 1608,
        "MarketerName": "Naval Facilities"
      },
      {
        "MarketerID": 1628,
        "MarketerName": "West Consulting Group LLC"
      },
      {
        "MarketerID": 1629,
        "MarketerName": "USDA-10300 Baltimore Ave"
      },
      {
        "MarketerID": 1648,
        "MarketerName": "Urban Ltd."
      },
      {
        "MarketerID": 1668,
        "MarketerName": "PG Associates, Inc."
      },
      {
        "MarketerID": 1688,
        "MarketerName": "MONTGOMERY COUNTY, MARYLAND"
      },
      {
        "MarketerID": 1689,
        "MarketerName": "Montgomery County Government"
      },
      {
        "MarketerID": 1708,
        "MarketerName": "Metropolitan Comm. Group"
      },
      {
        "MarketerID": 1748,
        "MarketerName": "michael belisle design"
      },
      {
        "MarketerID": 1768,
        "MarketerName": "Charles P.Johnson & Assoc."
      },
      {
        "MarketerID": 1808,
        "MarketerName": "MACRIS, HENDRICKS & GLASCOCK, P."
      },
      {
        "MarketerID": 1828,
        "MarketerName": "William H. Gordon Associates, In"
      },
      {
        "MarketerID": 1849,
        "MarketerName": "Maddox Engineers and Surveyors"
      },
      {
        "MarketerID": 1868,
        "MarketerName": "William H Gordon Associates"
      },
      {
        "MarketerID": 1888,
        "MarketerName": "PHRA "
      },
      {
        "MarketerID": 1908,
        "MarketerName": "utility locating service inc"
      },
      {
        "MarketerID": 1910,
        "MarketerName": "Bowman"
      },
      {
        "MarketerID": 1928,
        "MarketerName": "Qwest Government Services, Inc."
      },
      {
        "MarketerID": 1929,
        "MarketerName": "HNTB"
      },
      {
        "MarketerID": 1948,
        "MarketerName": "Landesign, Inc."
      },
      {
        "MarketerID": 1968,
        "MarketerName": "Montgomery County"
      },
      {
        "MarketerID": 1988,
        "MarketerName": "Tenacity Group"
      },
      {
        "MarketerID": 1989,
        "MarketerName": "FBRC, LLC"
      },
      {
        "MarketerID": 2008,
        "MarketerName": "damian@utilitysystems.com"
      },
      {
        "MarketerID": 2029,
        "MarketerName": "Daniel Consultants, Inc"
      },
      {
        "MarketerID": 2048,
        "MarketerName": "Patton, Harris, Rust & Assoc, pc"
      },
      {
        "MarketerID": 2068,
        "MarketerName": "Michael Baker Jr., Inc."
      },
      {
        "MarketerID": 2088,
        "MarketerName": "B. Frank Joy, LLC"
      },
      {
        "MarketerID": 2108,
        "MarketerName": "Gulick Group Land Resources"
      },
      {
        "MarketerID": 2128,
        "MarketerName": "Shell Energy"
      },
      {
        "MarketerID": 2208,
        "MarketerName": "Precision Systems, Inc"
      },
      {
        "MarketerID": 2228,
        "MarketerName": "ADTEK ENGINEERS"
      },
      {
        "MarketerID": 2248,
        "MarketerName": "Associates Plumbing, Inc."
      },
      {
        "MarketerID": 2249,
        "MarketerName": "Dewberry & Davis "
      },
      {
        "MarketerID": 2268,
        "MarketerName": "Woolpert"
      },
      {
        "MarketerID": 2288,
        "MarketerName": "Bernard F. Locraft Civil Engineers"
      },
      {
        "MarketerID": 2308,
        "MarketerName": "drs development, llc"
      },
      {
        "MarketerID": 2348,
        "MarketerName": "Wallace Montgomery"
      },
      {
        "MarketerID": 2368,
        "MarketerName": "Taylor Wiseman Taylor"
      },
      {
        "MarketerID": 2431,
        "MarketerName": "Utility Professional Services In"
      },
      {
        "MarketerID": 2443,
        "MarketerName": "CDM"
      },
      {
        "MarketerID": 2446,
        "MarketerName": "Macris Hendricks and Glascock P."
      },
      {
        "MarketerID": 2468,
        "MarketerName": "Berman Enterprises, LP"
      },
      {
        "MarketerID": 2477,
        "MarketerName": "O Brien and Gere Engineers Inc"
      },
      {
        "MarketerID": 2535,
        "MarketerName": "Bohler Engineering"
      },
      {
        "MarketerID": 2584,
        "MarketerName": "O'Brien and Gere"
      },
      {
        "MarketerID": 2594,
        "MarketerName": "Washington Gas"
      },
      {
        "MarketerID": 2652,
        "MarketerName": "macris,hendricks & glascock, p.a"
      },
      {
        "MarketerID": 2726,
        "MarketerName": "Baltimore Gas & Electric"
      },
      {
        "MarketerID": 2776,
        "MarketerName": "Engineering and Environment Inc."
      },
      {
        "MarketerID": 3019,
        "MarketerName": "Trammell Crow Company"
      },
      {
        "MarketerID": 3020,
        "MarketerName": "Joe Jackson Associates, P.C."
      },
      {
        "MarketerID": 3023,
        "MarketerName": "Rummel Klepper and Kahl LLP"
      },
      {
        "MarketerID": 3029,
        "MarketerName": "Rummel, Klepper & Khal,LLP"
      },
      {
        "MarketerID": 3030,
        "MarketerName": "George Mason University"
      },
      {
        "MarketerID": 3068,
        "MarketerName": "Stantec"
      },
      {
        "MarketerID": 3079,
        "MarketerName": "Rummel, Klepper & Kahl"
      },
      {
        "MarketerID": 3084,
        "MarketerName": "Greenhorne & O'Mara, Inc."
      },
      {
        "MarketerID": 3085,
        "MarketerName": "Greenhorne & O 'Mara"
      },
      {
        "MarketerID": 3088,
        "MarketerName": "Alexandria Surveys"
      },
      {
        "MarketerID": 3155,
        "MarketerName": "A. Morton Thomas and Associates"
      },
      {
        "MarketerID": 3170,
        "MarketerName": "Georgetown University"
      },
      {
        "MarketerID": 3284,
        "MarketerName": "Tri Tek Engineering"
      },
      {
        "MarketerID": 3381,
        "MarketerName": "Applied Civil Engineering"
      },
      {
        "MarketerID": 3389,
        "MarketerName": "Joyce Engineering Corporation"
      },
      {
        "MarketerID": 3397,
        "MarketerName": "Accumark, Inc."
      },
      {
        "MarketerID": 3521,
        "MarketerName": "JAS Engineering & Design, LLC"
      },
      {
        "MarketerID": 3695,
        "MarketerName": "Prince William County"
      },
      {
        "MarketerID": 3730,
        "MarketerName": "Vogel Engineering +Timmons Group"
      },
      {
        "MarketerID": 3804,
        "MarketerName": "Greenhorne & O'mara"
      },
      {
        "MarketerID": 4035,
        "MarketerName": "Archibuild"
      },
      {
        "MarketerID": 4287,
        "MarketerName": "AB CONSULTANTS, INC."
      },
      {
        "MarketerID": 4291,
        "MarketerName": "Baltimore Gas and Electric"
      },
      {
        "MarketerID": 4292,
        "MarketerName": "BGE"
      },
      {
        "MarketerID": 4552,
        "MarketerName": "RK&K Consulting Engineers, LLP "
      },
      {
        "MarketerID": 4693,
        "MarketerName": "KCW Engineering Technologies"
      },
      {
        "MarketerID": 4719,
        "MarketerName": "BC Consultants, Inc."
      },
      {
        "MarketerID": 4744,
        "MarketerName": "Utilities Search Inc"
      },
      {
        "MarketerID": 4780,
        "MarketerName": "PHR+A"
      },
      {
        "MarketerID": 5080,
        "MarketerName": "Wallace, Montgomery & Associates"
      },
      {
        "MarketerID": 5140,
        "MarketerName": "Pepco"
      },
      {
        "MarketerID": 5444,
        "MarketerName": "Wallace, Montgomery & Assoc."
      },
      {
        "MarketerID": 5560,
        "MarketerName": "NAI The Michael Companies"
      },
      {
        "MarketerID": 5701,
        "MarketerName": "Dominion Surveyors"
      },
      {
        "MarketerID": 5739,
        "MarketerName": "Michael Baker Jr., Inc"
      },
      {
        "MarketerID": 5904,
        "MarketerName": "WRA"
      },
      {
        "MarketerID": 6024,
        "MarketerName": "Dewberry & Davis LLC"
      },
      {
        "MarketerID": 6398,
        "MarketerName": "O'Connell & Lawrence, Inc."
      },
      {
        "MarketerID": 6424,
        "MarketerName": "O'Connell & Lawrence, Inc."
      },
      {
        "MarketerID": 6684,
        "MarketerName": "Jefferson Builders, Inc."
      },
      {
        "MarketerID": 6945,
        "MarketerName": "CDDI LLC"
      },
      {
        "MarketerID": 7047,
        "MarketerName": "Montgomery County MD"
      },
      {
        "MarketerID": 7206,
        "MarketerName": "Capitol Development Design Inc."
      },
      {
        "MarketerID": 7371,
        "MarketerName": "National Park Service"
      },
      {
        "MarketerID": 7460,
        "MarketerName": "Whitney Bailey Cox & Magnani,LLC"
      },
      {
        "MarketerID": 7477,
        "MarketerName": "Patton, Harris, Rust & Assoc"
      },
      {
        "MarketerID": 7485,
        "MarketerName": "PATTON HARRIS RUST + ASS"
      },
      {
        "MarketerID": 7531,
        "MarketerName": "CDDI, LLC"
      },
      {
        "MarketerID": 7931,
        "MarketerName": "Architectural Solutions LLC"
      },
      {
        "MarketerID": 8186,
        "MarketerName": "M-NCPPC"
      },
      {
        "MarketerID": 8366,
        "MarketerName": "Charles P. Johnson &amp; Associates"
      },
      {
        "MarketerID": 8509,
        "MarketerName": "DMJMHarris"
      },
      {
        "MarketerID": 8707,
        "MarketerName": "Soltesz"
      },
      {
        "MarketerID": 8887,
        "MarketerName": "Huntley, Nyce & Associates"
      },
      {
        "MarketerID": 8927,
        "MarketerName": "Greenhorne & O'Mara"
      },
      {
        "MarketerID": 9088,
        "MarketerName": "Loiederman Soltesz Associates"
      },
      {
        "MarketerID": 9128,
        "MarketerName": "Bowman Consulting Group, Ltd."
      },
      {
        "MarketerID": 9150,
        "MarketerName": "RJM Engineering"
      },
      {
        "MarketerID": 9186,
        "MarketerName": "huntley nyce"
      },
      {
        "MarketerID": 9228,
        "MarketerName": "Greenhorne & O'mara"
      },
      {
        "MarketerID": 9372,
        "MarketerName": "John E. Harms, Jr. & Associates"
      },
      {
        "MarketerID": 9387,
        "MarketerName": "ESE Consultants (Toll Brothers)"
      },
      {
        "MarketerID": 9728,
        "MarketerName": "Inframap Corp"
      },
      {
        "MarketerID": 10028,
        "MarketerName": "Parsons Brinckerhoff"
      },
      {
        "MarketerID": 10606,
        "MarketerName": "CDDI"
      },
      {
        "MarketerID": 10806,
        "MarketerName": "Whitman, Requardt & Associates"
      },
      {
        "MarketerID": 10827,
        "MarketerName": "NDEC Corp."
      },
      {
        "MarketerID": 10909,
        "MarketerName": "Huntley, Nyce & Associates, Ltd"
      },
      {
        "MarketerID": 11491,
        "MarketerName": "Dominion Energy"
      },
      {
        "MarketerID": 11649,
        "MarketerName": "KCW ENGINEERING TECH INC."
      },
      {
        "MarketerID": 11670,
        "MarketerName": "Utility Consultants, Inc."
      },
      {
        "MarketerID": 13289,
        "MarketerName": "GREENHORNE AND O'MARA"
      },
      {
        "MarketerID": 14050,
        "MarketerName": "AIDATA Inc"
      },
      {
        "MarketerID": 15037,
        "MarketerName": "PEPCO"
      },
      {
        "MarketerID": 16273,
        "MarketerName": "AMT LLC"
      },
      {
        "MarketerID": 16751,
        "MarketerName": "McCrone Inc."
      },
      {
        "MarketerID": 16869,
        "MarketerName": "WSSC"
      },
      {
        "MarketerID": 17630,
        "MarketerName": "FirstData/Remitco"
      },
      {
        "MarketerID": 17649,
        "MarketerName": "Nolan Associates, Inc."
      },
      {
        "MarketerID": 17771,
        "MarketerName": "Site Solutions Inc"
      },
      {
        "MarketerID": 17870,
        "MarketerName": "Minkoff Development Corporation"
      },
      {
        "MarketerID": 17909,
        "MarketerName": "LSA"
      },
      {
        "MarketerID": 18150,
        "MarketerName": "RDA Engineers Inc."
      },
      {
        "MarketerID": 18190,
        "MarketerName": "Utility Sytems C&E, LLC"
      },
      {
        "MarketerID": 18209,
        "MarketerName": "Bowman Consulting"
      },
      {
        "MarketerID": 18389,
        "MarketerName": "WASHINGTON GAS"
      },
      {
        "MarketerID": 18609,
        "MarketerName": "City of Rockville"
      },
      {
        "MarketerID": 18873,
        "MarketerName": "JACOBS ENGINEERING GROUP"
      },
      {
        "MarketerID": 19931,
        "MarketerName": "Stand Energy 2"
      },
      {
        "MarketerID": 20013,
        "MarketerName": "A. Morton Thomas and Assoc,, Inc"
      },
      {
        "MarketerID": 20377,
        "MarketerName": "Arlington County Government"
      },
      {
        "MarketerID": 20451,
        "MarketerName": "Danella Engineering & Const."
      },
      {
        "MarketerID": 20629,
        "MarketerName": "Solar Energy Design, Inc."
      },
      {
        "MarketerID": 21131,
        "MarketerName": "Capitol Engineers, PC"
      },
      {
        "MarketerID": 21249,
        "MarketerName": "Chester Engineers"
      },
      {
        "MarketerID": 21631,
        "MarketerName": "Dewberry and Davis LLC"
      },
      {
        "MarketerID": 21694,
        "MarketerName": "JA Underground"
      },
      {
        "MarketerID": 21871,
        "MarketerName": "Edwards Utility Mapping"
      },
      {
        "MarketerID": 22849,
        "MarketerName": "M-NCPPC"
      },
      {
        "MarketerID": 23289,
        "MarketerName": "Oyster Imus Petzold and Assoc"
      },
      {
        "MarketerID": 23450,
        "MarketerName": "Axiom Engineering Design"
      },
      {
        "MarketerID": 23810,
        "MarketerName": "Loudoun Water"
      },
      {
        "MarketerID": 24430,
        "MarketerName": "MEX-EC LLC"
      },
      {
        "MarketerID": 24649,
        "MarketerName": "US Dept. of Agriculture"
      },
      {
        "MarketerID": 25331,
        "MarketerName": "PHRA"
      },
      {
        "MarketerID": 25689,
        "MarketerName": "West Group Properties LLC"
      },
      {
        "MarketerID": 25751,
        "MarketerName": "Brudis and Associates"
      },
      {
        "MarketerID": 25789,
        "MarketerName": "Toole Design Group"
      },
      {
        "MarketerID": 27253,
        "MarketerName": "Wheaton Vol. Rescue Squad"
      },
      {
        "MarketerID": 27293,
        "MarketerName": "MCG Utilities"
      },
      {
        "MarketerID": 27913,
        "MarketerName": "Charles P. Johnson & Assoc. Inc."
      },
      {
        "MarketerID": 28112,
        "MarketerName": "O'Brien & Gere"
      },
      {
        "MarketerID": 28219,
        "MarketerName": "O'Brien & Gere"
      },
      {
        "MarketerID": 28492,
        "MarketerName": "O'Brien & Gere"
      },
      {
        "MarketerID": 28674,
        "MarketerName": "Oyster Imus Petzold and Associat"
      },
      {
        "MarketerID": 30534,
        "MarketerName": "Accumark Inc"
      },
      {
        "MarketerID": 30575,
        "MarketerName": "Arlington County Gov't"
      },
      {
        "MarketerID": 31318,
        "MarketerName": "Alpha Corporation"
      },
      {
        "MarketerID": 32114,
        "MarketerName": "Benning & Associates, Inc."
      },
      {
        "MarketerID": 32258,
        "MarketerName": "Rajan Mahima Associates"
      },
      {
        "MarketerID": 32594,
        "MarketerName": "Urban, Ltd."
      },
      {
        "MarketerID": 33115,
        "MarketerName": "Dewberry Engineers Inc "
      },
      {
        "MarketerID": 34340,
        "MarketerName": "1218 T Street NW"
      },
      {
        "MarketerID": 34594,
        "MarketerName": "Landesign"
      },
      {
        "MarketerID": 35974,
        "MarketerName": "Pennoni Associates Inc."
      },
      {
        "MarketerID": 36415,
        "MarketerName": "Georgetown"
      },
      {
        "MarketerID": 36594,
        "MarketerName": "Lanier Poppe Engineering"
      },
      {
        "MarketerID": 37217,
        "MarketerName": "Pepco"
      },
      {
        "MarketerID": 37234,
        "MarketerName": "Washington Suburban Sanitary Com"
      },
      {
        "MarketerID": 37515,
        "MarketerName": "bowman condulting group"
      },
      {
        "MarketerID": 37714,
        "MarketerName": "Nat'l Capital Planning Commissio"
      },
      {
        "MarketerID": 37895,
        "MarketerName": "Pepco Government Services LLC"
      },
      {
        "MarketerID": 38158,
        "MarketerName": "Greenhorne & O'Mara, Inc."
      },
      {
        "MarketerID": 38354,
        "MarketerName": "Greenhorne and O'Mara, Inc."
      },
      {
        "MarketerID": 38475,
        "MarketerName": "Whitman Requardt and Associates "
      },
      {
        "MarketerID": 38914,
        "MarketerName": "William H. Gordon Associates,Inc"
      },
      {
        "MarketerID": 39455,
        "MarketerName": "Legion Design"
      },
      {
        "MarketerID": 39655,
        "MarketerName": "Dewberry "
      },
      {
        "MarketerID": 40354,
        "MarketerName": "Whitman Requardt & Associates"
      },
      {
        "MarketerID": 40455,
        "MarketerName": "W.S.S.C."
      },
      {
        "MarketerID": 40662,
        "MarketerName": "PULS "
      },
      {
        "MarketerID": 40917,
        "MarketerName": "VHB"
      },
      {
        "MarketerID": 41215,
        "MarketerName": "Johnson Bernat Associates"
      },
      {
        "MarketerID": 42235,
        "MarketerName": "Wiley|Wilson"
      },
      {
        "MarketerID": 42874,
        "MarketerName": "Dewberry & Davis"
      },
      {
        "MarketerID": 42936,
        "MarketerName": "UDR, INC."
      },
      {
        "MarketerID": 42983,
        "MarketerName": "CHA Inc. (Pepco Contractor)"
      },
      {
        "MarketerID": 43174,
        "MarketerName": "KCI Management"
      },
      {
        "MarketerID": 43635,
        "MarketerName": "VIKA Capitol, LLC"
      },
      {
        "MarketerID": 44138,
        "MarketerName": "STV Incorporated"
      },
      {
        "MarketerID": 44274,
        "MarketerName": "RK&K"
      },
      {
        "MarketerID": 44358,
        "MarketerName": "Pepco Holdings, Inc. (PHI)"
      },
      {
        "MarketerID": 44454,
        "MarketerName": "A Advantage Heating & A/C"
      },
      {
        "MarketerID": 44495,
        "MarketerName": "CountrySide Surveys"
      },
      {
        "MarketerID": 44555,
        "MarketerName": "UDR"
      },
      {
        "MarketerID": 45176,
        "MarketerName": "Pepco"
      },
      {
        "MarketerID": 45238,
        "MarketerName": "Black & Veatch"
      },
      {
        "MarketerID": 45834,
        "MarketerName": "Ben Dyer Associates"
      },
      {
        "MarketerID": 46055,
        "MarketerName": "Ayers Saint Gross"
      },
      {
        "MarketerID": 46395,
        "MarketerName": "CDI Properties, LLC"
      },
      {
        "MarketerID": 47274,
        "MarketerName": "Jacobs"
      },
      {
        "MarketerID": 47275,
        "MarketerName": "Gannett Fleming Inc"
      },
      {
        "MarketerID": 48059,
        "MarketerName": "DC Water"
      },
      {
        "MarketerID": 48214,
        "MarketerName": "Landmark Engineering"
      },
      {
        "MarketerID": 49514,
        "MarketerName": "AB CONSULTANTS INC."
      },
      {
        "MarketerID": 49554,
        "MarketerName": "Gutschick, Little & Weber, P.A."
      },
      {
        "MarketerID": 49974,
        "MarketerName": "Government Services IPT"
      },
      {
        "MarketerID": 50134,
        "MarketerName": "Greenhorne & O'Mara"
      },
      {
        "MarketerID": 50255,
        "MarketerName": "Greenhorne & O'Mara, Inc."
      },
      {
        "MarketerID": 50855,
        "MarketerName": "TRC Solutions"
      },
      {
        "MarketerID": 50935,
        "MarketerName": "Utility Professional Services"
      },
      {
        "MarketerID": 51954,
        "MarketerName": "Sabra, Wang and Associates, Inc."
      },
      {
        "MarketerID": 53256,
        "MarketerName": "Snider and Associates"
      },
      {
        "MarketerID": 53295,
        "MarketerName": "Potomac Valley Surveys"
      },
      {
        "MarketerID": 53614,
        "MarketerName": "DAJANI, LLC"
      },
      {
        "MarketerID": 54634,
        "MarketerName": "Voyten And Associates, Inc."
      },
      {
        "MarketerID": 55034,
        "MarketerName": "US Army"
      },
      {
        "MarketerID": 55514,
        "MarketerName": "DC Water"
      },
      {
        "MarketerID": 55635,
        "MarketerName": "Indra Energy - MD - 119"
      },
      {
        "MarketerID": 55636,
        "MarketerName": "Smart One Energy"
      },
      {
        "MarketerID": 55638,
        "MarketerName": "Maryland Gas and Electric"
      },
      {
        "MarketerID": 55654,
        "MarketerName": "Meridian Surveys"
      },
      {
        "MarketerID": 56174,
        "MarketerName": "Rinker Design Associates"
      },
      {
        "MarketerID": 58038,
        "MarketerName": "EnerNoc"
      },
      {
        "MarketerID": 58395,
        "MarketerName": "CHACONSULTING"
      },
      {
        "MarketerID": 60034,
        "MarketerName": "RDA"
      },
      {
        "MarketerID": 62435,
        "MarketerName": "None"
      },
      {
        "MarketerID": 62437,
        "MarketerName": "Dewberry"
      },
      {
        "MarketerID": 63278,
        "MarketerName": "AMEC"
      },
      {
        "MarketerID": 64356,
        "MarketerName": "Gannett Fleming"
      },
      {
        "MarketerID": 64494,
        "MarketerName": "DCWATER"
      },
      {
        "MarketerID": 64598,
        "MarketerName": "DC Water"
      },
      {
        "MarketerID": 64814,
        "MarketerName": "Greenhorne & O'Mara, Inc."
      },
      {
        "MarketerID": 65135,
        "MarketerName": "Constellation New Energy 2"
      },
      {
        "MarketerID": 66794,
        "MarketerName": "ECS Mid-Atlantic, LLC"
      },
      {
        "MarketerID": 67394,
        "MarketerName": "TRC Solution"
      },
      {
        "MarketerID": 68494,
        "MarketerName": "Greenhorne & O'Mara, Inc."
      },
      {
        "MarketerID": 68495,
        "MarketerName": "GHD Inc"
      },
      {
        "MarketerID": 69194,
        "MarketerName": "Visnic Homes, Inc."
      },
      {
        "MarketerID": 69514,
        "MarketerName": "Rice Associates Inc."
      },
      {
        "MarketerID": 70434,
        "MarketerName": "Xoom Energy Maryland"
      },
      {
        "MarketerID": 70454,
        "MarketerName": "World Energy"
      },
      {
        "MarketerID": 70494,
        "MarketerName": "Greeley and Hansen"
      },
      {
        "MarketerID": 70677,
        "MarketerName": "Forest Glen Annex "
      },
      {
        "MarketerID": 70695,
        "MarketerName": "Forest Glen Annex"
      },
      {
        "MarketerID": 71014,
        "MarketerName": "Advisors LLC"
      },
      {
        "MarketerID": 71655,
        "MarketerName": "McKissack &McKissack Inc"
      },
      {
        "MarketerID": 71895,
        "MarketerName": "McKissack and McKissack Inc"
      },
      {
        "MarketerID": 72179,
        "MarketerName": "Insight Property Group"
      },
      {
        "MarketerID": 72875,
        "MarketerName": "Energy Plus Natural Gas LLC"
      },
      {
        "MarketerID": 73396,
        "MarketerName": "AMT LLC"
      },
      {
        "MarketerID": 73914,
        "MarketerName": "Deca Energy"
      },
      {
        "MarketerID": 73915,
        "MarketerName": "Ambit Energy"
      },
      {
        "MarketerID": 74174,
        "MarketerName": "CNA, LLC"
      },
      {
        "MarketerID": 74355,
        "MarketerName": "Sabra, Wang, & Associates, Inc."
      },
      {
        "MarketerID": 74714,
        "MarketerName": "Georgetown University"
      },
      {
        "MarketerID": 75394,
        "MarketerName": "Utility Profrssional Services, I"
      },
      {
        "MarketerID": 75576,
        "MarketerName": "Kibart, Inc."
      },
      {
        "MarketerID": 76734,
        "MarketerName": "IGS Energy - MD - 128"
      },
      {
        "MarketerID": 77554,
        "MarketerName": "The Engineering Groupe"
      },
      {
        "MarketerID": 77755,
        "MarketerName": "O'Brien & Gere"
      },
      {
        "MarketerID": 77834,
        "MarketerName": "O'Brien & Gere"
      },
      {
        "MarketerID": 78514,
        "MarketerName": "Parsons Brinckerhoff, INC"
      },
      {
        "MarketerID": 79099,
        "MarketerName": "HNTB"
      },
      {
        "MarketerID": 80065,
        "MarketerName": "TRC Solutions"
      },
      {
        "MarketerID": 82856,
        "MarketerName": "AB Consultants Inc"
      },
      {
        "MarketerID": 82859,
        "MarketerName": "CAS Engineering, Inc"
      },
      {
        "MarketerID": 85337,
        "MarketerName": "Langan Engineering and Environme"
      },
      {
        "MarketerID": 85400,
        "MarketerName": "Dewberry Consultants LLC"
      },
      {
        "MarketerID": 88794,
        "MarketerName": "Georgetown University-PFM"
      },
      {
        "MarketerID": 89135,
        "MarketerName": "Engie Power & Gas - 135"
      },
      {
        "MarketerID": 89194,
        "MarketerName": "Langan Engineering"
      },
      {
        "MarketerID": 89534,
        "MarketerName": "Langan Engineering & Environment"
      },
      {
        "MarketerID": 90154,
        "MarketerName": "A. Morton Thomas"
      },
      {
        "MarketerID": 90454,
        "MarketerName": "Witmer Associates LLC"
      },
      {
        "MarketerID": 90954,
        "MarketerName": "Constellation Energy Gas Choice"
      },
      {
        "MarketerID": 90976,
        "MarketerName": "Kim Engineering"
      },
      {
        "MarketerID": 91974,
        "MarketerName": "CAD-CON Consulting Inc"
      },
      {
        "MarketerID": 93354,
        "MarketerName": "AMT, LLC"
      },
      {
        "MarketerID": 95454,
        "MarketerName": "TRC Solution"
      },
      {
        "MarketerID": 99461,
        "MarketerName": "CHA Consulting, Inc"
      },
      {
        "MarketerID": 100535,
        "MarketerName": "Viridian Energy"
      },
      {
        "MarketerID": 100554,
        "MarketerName": "Xoom Energy"
      },
      {
        "MarketerID": 100895,
        "MarketerName": "Insight, LLC"
      },
      {
        "MarketerID": 100914,
        "MarketerName": "NRG Business Market,LLC - 145"
      },
      {
        "MarketerID": 101516,
        "MarketerName": "McIlvried DiDiano & Mox LLC"
      },
      {
        "MarketerID": 103174,
        "MarketerName": "Engie Power & Gas - 144"
      },
      {
        "MarketerID": 104474,
        "MarketerName": "Stand Energy UCB RR"
      },
      {
        "MarketerID": 104756,
        "MarketerName": "Insight LLC"
      },
      {
        "MarketerID": 105614,
        "MarketerName": "Triad Engineering"
      },
      {
        "MarketerID": 105679,
        "MarketerName": "Triad Engineering"
      },
      {
        "MarketerID": 105682,
        "MarketerName": "Wiley Wilson"
      },
      {
        "MarketerID": 106114,
        "MarketerName": "EBA Engineering "
      },
      {
        "MarketerID": 106655,
        "MarketerName": "EBA Engineering"
      },
      {
        "MarketerID": 108496,
        "MarketerName": "Utility Professional Services, I"
      },
      {
        "MarketerID": 108594,
        "MarketerName": "Utility Professional Services "
      },
      {
        "MarketerID": 109494,
        "MarketerName": "ab consultants"
      },
      {
        "MarketerID": 119354,
        "MarketerName": "Insight"
      },
      {
        "MarketerID": 120394,
        "MarketerName": "Louis Berger Group"
      },
      {
        "MarketerID": 121234,
        "MarketerName": "Dacca, Inc."
      },
      {
        "MarketerID": 122074,
        "MarketerName": "Louis Berger Water Services Inc"
      },
      {
        "MarketerID": 122214,
        "MarketerName": "Enspire Energy"
      },
      {
        "MarketerID": 123275,
        "MarketerName": "CEGC"
      },
      {
        "MarketerID": 124754,
        "MarketerName": "JJB DC Inc."
      },
      {
        "MarketerID": 126195,
        "MarketerName": "WGL Energy customer care center"
      },
      {
        "MarketerID": 127554,
        "MarketerName": "Burns & McDonnell"
      },
      {
        "MarketerID": 128254,
        "MarketerName": "USA Groups"
      },
      {
        "MarketerID": 136034,
        "MarketerName": "Direct Energy Services,LLC-156"
      },
      {
        "MarketerID": 142214,
        "MarketerName": "SFE Energy"
      },
      {
        "MarketerID": 142215,
        "MarketerName": "AGERA Energy - 159"
      },
      {
        "MarketerID": 142216,
        "MarketerName": "AGERA Energy - 160"
      },
      {
        "MarketerID": 142815,
        "MarketerName": "Department of Energy & Environment (DOEE)"
      },
      {
        "MarketerID": 142816,
        "MarketerName": "Office of Home Energy Programs (OHEP)"
      },
      {
        "MarketerID": 142817,
        "MarketerName": "Montgomery County Social Services"
      },
      {
        "MarketerID": 142818,
        "MarketerName": "Prince Georges County Social Services"
      },
      {
        "MarketerID": 142819,
        "MarketerName": "Saint Mary's County Social Services"
      },
      {
        "MarketerID": 142820,
        "MarketerName": "Frederick County Department of Social Services"
      },
      {
        "MarketerID": 142821,
        "MarketerName": "Calvert County Social Services"
      },
      {
        "MarketerID": 142822,
        "MarketerName": "Charles County Social Services"
      },
      {
        "MarketerID": 142823,
        "MarketerName": "Virginia Department of Social Services (VDSS)"
      },
      {
        "MarketerID": 142824,
        "MarketerName": "Fairfax County Social Services"
      },
      {
        "MarketerID": 142825,
        "MarketerName": "Prince William County Social Services"
      },
      {
        "MarketerID": 142826,
        "MarketerName": "Alexandria Division of Human Services"
      },
      {
        "MarketerID": 142827,
        "MarketerName": "Winchester Department of Social Services"
      },
      {
        "MarketerID": 142828,
        "MarketerName": "Shenandoah Department of Social Services"
      },
      {
        "MarketerID": 142829,
        "MarketerName": "Arlington County Social Services"
      },
      {
        "MarketerID": 142830,
        "MarketerName": "Loudoun County Department of Family Services"
      },
      {
        "MarketerID": 142831,
        "MarketerName": "Salvation Army"
      },
      {
        "MarketerID": 142832,
        "MarketerName": "Saint Vincent de Paul  Society"
      },
      {
        "MarketerID": 142833,
        "MarketerName": "Catholic Charities"
      },
      {
        "MarketerID": 142834,
        "MarketerName": "Luthern Social Services"
      },
      {
        "MarketerID": 142876,
        "MarketerName": "NOVEC Energy Solutions – 164"
      },
      {
        "MarketerID": 142895,
        "MarketerName": "Dominion Energy Solutions - 150"
      },
      {
        "MarketerID": 142909,
        "MarketerName": "MAJOR Energy"
      },
      {
        "MarketerID": 142922,
        "MarketerName": "NRG Home"
      },
      {
        "MarketerID": 142936,
        "MarketerName": "Mansfield Power and Gas LLC"
      },
      {
        "MarketerID": 142939,
        "MarketerName": "Just Energy"
      },
      {
        "MarketerID": 142941,
        "MarketerName": "Shipley Energy"
      },
      {
        "MarketerID": 142942,
        "MarketerName": "Planet Energy"
      },
      {
        "MarketerID": 142943,
        "MarketerName": "Spring Power & Gas"
      },
      {
        "MarketerID": 142944,
        "MarketerName": "Twin Eagle Energy"
      },
      {
        "MarketerID": 142968,
        "MarketerName": "Indra Energy - DC - 169"
      },
      {
        "MarketerID": 142969,
        "MarketerName": "Indra Energy - VA - 170"
      },
      {
        "MarketerID": 142983,
        "MarketerName": "Viridian Energy DUAL"
      },
      {
        "MarketerID": 142984,
        "MarketerName": "Viridian Energy UCB BR"
      },
      {
        "MarketerID": 142985,
        "MarketerName": "Engie Power & Gas - 173"
      },
      {
        "MarketerID": 142991,
        "MarketerName": "IDT Energy"
      },
      {
        "MarketerID": 142992,
        "MarketerName": "MPower Energy NJ LLC"
      },
      {
        "MarketerID": 142993,
        "MarketerName": "PESCO Energy - 175"
      },
      {
        "MarketerID": 142994,
        "MarketerName": "PESCO Energy - 176"
      },
      {
        "MarketerID": 142995,
        "MarketerName": "Think Energy"
      },
      {
        "MarketerID": 142996,
        "MarketerName": "Virginia Retail Energy - 178"
      },
      {
        "MarketerID": 142997,
        "MarketerName": "Virginia Retail Energy - 179"
      },
      {
        "MarketerID": 142998,
        "MarketerName": "Stand Energy - 180"
      },
      {
        "MarketerID": 142999,
        "MarketerName": "Stand Energy - 181"
      },
      {
        "MarketerID": 143009,
        "MarketerName": "Clearview Energy"
      },
      {
        "MarketerID": 143010,
        "MarketerName": "South Jersey Energy Corp - 184"
      },
      {
        "MarketerID": 143011,
        "MarketerName": "South Jersey Energy Corp - 185"
      },
      {
        "MarketerID": 143012,
        "MarketerName": "Indra Energy - MD - 186"
      },
      {
        "MarketerID": 143013,
        "MarketerName": "Tomorrow Energy Corp"
      },
      {
        "MarketerID": 143014,
        "MarketerName": "Think Energy - 188"
      },
      {
        "MarketerID": 143015,
        "MarketerName": "American Power & Gas"
      },
      {
        "MarketerID": 143016,
        "MarketerName": "Atlantic Energy"
      },
      {
        "MarketerID": 143017,
        "MarketerName": "Median Energy"
      },
      {
        "MarketerID": 143027,
        "MarketerName": "Josco Energy - 192"
      },
      {
        "MarketerID": 143028,
        "MarketerName": "Josco Energy - 193"
      },
      {
        "MarketerID": 143029,
        "MarketerName": "CleanSky Energy - DC and MD - 194"
      },
      {
        "MarketerID": 143030,
        "MarketerName": "CleanSky Energy - DC and MD - 195"
      },
      {
        "MarketerID": 143039,
        "MarketerName": "UGI Energy Services - 197"
      },
      {
        "MarketerID": 143040,
        "MarketerName": "Indra Energy - MD - 198"
      },
      {
        "MarketerID": 143041,
        "MarketerName": "Indra Energy - MD - 199"
      },
      {
        "MarketerID": 143042,
        "MarketerName": "Indra Energy - DC - 200"
      },
      {
        "MarketerID": 143043,
        "MarketerName": "Indra Energy - DC - 201"
      },
      {
        "MarketerID": 143044,
        "MarketerName": "Indra Energy - VA - 202"
      },
      {
        "MarketerID": 143045,
        "MarketerName": "Indra Energy - VA - 203"
      },
      {
        "MarketerID": 143047,
        "MarketerName": "MD DHCD"
      },
      {
        "MarketerID": 143049,
        "MarketerName": "Park Power LLC - DC - 204"
      },
      {
        "MarketerID": 143050,
        "MarketerName": "Park Power LLC - DC - 205"
      },
      {
        "MarketerID": 143051,
        "MarketerName": "Park Power LLC - DC - 206"
      },
      {
        "MarketerID": 143063,
        "MarketerName": "East Coast Power & Gas - MD - 207"
      },
      {
        "MarketerID": 143064,
        "MarketerName": "East Coast Power & Gas - MD - 208"
      },
      {
        "MarketerID": 143065,
        "MarketerName": "East Coast Power & Gas - MD - 209"
      },
      {
        "MarketerID": 143066,
        "MarketerName": "Statewise Energy - MD - 210"
      },
      {
        "MarketerID": 143087,
        "MarketerName": "Statewise Energy - MD - 211"
      },
      {
        "MarketerID": 143099,
        "MarketerName": "NRG Business Market,LLC - 212"
      },
      {
        "MarketerID": 143100,
        "MarketerName": "NRG Business Market,LLC - 213"
      },
      {
        "MarketerID": 143101,
        "MarketerName": "NRG Business Market,LLC - 214"
      },
      {
        "MarketerID": 143113,
        "MarketerName": "Nordic Energy Services - 215"
      },
      {
        "MarketerID": 143114,
        "MarketerName": "Nordic Energy Services - 216"
      },
      {
        "MarketerID": 143115,
        "MarketerName": "Nordic Energy Services - 217"
      },
      {
        "MarketerID": 143116,
        "MarketerName": "Nordic Energy Services - 218"
      },
      {
        "MarketerID": 143117,
        "MarketerName": "SunSea Energy - DC - 219"
      },
      {
        "MarketerID": 143118,
        "MarketerName": "SunSea Energy - DC - 220"
      },
      {
        "MarketerID": 143119,
        "MarketerName": "SunSea Energy - DC - 221"
      },
      {
        "MarketerID": 143120,
        "MarketerName": "SunSea Energy - DC - 222"
      },
      {
        "MarketerID": 143121,
        "MarketerName": "SunSea Energy - MD & VA - 223"
      },
      {
        "MarketerID": 143122,
        "MarketerName": "SunSea Energy - MD & VA - 224"
      },
      {
        "MarketerID": 143123,
        "MarketerName": "SunSea Energy - MD & VA - 225"
      },
      {
        "MarketerID": 143124,
        "MarketerName": "SunSea Energy - MD & VA - 226"
      },
      {
        "MarketerID": 143125,
        "MarketerName": "Alpha Gas and Electric - DC - 227"
      },
      {
        "MarketerID": 143127,
        "MarketerName": "Alpha Gas and Electric - DC - 229"
      },
      {
        "MarketerID": 143128,
        "MarketerName": "Alpha Gas and Electric - VA - 230"
      },
      {
        "MarketerID": 143129,
        "MarketerName": "Alpha Gas and Electric - DC - 231"
      },
      {
        "MarketerID": 143130,
        "MarketerName": "Alpha Gas and Electric - VA - 232"
      },
      {
        "MarketerID": 143132,
        "MarketerName": "Alpha Gas and Electric - VA - 234"
      },
      {
        "MarketerID": 143133,
        "MarketerName": "Alpha Gas and Electric - MD - 235"
      },
      {
        "MarketerID": 143134,
        "MarketerName": "Alpha Gas and Electric - MD - 236"
      },
      {
        "MarketerID": 143135,
        "MarketerName": "Alpha Gas and Electric - MD - 237"
      },
      {
        "MarketerID": 143136,
        "MarketerName": "Alpha Gas and Electric - MD - 238"
      },
      {
        "MarketerID": 143145,
        "MarketerName": "Green Choice Energy - DC - 239"
      },
      {
        "MarketerID": 143146,
        "MarketerName": "Green Choice Energy - DC - 240"
      },
      {
        "MarketerID": 143147,
        "MarketerName": "Green Choice Energy - DC - 241"
      },
      {
        "MarketerID": 143148,
        "MarketerName": "Green Choice Energy - DC - 242"
      },
      {
        "MarketerID": 143149,
        "MarketerName": "Green Choice Energy - MD & VA - 243"
      },
      {
        "MarketerID": 143150,
        "MarketerName": "Green Choice Energy - MD & VA - 244"
      },
      {
        "MarketerID": 143151,
        "MarketerName": "Green Choice Energy - MD & VA - 245"
      },
      {
        "MarketerID": 143152,
        "MarketerName": "Green Choice Energy - MD & VA - 246"
      },
      {
        "MarketerID": 143155,
        "MarketerName": "Discount Power LLC - DC - 247"
      },
      {
        "MarketerID": 143156,
        "MarketerName": "Discount Power LLC - DC - 248"
      },
      {
        "MarketerID": 143157,
        "MarketerName": "Discount Power LLC - DC - 249"
      },
      {
        "MarketerID": 143158,
        "MarketerName": "Discount Power LLC - DC - 250"
      },
      {
        "MarketerID": 143159,
        "MarketerName": "Discount Power LLC - MD & VA - 251"
      },
      {
        "MarketerID": 143160,
        "MarketerName": "Discount Power LLC - MD & VA - 252"
      },
      {
        "MarketerID": 143161,
        "MarketerName": "Discount Power LLC - MD & VA - 253"
      },
      {
        "MarketerID": 143162,
        "MarketerName": "Discount Power LLC - MD & VA - 254"
      },
      {
        "MarketerID": 143163,
        "MarketerName": "Park Power LLC - MD & VA - 255"
      },
      {
        "MarketerID": 143164,
        "MarketerName": "Park Power LLC - MD & VA - 256"
      },
      {
        "MarketerID": 143165,
        "MarketerName": "Park Power LLC - MD & VA - 257"
      },
      {
        "MarketerID": 143166,
        "MarketerName": "Park Power LLC - MD & VA - 258"
      },
      {
        "MarketerID": 143240,
        "MarketerName": "Washington Suburban Sanitary Commission "
      },
      {
        "MarketerID": 143244,
        "MarketerName": "Greenlight Energy Inc."
      },
      {
        "MarketerID": 143248,
        "MarketerName": "IGS Energy - MD"
      },
      {
        "MarketerID": 143251,
        "MarketerName": "IGS Energy - VA & DC "
      },
      {
        "MarketerID": 143255,
        "MarketerName": "Engie Power & Gas"
      },
      {
        "MarketerID": 143263,
        "MarketerName": "Wave Energy"
      },
      {
        "MarketerID": 143298,
        "MarketerName": "United Energy Trading "
      },
      {
        "MarketerID": 143317,
        "MarketerName": "Spark Energy Gas LLC"
      },
      {
        "MarketerID": 143395,
        "MarketerName": "Virginia Light & Power LLC"
      },
      {
        "MarketerID": 143399,
        "MarketerName": "New Wave Energy LLC - MD "
      },
      {
        "MarketerID": 143403,
        "MarketerName": "New Wave Energy LLC - DC & VA"
      },
      {
        "MarketerID": 143415,
        "MarketerName": "American Power & Gas - DC"
      },
      {
        "MarketerID": 143440,
        "MarketerName": "Electric Advisers Inc"
      },
      {
        "MarketerID": 143461,
        "MarketerName": "Vista Energy"
      },
      {
        "MarketerID": 143462,
        "MarketerName": "Vista Energy - 303"
      },
      {
        "MarketerID": 143463,
        "MarketerName": "Vista Energy - 304"
      },
      {
        "MarketerID": 143464,
        "MarketerName": "Vista Energy - 305"
      },
      {
        "MarketerID": 143465,
        "MarketerName": "Gas South"
      },
      {
        "MarketerID": 143466,
        "MarketerName": "Gas South - 307"
      },
      {
        "MarketerID": 143467,
        "MarketerName": "Gas South - 308"
      },
      {
        "MarketerID": 143468,
        "MarketerName": "Gas South - 309"
      },
      {
        "MarketerID": 143472,
        "MarketerName": "American Power & Gas - 310"
      },
      {
        "MarketerID": 143473,
        "MarketerName": "American Power & Gas - DC - 311"
      },
      {
        "MarketerID": 143474,
        "MarketerName": "Atlantic Energy - 312"
      },
      {
        "MarketerID": 143475,
        "MarketerName": "Clearview Energy - 313"
      },
      {
        "MarketerID": 143476,
        "MarketerName": "Deca Energy - 314"
      },
      {
        "MarketerID": 143477,
        "MarketerName": "Energy Plus Natural Gas LLC - 316"
      },
      {
        "MarketerID": 143478,
        "MarketerName": "Gateway Energy Services - 317"
      },
      {
        "MarketerID": 143479,
        "MarketerName": "IDT Energy - 318"
      },
      {
        "MarketerID": 143480,
        "MarketerName": "Major Energy - 321"
      },
      {
        "MarketerID": 143481,
        "MarketerName": "Maryland Gas & Electric - 322"
      },
      {
        "MarketerID": 143482,
        "MarketerName": "Median Energy - 323"
      },
      {
        "MarketerID": 143483,
        "MarketerName": "Mpower Energy NJ LLC - 324"
      },
      {
        "MarketerID": 143484,
        "MarketerName": "NRG Home - 325"
      },
      {
        "MarketerID": 143485,
        "MarketerName": "SFE Energy - 326"
      },
      {
        "MarketerID": 143486,
        "MarketerName": "Spring Power & Gas - 327"
      },
      {
        "MarketerID": 143487,
        "MarketerName": "StateWise Energy MD LLC"
      },
      {
        "MarketerID": 143488,
        "MarketerName": "Xoom Energy - 329"
      },
      {
        "MarketerID": 143489,
        "MarketerName": "Xoom Energy of VA"
      }
    ]
  }
}

export const AdminCustomerData = {
  "Succeeded": true,
  "Message": "Get MArketer Account Association successfully!!",
  "Errors": null,
  "Data": {
    "AccountID": 456660,
    "AccountNumber": "220002633091",
    "EffectiveDate": "2025-02-25T00:00:00",
    "EndDate": "2025-05-30T00:00:00",
    "CompanyID": 1,
    "BillingCycleDay": 1,
    "AllocationGroupID": 2,
    "Marketer": [
      {
        "MarketerID": 1,
        "MarketerName": "Ambit Energy"
      },
      {
        "MarketerID": 2,
        "MarketerName": "AGERA Energy"
      },
      {
        "MarketerID": 3,
        "MarketerName": "Atlantic Energy"
      },
      {
        "MarketerID": 4,
        "MarketerName": "AOC"
      },
      {
        "MarketerID": 5,
        "MarketerName": "Bolenja-Italy"
      }
    ],
    "MarketerGroup": [
      {
        "ID": 2,
        "GroupName": "Test Marketer"
      },
      {
        "ID": 3,
        "GroupName": "Marketer child - Interuptible"
      }
    ],
    "AccountAssociationHistories": [
      {
        "AccountID": 456660,
        "AccountNumber": "220002633091",
        "EffectiveDate": "2003-01-01T00:00:00",
        "EndDate": "2004-06-30T00:00:00",
        "CompanyID": 101,
        "CompanyName": "Washington Gas",
        "AllocationGroupID": 61,
        "AllocationGroup": "IRate Accounts"
      },
      {
        "AccountID": 456660,
        "AccountNumber": "220002633091",
        "EffectiveDate": "2003-07-31T00:00:00",
        "EndDate": "2006-02-28T00:00:00",
        "CompanyID": 136,
        "CompanyName": "WGL Energy Svcs - 35",
        "AllocationGroupID": 33,
        "AllocationGroup": "WGES MD IP"
      },
      {
        "AccountID": 456660,
        "AccountNumber": "220002633091",
        "EffectiveDate": "2006-03-01T00:00:00",
        "EndDate": "2012-09-30T00:00:00",
        "CompanyID": 173,
        "CompanyName": "Amerada Hess Corp",
        "AllocationGroupID": 22,
        "AllocationGroup": "AMERAD MD IP-Inactive"
      },
      {
        "AccountID": 456660,
        "AccountNumber": "220002633091",
        "EffectiveDate": "2014-12-01T00:00:00",
        "EndDate": "2016-02-29T00:00:00",
        "CompanyID": 182,
        "CompanyName": "Bollinger Energy",
        "AllocationGroupID": 301,
        "AllocationGroup": "BOLLIN MD IP"
      },
      {
        "AccountID": 456660,
        "AccountNumber": "220002633091",
        "EffectiveDate": "2012-10-01T00:00:00",
        "EndDate": "2014-10-31T00:00:00",
        "CompanyID": 136,
        "CompanyName": "WGL Energy Svcs - 35",
        "AllocationGroupID": 33,
        "AllocationGroup": "WGES MD IP"
      },
      {
        "AccountID": 456660,
        "AccountNumber": "220002633091",
        "EffectiveDate": "2016-03-01T00:00:00",
        "EndDate": "2016-03-31T00:00:00",
        "CompanyID": 136,
        "CompanyName": "WGL Energy Svcs - 35",
        "AllocationGroupID": 149,
        "AllocationGroup": "WGES VA IP"
      },
      {
        "AccountID": 456660,
        "AccountNumber": "220002633091",
        "EffectiveDate": "2016-03-01T00:00:00",
        "EndDate": null,
        "CompanyID": 136,
        "CompanyName": "WGL Energy Svcs - 35",
        "AllocationGroupID": 33,
        "AllocationGroup": "WGES MD IP"
      }
    ]
  }
}

export const getByFirm = {
  "Succeeded": true,
  "Message": null,
  "Errors": null,
  "Data": [
    {
      AllocationGroupID: 1,
      AllocationGroup: "AGERA FP",
      GroupImbalance: 11.237,
      ImbalanceAdjustedVolume: 997,
      InventoryBalance: 12.130,
      EffectiveDate: "2025-02-01T00:00:00"
    },
    {
      AllocationGroupID: 2,
      AllocationGroup: "AMBIT FP",
      GroupImbalance: 11.237,
      ImbalanceAdjustedVolume: 997,
      InventoryBalance: 12.130,
      EffectiveDate: "2025-02-01T00:00:00"
    },
    {
      AllocationGroupID: 3,
      AllocationGroup: "WGES FP",
      GroupImbalance: 11.237,
      ImbalanceAdjustedVolume: 997,
      InventoryBalance: 12.130,
      EffectiveDate: "2025-02-01T00:00:00"
    }
  ]
}

export const NominationGroupData = {
  "Succeeded": true,
  "Message": null,
  "Errors": null,
  "Data": {
    "GroupData": {
      "MarketerID": 173,
      "MaketerName": "Amerada Hess Corp",
      "GroupData1": [
        {
          "GroupID": 21,
          "GroupName": "AMERAD DC IP-Inactive",
          "GroupDetails": [
            {
              "ShipmentDate": "2025-03-01T00:00:00",
              "GroupValue": "728",
              "GroupDate": "2005-03-01T00:00:00",
              "NominationID": 216,
              "NominationValue": "826.00",
              "DRVID": 6097,
              "DRV_value": 825
            },
            {
              "ShipmentDate": "2005-03-02T00:00:00",
              "GroupValue": "778",
              "GroupDate": "2005-06-02T00:00:00",
              "NominationID": 217,
              "NominationValue": "0.00",
              "DRVID": 6098,
              "DRV_value": 818
            },
            {
              "ShipmentDate": "2025-06-03T00:00:00",
              "GroupValue": "746",
              "GroupDate": "2025-06-03T00:00:00",
              "NominationID": 218,
              "NominationValue": "0.00",
              "DRVID": 6099,
              "DRV_value": 818
            },
            {
              "ShipmentDate": "2025-06-04T00:00:00",
              "GroupValue": "610",
              "GroupDate": "2025-06-04T00:00:00",
              "NominationID": 219,
              "NominationValue": "0.00",
              "DRVID": 6100,
              "DRV_value": 769
            },
            {
              "ShipmentDate": "2025-06-05T00:00:00",
              "GroupValue": "625",
              "GroupDate": "2025-06-05T00:00:00",
              "NominationID": 220,
              "NominationValue": "0.00",
              "DRVID": 6101,
              "DRV_value": 769
            },
            {
              "ShipmentDate": "2025-06-06T00:00:00",
              "GroupValue": "817",
              "GroupDate": "2025-06-06T00:00:00",
              "NominationID": 221,
              "NominationValue": "0.00",
              "DRVID": 6102,
              "DRV_value": 785
            },
            {
              "ShipmentDate": "2025-06-07T00:00:00",
              "GroupValue": "898",
              "GroupDate": "2025-06-07T00:00:00",
              "NominationID": 222,
              "NominationValue": "0.00",
              "DRVID": 6103,
              "DRV_value": 818
            },
            {
              "ShipmentDate": "2025-06-08T00:00:00",
              "GroupValue": "924",
              "GroupDate": "2025-06-08T00:00:00",
              "NominationID": 223,
              "NominationValue": "0.00",
              "DRVID": 6104,
              "DRV_value": 818
            },
            {
              "ShipmentDate": "2025-06-09T00:00:00",
              "GroupValue": "795",
              "GroupDate": "2025-06-09T00:00:00",
              "NominationID": 224,
              "NominationValue": "0.00",
              "DRVID": 6105,
              "DRV_value": 818
            },
            {
              "ShipmentDate": "2025-06-10T00:00:00",
              "GroupValue": "809",
              "GroupDate": "2025-06-10T00:00:00",
              "NominationID": 225,
              "NominationValue": "0.00",
              "DRVID": 6106,
              "DRV_value": 818
            },
            {
              "ShipmentDate": "2025-06-11T00:00:00",
              "GroupValue": "586",
              "GroupDate": "2025-06-11T00:00:00",
              "NominationID": 226,
              "NominationValue": "0.00",
              "DRVID": 6107,
              "DRV_value": 785
            },
            {
              "ShipmentDate": "2025-06-12T00:00:00",
              "GroupValue": "674",
              "GroupDate": "2025-06-12T00:00:00",
              "NominationID": 227,
              "NominationValue": "0.00",
              "DRVID": 6108,
              "DRV_value": 761
            },
            {
              "ShipmentDate": "2025-06-13T00:00:00",
              "GroupValue": "812",
              "GroupDate": "2025-06-13T00:00:00",
              "NominationID": 228,
              "NominationValue": "0.00",
              "DRVID": 6109,
              "DRV_value": 785
            },
            {
              "ShipmentDate": "2025-06-14T00:00:00",
              "GroupValue": "1170",
              "GroupDate": "2025-06-14T00:00:00",
              "NominationID": 229,
              "NominationValue": "0.00",
              "DRVID": 6110,
              "DRV_value": 818
            },
            {
              "ShipmentDate": "2025-06-15T00:00:00",
              "GroupValue": "1261",
              "GroupDate": "2025-06-15T00:00:00",
              "NominationID": 230,
              "NominationValue": "0.00",
              "DRVID": 6111,
              "DRV_value": 818
            },
            {
              "ShipmentDate": "2025-06-16T00:00:00",
              "GroupValue": "1407",
              "GroupDate": "2025-06-16T00:00:00",
              "NominationID": 231,
              "NominationValue": "0.00",
              "DRVID": 6112,
              "DRV_value": 818
            },
            {
              "ShipmentDate": "2025-06-17T00:00:00",
              "GroupValue": "1341",
              "GroupDate": "2025-06-17T00:00:00",
              "NominationID": 232,
              "NominationValue": "0.00",
              "DRVID": 6113,
              "DRV_value": 820
            },
            {
              "ShipmentDate": "2025-06-18T00:00:00",
              "GroupValue": "1233",
              "GroupDate": "2025-06-18T00:00:00",
              "NominationID": 233,
              "NominationValue": "0.00",
              "DRVID": 6114,
              "DRV_value": 779
            },
            {
              "ShipmentDate": "2025-06-19T00:00:00",
              "GroupValue": "965",
              "GroupDate": "2025-06-19T00:00:00",
              "NominationID": 234,
              "NominationValue": "0.00",
              "DRVID": 6115,
              "DRV_value": 738
            },
            {
              "ShipmentDate": "2025-06-20T00:00:00",
              "GroupValue": "979",
              "GroupDate": "2025-06-20T00:00:00",
              "NominationID": 235,
              "NominationValue": "0.00",
              "DRVID": 6116,
              "DRV_value": 779
            },
            {
              "ShipmentDate": "2025-06-21T00:00:00",
              "GroupValue": "793",
              "GroupDate": "2025-06-21T00:00:00",
              "NominationID": 236,
              "NominationValue": "0.00",
              "DRVID": 6117,
              "DRV_value": 820
            },
            {
              "ShipmentDate": "2025-06-22T00:00:00",
              "GroupValue": "973",
              "GroupDate": "2025-06-22T00:00:00",
              "NominationID": 237,
              "NominationValue": "0.00",
              "DRVID": 6118,
              "DRV_value": 1028
            },
            {
              "ShipmentDate": "2025-06-23T00:00:00",
              "GroupValue": "862",
              "GroupDate": "2025-06-23T00:00:00",
              "NominationID": 238,
              "NominationValue": "0.00",
              "DRVID": 6119,
              "DRV_value": 1028
            },
            {
              "ShipmentDate": "2025-06-24T00:00:00",
              "GroupValue": "811",
              "GroupDate": "2025-06-24T00:00:00",
              "NominationID": 239,
              "NominationValue": "0.00",
              "DRVID": 6120,
              "DRV_value": 872
            },
            {
              "ShipmentDate": "2025-06-25T00:00:00",
              "GroupValue": "833",
              "GroupDate": "2025-06-25T00:00:00",
              "NominationID": 240,
              "NominationValue": "0.00",
              "DRVID": 6121,
              "DRV_value": 828
            },
            {
              "ShipmentDate": "2025-06-26T00:00:00",
              "GroupValue": "644",
              "GroupDate": "2025-06-26T00:00:00",
              "NominationID": 241,
              "NominationValue": "0.00",
              "DRVID": 6122,
              "DRV_value": 785
            },
            {
              "ShipmentDate": "2025-06-27T00:00:00",
              "GroupValue": "697",
              "GroupDate": "2025-06-27T00:00:00",
              "NominationID": 242,
              "NominationValue": "0.00",
              "DRVID": 6123,
              "DRV_value": 828
            },
            {
              "ShipmentDate": "2025-06-28T00:00:00",
              "GroupValue": "729",
              "GroupDate": "2025-06-28T00:00:00",
              "NominationID": 243,
              "NominationValue": "0.00",
              "DRVID": 6124,
              "DRV_value": 872
            },
            {
              "ShipmentDate": "2025-06-29T00:00:00",
              "GroupValue": "731",
              "GroupDate": "2025-06-29T00:00:00",
              "NominationID": 244,
              "NominationValue": "0.00",
              "DRVID": 6125,
              "DRV_value": 872
            },
            {
              "ShipmentDate": "2025-06-30T00:00:00",
              "GroupValue": "784",
              "GroupDate": "2025-06-30T00:00:00",
              "NominationID": 245,
              "NominationValue": "0.00",
              "DRVID": 6126,
              "DRV_value": 716
            }
          ]
        },
        {
          "GroupID": 22,
          "GroupName": "Group 2",
          "GroupDetails": [
            {
              "ShipmentDate": "2025-03-01T00:00:00",
              "GroupValue": "728",
              "GroupDate": "2005-03-01T00:00:00",
              "NominationID": 216,
              "NominationValue": "826.00",
              "DRVID": 6097,
              "DRV_value": 825
            },
            {
              "ShipmentDate": "2005-03-02T00:00:00",
              "GroupValue": "778",
              "GroupDate": "2005-03-02T00:00:00",
              "NominationID": 217,
              "NominationValue": "0.00",
              "DRVID": 6098,
              "DRV_value": 818
            },
            {
              "ShipmentDate": "2025-03-03T00:00:00",
              "GroupValue": "746",
              "GroupDate": "2025-03-03T00:00:00",
              "NominationID": 218,
              "NominationValue": "0.00",
              "DRVID": 6099,
              "DRV_value": 818
            },
            {
              "ShipmentDate": "2025-03-04T00:00:00",
              "GroupValue": "610",
              "GroupDate": "2025-03-04T00:00:00",
              "NominationID": 219,
              "NominationValue": "0.00",
              "DRVID": 6100,
              "DRV_value": 769
            },
            {
              "ShipmentDate": "2025-03-05T00:00:00",
              "GroupValue": "625",
              "GroupDate": "2025-03-05T00:00:00",
              "NominationID": 220,
              "NominationValue": "0.00",
              "DRVID": 6101,
              "DRV_value": 769
            },
            {
              "ShipmentDate": "2025-03-03T00:00:00",
              "GroupValue": "817",
              "GroupDate": "2025-03-03T00:00:00",
              "NominationID": 221,
              "NominationValue": "0.00",
              "DRVID": 6102,
              "DRV_value": 785
            },
            {
              "ShipmentDate": "2025-03-07T00:00:00",
              "GroupValue": "898",
              "GroupDate": "2025-03-07T00:00:00",
              "NominationID": 222,
              "NominationValue": "0.00",
              "DRVID": 6103,
              "DRV_value": 818
            },
            {
              "ShipmentDate": "2025-03-08T00:00:00",
              "GroupValue": "924",
              "GroupDate": "2025-03-08T00:00:00",
              "NominationID": 223,
              "NominationValue": "0.00",
              "DRVID": 6104,
              "DRV_value": 818
            },
            {
              "ShipmentDate": "2025-03-09T00:00:00",
              "GroupValue": "795",
              "GroupDate": "2025-03-09T00:00:00",
              "NominationID": 224,
              "NominationValue": "0.00",
              "DRVID": 6105,
              "DRV_value": 818
            },
            {
              "ShipmentDate": "2025-03-10T00:00:00",
              "GroupValue": "809",
              "GroupDate": "2025-03-10T00:00:00",
              "NominationID": 225,
              "NominationValue": "0.00",
              "DRVID": 6103,
              "DRV_value": 818
            },
            {
              "ShipmentDate": "2025-03-11T00:00:00",
              "GroupValue": "586",
              "GroupDate": "2025-03-11T00:00:00",
              "NominationID": 226,
              "NominationValue": "0.00",
              "DRVID": 6107,
              "DRV_value": 785
            },
            {
              "ShipmentDate": "2025-03-12T00:00:00",
              "GroupValue": "674",
              "GroupDate": "2025-03-12T00:00:00",
              "NominationID": 227,
              "NominationValue": "0.00",
              "DRVID": 6108,
              "DRV_value": 761
            },
            {
              "ShipmentDate": "2025-03-13T00:00:00",
              "GroupValue": "812",
              "GroupDate": "2025-03-13T00:00:00",
              "NominationID": 228,
              "NominationValue": "0.00",
              "DRVID": 6109,
              "DRV_value": 785
            },
            {
              "ShipmentDate": "2025-03-14T00:00:00",
              "GroupValue": "1170",
              "GroupDate": "2025-03-14T00:00:00",
              "NominationID": 229,
              "NominationValue": "0.00",
              "DRVID": 6110,
              "DRV_value": 818
            },
            {
              "ShipmentDate": "2025-03-15T00:00:00",
              "GroupValue": "1261",
              "GroupDate": "2025-03-15T00:00:00",
              "NominationID": 230,
              "NominationValue": "0.00",
              "DRVID": 6111,
              "DRV_value": 818
            },
            {
              "ShipmentDate": "2025-03-16T00:00:00",
              "GroupValue": "1407",
              "GroupDate": "2025-03-16T00:00:00",
              "NominationID": 231,
              "NominationValue": "0.00",
              "DRVID": 6112,
              "DRV_value": 818
            },
            {
              "ShipmentDate": "2025-03-17T00:00:00",
              "GroupValue": "1341",
              "GroupDate": "2025-03-17T00:00:00",
              "NominationID": 232,
              "NominationValue": "0.00",
              "DRVID": 6113,
              "DRV_value": 820
            },
            {
              "ShipmentDate": "2025-03-18T00:00:00",
              "GroupValue": "1233",
              "GroupDate": "2025-03-18T00:00:00",
              "NominationID": 233,
              "NominationValue": "0.00",
              "DRVID": 6114,
              "DRV_value": 779
            },
            {
              "ShipmentDate": "2025-03-19T00:00:00",
              "GroupValue": "965",
              "GroupDate": "2025-03-19T00:00:00",
              "NominationID": 234,
              "NominationValue": "0.00",
              "DRVID": 6115,
              "DRV_value": 738
            },
            {
              "ShipmentDate": "2025-03-20T00:00:00",
              "GroupValue": "979",
              "GroupDate": "2025-03-20T00:00:00",
              "NominationID": 235,
              "NominationValue": "0.00",
              "DRVID": 6116,
              "DRV_value": 779
            },
            {
              "ShipmentDate": "2025-03-21T00:00:00",
              "GroupValue": "793",
              "GroupDate": "2025-03-21T00:00:00",
              "NominationID": 236,
              "NominationValue": "0.00",
              "DRVID": 6117,
              "DRV_value": 820
            },
            {
              "ShipmentDate": "2025-03-22T00:00:00",
              "GroupValue": "973",
              "GroupDate": "2025-03-22T00:00:00",
              "NominationID": 237,
              "NominationValue": "0.00",
              "DRVID": 6118,
              "DRV_value": 1028
            },
            {
              "ShipmentDate": "2025-03-23T00:00:00",
              "GroupValue": "862",
              "GroupDate": "2025-03-23T00:00:00",
              "NominationID": 238,
              "NominationValue": "0.00",
              "DRVID": 6119,
              "DRV_value": 1028
            },
            {
              "ShipmentDate": "2025-03-24T00:00:00",
              "GroupValue": "811",
              "GroupDate": "2025-03-24T00:00:00",
              "NominationID": 239,
              "NominationValue": "0.00",
              "DRVID": 6120,
              "DRV_value": 872
            },
            {
              "ShipmentDate": "2025-03-25T00:00:00",
              "GroupValue": "833",
              "GroupDate": "2025-03-25T00:00:00",
              "NominationID": 240,
              "NominationValue": "0.00",
              "DRVID": 6121,
              "DRV_value": 828
            },
            {
              "ShipmentDate": "2025-03-26T00:00:00",
              "GroupValue": "644",
              "GroupDate": "2025-03-26T00:00:00",
              "NominationID": 241,
              "NominationValue": "0.00",
              "DRVID": 6122,
              "DRV_value": 785
            },
            {
              "ShipmentDate": "2025-03-27T00:00:00",
              "GroupValue": "697",
              "GroupDate": "2025-03-27T00:00:00",
              "NominationID": 242,
              "NominationValue": "0.00",
              "DRVID": 6123,
              "DRV_value": 828
            },
            {
              "ShipmentDate": "2025-03-28T00:00:00",
              "GroupValue": "729",
              "GroupDate": "2025-03-28T00:00:00",
              "NominationID": 243,
              "NominationValue": "0.00",
              "DRVID": 6124,
              "DRV_value": 872
            },
            {
              "ShipmentDate": "2025-03-29T00:00:00",
              "GroupValue": "731",
              "GroupDate": "2025-03-29T00:00:00",
              "NominationID": 244,
              "NominationValue": "0.00",
              "DRVID": 6125,
              "DRV_value": 872
            },
            {
              "ShipmentDate": "2025-03-30T00:00:00",
              "GroupValue": "784",
              "GroupDate": "2025-03-30T00:00:00",
              "NominationID": 245,
              "NominationValue": "0.00",
              "DRVID": 6126,
              "DRV_value": 716
            }
          ]
        },
      ],
      "TotalGroupData": {
        "GroupName": "Group",
        "GroupDetails": [
          {
            "ShipmentDate": null,
            "GroupValue": null,
            "GroupDate": "2025-03-03T00:00:00",
            "NominationID": null,
            "NominationValue": "3308.00",
            "DRVID": null,
            "DRV_value": null
          },
          {
            "ShipmentDate": null,
            "GroupValue": null,
            "GroupDate": "2025-03-02T00:00:00",
            "NominationID": null,
            "NominationValue": "40.00",
            "DRVID": null,
            "DRV_value": null
          }
        ]
      }

    },
    "MarketerData": [
      {
        "MarketerID": 101,
        "MarketerName": "Washington Gas Light Company"
      },
      {
        "MarketerID": 102,
        "MarketerName": "AGF Direct Gas Sales Inc"
      }
    ],
    "ListGroupData": [
      {
        "GroupID": 21,
        "GroupName": "AMERAD DC IP-Inactive"
      },
      {
        "GroupID": 22,
        "GroupName": "AMERAD MD IP-Inactive"
      },
      {
        "GroupID": 23,
        "GroupName": "BGE HO MD IP-Inactive"
      }]
  }
}

export const fileHubSupportedFormat = ['.xls', '.xlsx']

export const fileHubUETSupportedFormat = ['.xml']

export const accountInquiryData = {
  "Succeeded": true,
  "Message": null,
  "Errors": null,
  Data: {
    AccountData: [
      {
        AccountID: 1,
        AccountNumber: "12245460096",
        AccountHolder: "Test Account",
        SecondaryName: "Test Account",
        ServiceAddress: "No 1 texas city USA country",
        BillingAddress: "No 2 texas city USA country",
        PhoneNumber: "1234567890",
        AmountDue: "388.01"
      },
      {
        AccountID: 2,
        AccountNumber: "3674523756984",
        AccountHolder: "Test2 Account",
        SecondaryName: "Test2 Account",
        ServiceAddress: "No 1 texas city USA country",
        BillingAddress: "No 2 texas city USA country",
        PhoneNumber: "845-343-121-3455",
        AmountDue: "388.01"
      },
      {
        AccountID: 3,
        AccountNumber: "92478634545",
        AccountHolder: "Test3 Account",
        SecondaryName: "Test3 Account",
        ServiceAddress: "No 1 texas city USA country",
        BillingAddress: "No 2 texas city USA country",
        PhoneNumber: "1234567890",
        AmountDue: "388.01"
      },
      {
        AccountID: 4,
        AccountNumber: "013946564",
        AccountHolder: "Test4 Account",
        SecondaryName: "Test4 Account",
        ServiceAddress: "No 1 texas city USA country",
        BillingAddress: "No 2 texas city USA country",
        PhoneNumber: "1234567890",
        AmountDue: "388.01"
      }
    ]
  }
}

export const monthlyStorageFakeData ={
  "Succeeded": true,
  "Message": null,
  "Errors": null,
  "Data": {
    "MonthlyStorageData": [
      {
        "ShipmentDate": "2024-04-01T00:00:00",
        "TotalNominationAllocations": 68036,
        "TotalUsage": 75054,
        "TotalInjection": -7140,
        "TotalBalance": 1560436
      },
      {
        "ShipmentDate": "2024-04-02T00:00:00",
        "TotalNominationAllocations": 66377,
        "TotalUsage": 84043,
        "TotalInjection": -17973,
        "TotalBalance": 1542463
      },
      {
        "ShipmentDate": "2024-04-03T00:00:00",
        "TotalNominationAllocations": 62999,
        "TotalUsage": 91235,
        "TotalInjection": -28727,
        "TotalBalance": 1513736
      },
      {
        "ShipmentDate": "2024-04-04T00:00:00",
        "TotalNominationAllocations": 82141,
        "TotalUsage": 91954,
        "TotalInjection": -9984,
        "TotalBalance": 1503752
      },
      {
        "ShipmentDate": "2024-04-05T00:00:00",
        "TotalNominationAllocations": 92247,
        "TotalUsage": 94112,
        "TotalInjection": -1897,
        "TotalBalance": 1501855
      },
      {
        "ShipmentDate": "2024-04-06T00:00:00",
        "TotalNominationAllocations": 93495,
        "TotalUsage": 81526,
        "TotalInjection": 11896,
        "TotalBalance": 1513751
      },
      {
        "ShipmentDate": "2024-04-07T00:00:00",
        "TotalNominationAllocations": 86372,
        "TotalUsage": 67143,
        "TotalInjection": 19112,
        "TotalBalance": 1532863
      },
      {
        "ShipmentDate": "2024-04-08T00:00:00",
        "TotalNominationAllocations": 78422,
        "TotalUsage": 48444,
        "TotalInjection": 29795,
        "TotalBalance": 1562658
      },
      {
        "ShipmentDate": "2024-04-09T00:00:00",
        "TotalNominationAllocations": 72224,
        "TotalUsage": 31184,
        "TotalInjection": 40789,
        "TotalBalance": 1603447
      },
      {
        "ShipmentDate": "2024-04-10T00:00:00",
        "TotalNominationAllocations": 69234,
        "TotalUsage": 31184,
        "TotalInjection": 37818,
        "TotalBalance": 1641265
      },
      {
        "ShipmentDate": "2024-04-11T00:00:00",
        "TotalNominationAllocations": 66899,
        "TotalUsage": 31184,
        "TotalInjection": 35497,
        "TotalBalance": 1676762
      },
      {
        "ShipmentDate": "2024-04-12T00:00:00",
        "TotalNominationAllocations": 71527,
        "TotalUsage": 31184,
        "TotalInjection": 40097,
        "TotalBalance": 1716859
      },
      {
        "ShipmentDate": "2024-04-13T00:00:00",
        "TotalNominationAllocations": 71726,
        "TotalUsage": 49883,
        "TotalInjection": 21710,
        "TotalBalance": 1738569
      },
      {
        "ShipmentDate": "2024-04-14T00:00:00",
        "TotalNominationAllocations": 68336,
        "TotalUsage": 31184,
        "TotalInjection": 36925,
        "TotalBalance": 1775494
      },
      {
        "ShipmentDate": "2024-04-15T00:00:00",
        "TotalNominationAllocations": 68303,
        "TotalUsage": 31184,
        "TotalInjection": 36892,
        "TotalBalance": 1812386
      },
      {
        "ShipmentDate": "2024-04-16T00:00:00",
        "TotalNominationAllocations": 68644,
        "TotalUsage": 31184,
        "TotalInjection": 37231,
        "TotalBalance": 1849617
      },
      {
        "ShipmentDate": "2024-04-17T00:00:00",
        "TotalNominationAllocations": 69119,
        "TotalUsage": 31184,
        "TotalInjection": 37703,
        "TotalBalance": 1887320
      },
      {
        "ShipmentDate": "2024-04-18T00:00:00",
        "TotalNominationAllocations": 68976,
        "TotalUsage": 36578,
        "TotalInjection": 32200,
        "TotalBalance": 1919520
      },
      {
        "ShipmentDate": "2024-04-19T00:00:00",
        "TotalNominationAllocations": 74690,
        "TotalUsage": 62109,
        "TotalInjection": 12504,
        "TotalBalance": 1932024
      },
      {
        "ShipmentDate": "2024-04-20T00:00:00",
        "TotalNominationAllocations": 70360,
        "TotalUsage": 49523,
        "TotalInjection": 20710,
        "TotalBalance": 1952734
      },
      {
        "ShipmentDate": "2024-04-21T00:00:00",
        "TotalNominationAllocations": 70289,
        "TotalUsage": 83324,
        "TotalInjection": -13262,
        "TotalBalance": 1939472
      },
      {
        "ShipmentDate": "2024-04-22T00:00:00",
        "TotalNominationAllocations": 63288,
        "TotalUsage": 66064,
        "TotalInjection": -2824,
        "TotalBalance": 1936648
      },
      {
        "ShipmentDate": "2024-04-23T00:00:00",
        "TotalNominationAllocations": 63201,
        "TotalUsage": 32623,
        "TotalInjection": 30391,
        "TotalBalance": 1967039
      },
      {
        "ShipmentDate": "2024-04-24T00:00:00",
        "TotalNominationAllocations": 77896,
        "TotalUsage": 37297,
        "TotalInjection": 40351,
        "TotalBalance": 2007390
      },
      {
        "ShipmentDate": "2024-04-25T00:00:00",
        "TotalNominationAllocations": 102539,
        "TotalUsage": 72537,
        "TotalInjection": 29819,
        "TotalBalance": 2037209
      },
      {
        "ShipmentDate": "2024-04-26T00:00:00",
        "TotalNominationAllocations": 89368,
        "TotalUsage": 58153,
        "TotalInjection": 31024,
        "TotalBalance": 2068233
      },
      {
        "ShipmentDate": "2024-04-27T00:00:00",
        "TotalNominationAllocations": 68787,
        "TotalUsage": 57075,
        "TotalInjection": 11640,
        "TotalBalance": 2079873
      },
      {
        "ShipmentDate": "2024-04-28T00:00:00",
        "TotalNominationAllocations": 69079,
        "TotalUsage": 31184,
        "TotalInjection": 37664,
        "TotalBalance": 2117537
      },
      {
        "ShipmentDate": "2024-04-29T00:00:00",
        "TotalNominationAllocations": 69011,
        "TotalUsage": 31184,
        "TotalInjection": 37596,
        "TotalBalance": 2155133
      },
      {
        "ShipmentDate": "2024-04-30T00:00:00",
        "TotalNominationAllocations": 69080,
        "TotalUsage": 31184,
        "TotalInjection": 37665,
        "TotalBalance": 2192798
      }
    ],
    "AvailableMonths": [
      {
        "DisplayMonth": "April 2025",
        "MonthKey": "4/1/2025",
        "MonthValue": "04/01/2025 00:00:00"
      },
      {
        "DisplayMonth": "March 2025",
        "MonthKey": "3/1/2025",
        "MonthValue": "03/01/2025 00:00:00"
      },
      {
        "DisplayMonth": "February 2025",
        "MonthKey": "2/1/2025",
        "MonthValue": "02/01/2025 00:00:00"
      },
      {
        "DisplayMonth": "January 2025",
        "MonthKey": "1/1/2025",
        "MonthValue": "01/01/2025 00:00:00"
      },
      {
        "DisplayMonth": "December 2024",
        "MonthKey": "12/1/2024",
        "MonthValue": "12/01/2024 00:00:00"
      },
      {
        "DisplayMonth": "November 2024",
        "MonthKey": "11/1/2024",
        "MonthValue": "11/01/2024 00:00:00"
      },
      {
        "DisplayMonth": "October 2024",
        "MonthKey": "10/1/2024",
        "MonthValue": "10/01/2024 00:00:00"
      },
      {
        "DisplayMonth": "September 2024",
        "MonthKey": "9/1/2024",
        "MonthValue": "09/01/2024 00:00:00"
      },
      {
        "DisplayMonth": "August 2024",
        "MonthKey": "8/1/2024",
        "MonthValue": "08/01/2024 00:00:00"
      },
      {
        "DisplayMonth": "July 2024",
        "MonthKey": "7/1/2024",
        "MonthValue": "07/01/2024 00:00:00"
      },
      {
        "DisplayMonth": "June 2024",
        "MonthKey": "6/1/2024",
        "MonthValue": "06/01/2024 00:00:00"
      },
      {
        "DisplayMonth": "May 2024",
        "MonthKey": "5/1/2024",
        "MonthValue": "05/01/2024 00:00:00"
      },
      {
        "DisplayMonth": "April 2024",
        "MonthKey": "4/1/2024",
        "MonthValue": "04/01/2024 00:00:00"
      },
      {
        "DisplayMonth": "March 2024",
        "MonthKey": "3/1/2024",
        "MonthValue": "03/01/2024 00:00:00"
      },
      {
        "DisplayMonth": "February 2024",
        "MonthKey": "2/1/2024",
        "MonthValue": "02/01/2024 00:00:00"
      },
      {
        "DisplayMonth": "January 2024",
        "MonthKey": "1/1/2024",
        "MonthValue": "01/01/2024 00:00:00"
      },
      {
        "DisplayMonth": "December 2023",
        "MonthKey": "12/1/2023",
        "MonthValue": "12/01/2023 00:00:00"
      },
      {
        "DisplayMonth": "November 2023",
        "MonthKey": "11/1/2023",
        "MonthValue": "11/01/2023 00:00:00"
      },
      {
        "DisplayMonth": "October 2023",
        "MonthKey": "10/1/2023",
        "MonthValue": "10/01/2023 00:00:00"
      },
      {
        "DisplayMonth": "September 2023",
        "MonthKey": "9/1/2023",
        "MonthValue": "09/01/2023 00:00:00"
      },
      {
        "DisplayMonth": "August 2023",
        "MonthKey": "8/1/2023",
        "MonthValue": "08/01/2023 00:00:00"
      },
      {
        "DisplayMonth": "July 2023",
        "MonthKey": "7/1/2023",
        "MonthValue": "07/01/2023 00:00:00"
      },
      {
        "DisplayMonth": "June 2023",
        "MonthKey": "6/1/2023",
        "MonthValue": "06/01/2023 00:00:00"
      },
      {
        "DisplayMonth": "May 2023",
        "MonthKey": "5/1/2023",
        "MonthValue": "05/01/2023 00:00:00"
      },
      {
        "DisplayMonth": "April 2023",
        "MonthKey": "4/1/2023",
        "MonthValue": "04/01/2023 00:00:00"
      },
      {
        "DisplayMonth": "March 2023",
        "MonthKey": "3/1/2023",
        "MonthValue": "03/01/2023 00:00:00"
      },
      {
        "DisplayMonth": "February 2023",
        "MonthKey": "2/1/2023",
        "MonthValue": "02/01/2023 00:00:00"
      },
      {
        "DisplayMonth": "January 2023",
        "MonthKey": "1/1/2023",
        "MonthValue": "01/01/2023 00:00:00"
      },
      {
        "DisplayMonth": "December 2022",
        "MonthKey": "12/1/2022",
        "MonthValue": "12/01/2022 00:00:00"
      },
      {
        "DisplayMonth": "November 2022",
        "MonthKey": "11/1/2022",
        "MonthValue": "11/01/2022 00:00:00"
      },
      {
        "DisplayMonth": "October 2022",
        "MonthKey": "10/1/2022",
        "MonthValue": "10/01/2022 00:00:00"
      },
      {
        "DisplayMonth": "September 2022",
        "MonthKey": "9/1/2022",
        "MonthValue": "09/01/2022 00:00:00"
      },
      {
        "DisplayMonth": "August 2022",
        "MonthKey": "8/1/2022",
        "MonthValue": "08/01/2022 00:00:00"
      },
      {
        "DisplayMonth": "July 2022",
        "MonthKey": "7/1/2022",
        "MonthValue": "07/01/2022 00:00:00"
      },
      {
        "DisplayMonth": "June 2022",
        "MonthKey": "6/1/2022",
        "MonthValue": "06/01/2022 00:00:00"
      },
      {
        "DisplayMonth": "May 2022",
        "MonthKey": "5/1/2022",
        "MonthValue": "05/01/2022 00:00:00"
      },
      {
        "DisplayMonth": "April 2022",
        "MonthKey": "4/1/2022",
        "MonthValue": "04/01/2022 00:00:00"
      },
      {
        "DisplayMonth": "March 2022",
        "MonthKey": "3/1/2022",
        "MonthValue": "03/01/2022 00:00:00"
      },
      {
        "DisplayMonth": "February 2022",
        "MonthKey": "2/1/2022",
        "MonthValue": "02/01/2022 00:00:00"
      },
      {
        "DisplayMonth": "January 2022",
        "MonthKey": "1/1/2022",
        "MonthValue": "01/01/2022 00:00:00"
      },
      {
        "DisplayMonth": "December 2021",
        "MonthKey": "12/1/2021",
        "MonthValue": "12/01/2021 00:00:00"
      },
      {
        "DisplayMonth": "November 2021",
        "MonthKey": "11/1/2021",
        "MonthValue": "11/01/2021 00:00:00"
      },
      {
        "DisplayMonth": "October 2021",
        "MonthKey": "10/1/2021",
        "MonthValue": "10/01/2021 00:00:00"
      },
      {
        "DisplayMonth": "September 2021",
        "MonthKey": "9/1/2021",
        "MonthValue": "09/01/2021 00:00:00"
      },
      {
        "DisplayMonth": "August 2021",
        "MonthKey": "8/1/2021",
        "MonthValue": "08/01/2021 00:00:00"
      },
      {
        "DisplayMonth": "July 2021",
        "MonthKey": "7/1/2021",
        "MonthValue": "07/01/2021 00:00:00"
      },
      {
        "DisplayMonth": "June 2021",
        "MonthKey": "6/1/2021",
        "MonthValue": "06/01/2021 00:00:00"
      },
      {
        "DisplayMonth": "May 2021",
        "MonthKey": "5/1/2021",
        "MonthValue": "05/01/2021 00:00:00"
      },
      {
        "DisplayMonth": "April 2021",
        "MonthKey": "4/1/2021",
        "MonthValue": "04/01/2021 00:00:00"
      },
      {
        "DisplayMonth": "March 2021",
        "MonthKey": "3/1/2021",
        "MonthValue": "03/01/2021 00:00:00"
      },
      {
        "DisplayMonth": "February 2021",
        "MonthKey": "2/1/2021",
        "MonthValue": "02/01/2021 00:00:00"
      },
      {
        "DisplayMonth": "January 2021",
        "MonthKey": "1/1/2021",
        "MonthValue": "01/01/2021 00:00:00"
      },
      {
        "DisplayMonth": "December 2020",
        "MonthKey": "12/1/2020",
        "MonthValue": "12/01/2020 00:00:00"
      },
      {
        "DisplayMonth": "November 2020",
        "MonthKey": "11/1/2020",
        "MonthValue": "11/01/2020 00:00:00"
      },
      {
        "DisplayMonth": "October 2020",
        "MonthKey": "10/1/2020",
        "MonthValue": "10/01/2020 00:00:00"
      },
      {
        "DisplayMonth": "September 2020",
        "MonthKey": "9/1/2020",
        "MonthValue": "09/01/2020 00:00:00"
      },
      {
        "DisplayMonth": "August 2020",
        "MonthKey": "8/1/2020",
        "MonthValue": "08/01/2020 00:00:00"
      },
      {
        "DisplayMonth": "July 2020",
        "MonthKey": "7/1/2020",
        "MonthValue": "07/01/2020 00:00:00"
      },
      {
        "DisplayMonth": "June 2020",
        "MonthKey": "6/1/2020",
        "MonthValue": "06/01/2020 00:00:00"
      },
      {
        "DisplayMonth": "May 2020",
        "MonthKey": "5/1/2020",
        "MonthValue": "05/01/2020 00:00:00"
      },
      {
        "DisplayMonth": "April 2020",
        "MonthKey": "4/1/2020",
        "MonthValue": "04/01/2020 00:00:00"
      }
    ],
    "MarketerList": [
      {
        "CompanyID": 136,
        "Description": "WGL Energy Svcs - 35",
        "DescriptionAndId": "WGL Energy Svcs - 35 (136)"
      }
    ],
    "ImbalanceAdjustedVolume": {
      "Value": 1567576,
      "MonthEndBalanceForCurrentMonth": 2192798,
      "ImbalanceAdjustedVolume": 453,
      "BeginingBalanceForNextMonth": 2193251
    },
    "MonthlyTotalStorage": {
      "MonthlyTotalNominationAllocations": 2212665,
      "MonthlyTotalUsage": 1581701,
      "MonthlyTotalInjection": 625222,
      "MonthEndBalance": 2192798
    }
  }
}

export const MarketerCustomerData = {
  Succeeded: true,
  Message: "Account overview retrieved successfully",
  Errors: null,
  Data: {
    accountOverviewInfo: {
      Account: "320005071248",
      CUSTOMER_NAME: "MARVIN ALLEN",
      LAST_BILL_DATE: "",
      LAST_BILL_AMT: "",
      LAST_PAYMT_DTE: "",
      LAST_PAYMT_AMT: "",
      STATUS: 1,
      SERVICE_ADDR: "609 Nathan Pl NELeesburg, VA 20176-2350 USA",
      ErrorMessage: null,
      amountDue: 388.17,
    },
    getLegacyBillDates_Resp: {
      Account: "320005071248",
      dueDate: "12-05-2024",
      pastDue: "-",
      amountDue: 388.17,
      INVOICE: [
        {
          Bill_Date: null,
          PrintDocument: null,
          Bill_Start_Date: null,
          Bill_End_Date: null,
          Invoice_Amount: null,
          IsThirdParty: false,
        },
      ],
      ERRORS: [
        {
          Message_Type: "I",
          Message_Txt1: "Print Document doesn’t exist in the archive server",
          Message_Txt2: null,
        },
      ],
    },
    paymentHistoryInfo_Resp: {
      PaymentHistory: [],
    },
  },
};

export const CityGateReportsData = {
  "Succeeded": true,
  "Message": "Report Received",
  "Errors": null,
  "Data": {
    "supplybyCityGateReport": [
      {
        "CompanyID": 103,
        "ShortName": "Constellation Energy Source",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 103,
        "ShortName": "Constellation Energy Source",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 103,
        "ShortName": "Constellation Energy Source",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 103,
        "ShortName": "Constellation Energy Source",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 103,
        "ShortName": "Constellation Energy Source",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 103,
        "ShortName": "Constellation Energy Source",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 134,
        "ShortName": "UGI Energy Services - 33",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 6156,
        "TotalByShortName": 8208,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 75,
        "NominationPercentageOverall": 2.97,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 134,
        "ShortName": "UGI Energy Services - 33",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 8208,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 134,
        "ShortName": "UGI Energy Services - 33",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 821,
        "TotalByShortName": 8208,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 10,
        "NominationPercentageOverall": 0.4,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 134,
        "ShortName": "UGI Energy Services - 33",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 821,
        "TotalByShortName": 8208,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 10,
        "NominationPercentageOverall": 0.4,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 134,
        "ShortName": "UGI Energy Services - 33",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 410,
        "TotalByShortName": 8208,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 5,
        "NominationPercentageOverall": 0.2,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 134,
        "ShortName": "UGI Energy Services - 33",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 8208,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 136,
        "ShortName": "WGL Energy Svcs - 35",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 74574,
        "TotalByShortName": 99715,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 74.79,
        "NominationPercentageOverall": 35.98,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 136,
        "ShortName": "WGL Energy Svcs - 35",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 99715,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 136,
        "ShortName": "WGL Energy Svcs - 35",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 9879,
        "TotalByShortName": 99715,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 9.91,
        "NominationPercentageOverall": 4.77,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 136,
        "ShortName": "WGL Energy Svcs - 35",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 10085,
        "TotalByShortName": 99715,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 10.11,
        "NominationPercentageOverall": 4.87,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 136,
        "ShortName": "WGL Energy Svcs - 35",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 5177,
        "TotalByShortName": 99715,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 5.19,
        "NominationPercentageOverall": 2.5,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 136,
        "ShortName": "WGL Energy Svcs - 35",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 99715,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 161,
        "ShortName": "Colonial Energy",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 74,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 161,
        "ShortName": "Colonial Energy",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 74,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 161,
        "ShortName": "Colonial Energy",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 74,
        "TotalByShortName": 74,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 100,
        "NominationPercentageOverall": 0.04,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 161,
        "ShortName": "Colonial Energy",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 74,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 161,
        "ShortName": "Colonial Energy",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 74,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 161,
        "ShortName": "Colonial Energy",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 74,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 177,
        "ShortName": "NOVEC Energy Solutions – 76",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 7257,
        "TotalByShortName": 9811,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 73.97,
        "NominationPercentageOverall": 3.5,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 177,
        "ShortName": "NOVEC Energy Solutions – 76",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 9811,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 177,
        "ShortName": "NOVEC Energy Solutions – 76",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 1124,
        "TotalByShortName": 9811,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 11.46,
        "NominationPercentageOverall": 0.54,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 177,
        "ShortName": "NOVEC Energy Solutions – 76",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 1231,
        "TotalByShortName": 9811,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 12.55,
        "NominationPercentageOverall": 0.59,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 177,
        "ShortName": "NOVEC Energy Solutions – 76",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 199,
        "TotalByShortName": 9811,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 2.03,
        "NominationPercentageOverall": 0.1,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 177,
        "ShortName": "NOVEC Energy Solutions – 76",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 9811,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 179,
        "ShortName": "Sprague Op Res LLC - 78",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 2412,
        "TotalByShortName": 3492,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 69.07,
        "NominationPercentageOverall": 1.16,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 179,
        "ShortName": "Sprague Op Res LLC - 78",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 3492,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 179,
        "ShortName": "Sprague Op Res LLC - 78",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 500,
        "TotalByShortName": 3492,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 14.32,
        "NominationPercentageOverall": 0.24,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 179,
        "ShortName": "Sprague Op Res LLC - 78",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 580,
        "TotalByShortName": 3492,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 16.61,
        "NominationPercentageOverall": 0.28,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 179,
        "ShortName": "Sprague Op Res LLC - 78",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 3492,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 179,
        "ShortName": "Sprague Op Res LLC - 78",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 3492,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 182,
        "ShortName": "Bollinger Energy",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 2748,
        "TotalByShortName": 3379,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 81.33,
        "NominationPercentageOverall": 1.33,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 182,
        "ShortName": "Bollinger Energy",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 3379,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 182,
        "ShortName": "Bollinger Energy",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 160,
        "TotalByShortName": 3379,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 4.74,
        "NominationPercentageOverall": 0.08,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 182,
        "ShortName": "Bollinger Energy",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 314,
        "TotalByShortName": 3379,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 9.29,
        "NominationPercentageOverall": 0.15,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 182,
        "ShortName": "Bollinger Energy",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 157,
        "TotalByShortName": 3379,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 4.65,
        "NominationPercentageOverall": 0.08,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 182,
        "ShortName": "Bollinger Energy",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 3379,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 203,
        "ShortName": "Sprague Op Res LLC - 102",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 203,
        "ShortName": "Sprague Op Res LLC - 102",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 203,
        "ShortName": "Sprague Op Res LLC - 102",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 203,
        "ShortName": "Sprague Op Res LLC - 102",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 203,
        "ShortName": "Sprague Op Res LLC - 102",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 203,
        "ShortName": "Sprague Op Res LLC - 102",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 204,
        "ShortName": "Gateway Energy Services",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 727,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 204,
        "ShortName": "Gateway Energy Services",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 727,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 204,
        "ShortName": "Gateway Energy Services",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 727,
        "TotalByShortName": 727,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 100,
        "NominationPercentageOverall": 0.35,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 204,
        "ShortName": "Gateway Energy Services",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 727,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 204,
        "ShortName": "Gateway Energy Services",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 727,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 204,
        "ShortName": "Gateway Energy Services",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 727,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 205,
        "ShortName": "Stand Energy",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 1500,
        "TotalByShortName": 2322,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 64.6,
        "NominationPercentageOverall": 0.72,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 205,
        "ShortName": "Stand Energy",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 2322,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 205,
        "ShortName": "Stand Energy",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 272,
        "TotalByShortName": 2322,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 11.71,
        "NominationPercentageOverall": 0.13,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 205,
        "ShortName": "Stand Energy",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 275,
        "TotalByShortName": 2322,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 11.84,
        "NominationPercentageOverall": 0.13,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 205,
        "ShortName": "Stand Energy",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 275,
        "TotalByShortName": 2322,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 11.84,
        "NominationPercentageOverall": 0.13,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 205,
        "ShortName": "Stand Energy",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 2322,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 326,
        "ShortName": "Constellation New Energy",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 15411,
        "TotalByShortName": 30383,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 50.72,
        "NominationPercentageOverall": 7.44,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 326,
        "ShortName": "Constellation New Energy",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 30383,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 326,
        "ShortName": "Constellation New Energy",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 2400,
        "TotalByShortName": 30383,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 7.9,
        "NominationPercentageOverall": 1.16,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 326,
        "ShortName": "Constellation New Energy",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 8572,
        "TotalByShortName": 30383,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 28.21,
        "NominationPercentageOverall": 4.14,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 326,
        "ShortName": "Constellation New Energy",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 4000,
        "TotalByShortName": 30383,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 13.17,
        "NominationPercentageOverall": 1.93,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 326,
        "ShortName": "Constellation New Energy",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 30383,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 2128,
        "ShortName": "Shell Energy",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 2128,
        "ShortName": "Shell Energy",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 2128,
        "ShortName": "Shell Energy",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 2128,
        "ShortName": "Shell Energy",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 2128,
        "ShortName": "Shell Energy",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 2128,
        "ShortName": "Shell Energy",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 19931,
        "ShortName": "Stand Energy 2",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 19931,
        "ShortName": "Stand Energy 2",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 19931,
        "ShortName": "Stand Energy 2",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 19931,
        "ShortName": "Stand Energy 2",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 19931,
        "ShortName": "Stand Energy 2",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 19931,
        "ShortName": "Stand Energy 2",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 55635,
        "ShortName": "Indra Energy - MD - 119",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 288,
        "TotalByShortName": 288,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 100,
        "NominationPercentageOverall": 0.14,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 55635,
        "ShortName": "Indra Energy - MD - 119",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 288,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 55635,
        "ShortName": "Indra Energy - MD - 119",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 288,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 55635,
        "ShortName": "Indra Energy - MD - 119",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 288,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 55635,
        "ShortName": "Indra Energy - MD - 119",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 288,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 55635,
        "ShortName": "Indra Energy - MD - 119",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 288,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 55636,
        "ShortName": "Smart One Energy",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 55636,
        "ShortName": "Smart One Energy",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 55636,
        "ShortName": "Smart One Energy",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 55636,
        "ShortName": "Smart One Energy",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 55636,
        "ShortName": "Smart One Energy",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 55636,
        "ShortName": "Smart One Energy",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 55638,
        "ShortName": "Maryland Gas and Electric",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 672,
        "TotalByShortName": 1046,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 64.24,
        "NominationPercentageOverall": 0.32,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 55638,
        "ShortName": "Maryland Gas and Electric",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 1046,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 55638,
        "ShortName": "Maryland Gas and Electric",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 74,
        "TotalByShortName": 1046,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 7.07,
        "NominationPercentageOverall": 0.04,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 55638,
        "ShortName": "Maryland Gas and Electric",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 200,
        "TotalByShortName": 1046,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 19.12,
        "NominationPercentageOverall": 0.1,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 55638,
        "ShortName": "Maryland Gas and Electric",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 100,
        "TotalByShortName": 1046,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 9.56,
        "NominationPercentageOverall": 0.05,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 55638,
        "ShortName": "Maryland Gas and Electric",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 1046,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 58038,
        "ShortName": "EnerNoc",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 58038,
        "ShortName": "EnerNoc",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 58038,
        "ShortName": "EnerNoc",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 58038,
        "ShortName": "EnerNoc",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 58038,
        "ShortName": "EnerNoc",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 58038,
        "ShortName": "EnerNoc",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 65135,
        "ShortName": "Constellation New Energy 2",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 65135,
        "ShortName": "Constellation New Energy 2",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 65135,
        "ShortName": "Constellation New Energy 2",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 65135,
        "ShortName": "Constellation New Energy 2",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 65135,
        "ShortName": "Constellation New Energy 2",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 65135,
        "ShortName": "Constellation New Energy 2",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 70434,
        "ShortName": "Xoom Energy Maryland",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 554,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 70434,
        "ShortName": "Xoom Energy Maryland",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 554,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 70434,
        "ShortName": "Xoom Energy Maryland",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 554,
        "TotalByShortName": 554,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 100,
        "NominationPercentageOverall": 0.27,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 70434,
        "ShortName": "Xoom Energy Maryland",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 554,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 70434,
        "ShortName": "Xoom Energy Maryland",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 554,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 70434,
        "ShortName": "Xoom Energy Maryland",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 554,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 70454,
        "ShortName": "World Energy",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 70454,
        "ShortName": "World Energy",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 70454,
        "ShortName": "World Energy",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 70454,
        "ShortName": "World Energy",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 70454,
        "ShortName": "World Energy",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 70454,
        "ShortName": "World Energy",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 72875,
        "ShortName": "Energy Plus Natural Gas LLC",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 122,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 72875,
        "ShortName": "Energy Plus Natural Gas LLC",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 122,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 72875,
        "ShortName": "Energy Plus Natural Gas LLC",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 122,
        "TotalByShortName": 122,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 100,
        "NominationPercentageOverall": 0.06,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 72875,
        "ShortName": "Energy Plus Natural Gas LLC",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 122,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 72875,
        "ShortName": "Energy Plus Natural Gas LLC",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 122,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 72875,
        "ShortName": "Energy Plus Natural Gas LLC",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 122,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 73914,
        "ShortName": "Deca Energy",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 642,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 73914,
        "ShortName": "Deca Energy",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 642,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 73914,
        "ShortName": "Deca Energy",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 642,
        "TotalByShortName": 642,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 100,
        "NominationPercentageOverall": 0.31,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 73914,
        "ShortName": "Deca Energy",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 642,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 73914,
        "ShortName": "Deca Energy",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 642,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 73914,
        "ShortName": "Deca Energy",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 642,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 73915,
        "ShortName": "Ambit Energy",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 118,
        "TotalByShortName": 369,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 31.98,
        "NominationPercentageOverall": 0.06,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 73915,
        "ShortName": "Ambit Energy",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 369,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 73915,
        "ShortName": "Ambit Energy",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 50,
        "TotalByShortName": 369,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 13.55,
        "NominationPercentageOverall": 0.02,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 73915,
        "ShortName": "Ambit Energy",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 126,
        "TotalByShortName": 369,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 34.15,
        "NominationPercentageOverall": 0.06,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 73915,
        "ShortName": "Ambit Energy",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 75,
        "TotalByShortName": 369,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 20.33,
        "NominationPercentageOverall": 0.04,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 73915,
        "ShortName": "Ambit Energy",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 369,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 76734,
        "ShortName": "IGS Energy - MD - 128",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 76734,
        "ShortName": "IGS Energy - MD - 128",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 76734,
        "ShortName": "IGS Energy - MD - 128",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 76734,
        "ShortName": "IGS Energy - MD - 128",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 76734,
        "ShortName": "IGS Energy - MD - 128",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 76734,
        "ShortName": "IGS Energy - MD - 128",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 89135,
        "ShortName": "Engie Power & Gas - 135",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 2005,
        "TotalByShortName": 4175,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 48.02,
        "NominationPercentageOverall": 0.97,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 89135,
        "ShortName": "Engie Power & Gas - 135",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 4175,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 89135,
        "ShortName": "Engie Power & Gas - 135",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 300,
        "TotalByShortName": 4175,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 7.19,
        "NominationPercentageOverall": 0.14,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 89135,
        "ShortName": "Engie Power & Gas - 135",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 1249,
        "TotalByShortName": 4175,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 29.92,
        "NominationPercentageOverall": 0.6,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 89135,
        "ShortName": "Engie Power & Gas - 135",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 621,
        "TotalByShortName": 4175,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 14.87,
        "NominationPercentageOverall": 0.3,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 89135,
        "ShortName": "Engie Power & Gas - 135",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 4175,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 90954,
        "ShortName": "Constellation Energy Gas Choice",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 90954,
        "ShortName": "Constellation Energy Gas Choice",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 90954,
        "ShortName": "Constellation Energy Gas Choice",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 90954,
        "ShortName": "Constellation Energy Gas Choice",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 90954,
        "ShortName": "Constellation Energy Gas Choice",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 90954,
        "ShortName": "Constellation Energy Gas Choice",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 100535,
        "ShortName": "Viridian Energy",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 44,
        "TotalByShortName": 44,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 100,
        "NominationPercentageOverall": 0.02,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 100535,
        "ShortName": "Viridian Energy",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 44,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 100535,
        "ShortName": "Viridian Energy",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 44,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 100535,
        "ShortName": "Viridian Energy",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 44,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 100535,
        "ShortName": "Viridian Energy",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 44,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 100535,
        "ShortName": "Viridian Energy",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 44,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 100554,
        "ShortName": "Xoom Energy",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 137,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 100554,
        "ShortName": "Xoom Energy",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 137,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 100554,
        "ShortName": "Xoom Energy",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 137,
        "TotalByShortName": 137,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 100,
        "NominationPercentageOverall": 0.07,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 100554,
        "ShortName": "Xoom Energy",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 137,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 100554,
        "ShortName": "Xoom Energy",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 137,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 100554,
        "ShortName": "Xoom Energy",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 137,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 100914,
        "ShortName": "NRG Business Market,LLC - 145",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 19238,
        "TotalByShortName": 25651,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 75,
        "NominationPercentageOverall": 9.28,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 100914,
        "ShortName": "NRG Business Market,LLC - 145",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 25651,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 100914,
        "ShortName": "NRG Business Market,LLC - 145",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 2565,
        "TotalByShortName": 25651,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 10,
        "NominationPercentageOverall": 1.24,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 100914,
        "ShortName": "NRG Business Market,LLC - 145",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 2565,
        "TotalByShortName": 25651,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 10,
        "NominationPercentageOverall": 1.24,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 100914,
        "ShortName": "NRG Business Market,LLC - 145",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 1283,
        "TotalByShortName": 25651,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 5,
        "NominationPercentageOverall": 0.62,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 100914,
        "ShortName": "NRG Business Market,LLC - 145",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 25651,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 103174,
        "ShortName": "Engie Power & Gas - 144",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 103174,
        "ShortName": "Engie Power & Gas - 144",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 103174,
        "ShortName": "Engie Power & Gas - 144",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 103174,
        "ShortName": "Engie Power & Gas - 144",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 103174,
        "ShortName": "Engie Power & Gas - 144",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 103174,
        "ShortName": "Engie Power & Gas - 144",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 104474,
        "ShortName": "Stand Energy UCB RR",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 104474,
        "ShortName": "Stand Energy UCB RR",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 104474,
        "ShortName": "Stand Energy UCB RR",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 104474,
        "ShortName": "Stand Energy UCB RR",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 104474,
        "ShortName": "Stand Energy UCB RR",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 104474,
        "ShortName": "Stand Energy UCB RR",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 122214,
        "ShortName": "Enspire Energy",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 699,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 122214,
        "ShortName": "Enspire Energy",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 699,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 122214,
        "ShortName": "Enspire Energy",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 699,
        "TotalByShortName": 699,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 100,
        "NominationPercentageOverall": 0.34,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 122214,
        "ShortName": "Enspire Energy",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 699,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 122214,
        "ShortName": "Enspire Energy",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 699,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 122214,
        "ShortName": "Enspire Energy",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 699,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 123275,
        "ShortName": "CEGC",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 123275,
        "ShortName": "CEGC",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 123275,
        "ShortName": "CEGC",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 123275,
        "ShortName": "CEGC",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 123275,
        "ShortName": "CEGC",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 123275,
        "ShortName": "CEGC",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 136034,
        "ShortName": "Direct Energy Services,LLC-156",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 219,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 136034,
        "ShortName": "Direct Energy Services,LLC-156",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 219,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 136034,
        "ShortName": "Direct Energy Services,LLC-156",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 219,
        "TotalByShortName": 219,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 100,
        "NominationPercentageOverall": 0.11,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 136034,
        "ShortName": "Direct Energy Services,LLC-156",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 219,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 136034,
        "ShortName": "Direct Energy Services,LLC-156",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 219,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 136034,
        "ShortName": "Direct Energy Services,LLC-156",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 219,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 142214,
        "ShortName": "SFE Energy",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 1279,
        "TotalByShortName": 1279,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 100,
        "NominationPercentageOverall": 0.62,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 142214,
        "ShortName": "SFE Energy",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 1279,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 142214,
        "ShortName": "SFE Energy",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 1279,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 142214,
        "ShortName": "SFE Energy",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 1279,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 142214,
        "ShortName": "SFE Energy",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 1279,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 142214,
        "ShortName": "SFE Energy",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 1279,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 142215,
        "ShortName": "AGERA Energy - 159",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 142215,
        "ShortName": "AGERA Energy - 159",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 142215,
        "ShortName": "AGERA Energy - 159",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 142215,
        "ShortName": "AGERA Energy - 159",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 142215,
        "ShortName": "AGERA Energy - 159",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 142215,
        "ShortName": "AGERA Energy - 159",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 142216,
        "ShortName": "AGERA Energy - 160",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 142216,
        "ShortName": "AGERA Energy - 160",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 142216,
        "ShortName": "AGERA Energy - 160",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 142216,
        "ShortName": "AGERA Energy - 160",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 142216,
        "ShortName": "AGERA Energy - 160",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 142216,
        "ShortName": "AGERA Energy - 160",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 142876,
        "ShortName": "NOVEC Energy Solutions – 164",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 142876,
        "ShortName": "NOVEC Energy Solutions – 164",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 142876,
        "ShortName": "NOVEC Energy Solutions – 164",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 142876,
        "ShortName": "NOVEC Energy Solutions – 164",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 142876,
        "ShortName": "NOVEC Energy Solutions – 164",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 142876,
        "ShortName": "NOVEC Energy Solutions – 164",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 142895,
        "ShortName": "Dominion Energy Solutions - 150",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 142895,
        "ShortName": "Dominion Energy Solutions - 150",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 142895,
        "ShortName": "Dominion Energy Solutions - 150",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 142895,
        "ShortName": "Dominion Energy Solutions - 150",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 142895,
        "ShortName": "Dominion Energy Solutions - 150",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 142895,
        "ShortName": "Dominion Energy Solutions - 150",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 142909,
        "ShortName": "MAJOR Energy",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 30,
        "TotalByShortName": 30,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 100,
        "NominationPercentageOverall": 0.01,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 142909,
        "ShortName": "MAJOR Energy",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 30,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 142909,
        "ShortName": "MAJOR Energy",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 30,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 142909,
        "ShortName": "MAJOR Energy",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 30,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 142909,
        "ShortName": "MAJOR Energy",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 30,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 142909,
        "ShortName": "MAJOR Energy",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 30,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 142922,
        "ShortName": "NRG Home",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 220,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 142922,
        "ShortName": "NRG Home",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 220,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 142922,
        "ShortName": "NRG Home",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 220,
        "TotalByShortName": 220,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 100,
        "NominationPercentageOverall": 0.11,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 142922,
        "ShortName": "NRG Home",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 220,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 142922,
        "ShortName": "NRG Home",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 220,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 142922,
        "ShortName": "NRG Home",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 220,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 142936,
        "ShortName": "Mansfield Power and Gas LLC",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 142936,
        "ShortName": "Mansfield Power and Gas LLC",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 142936,
        "ShortName": "Mansfield Power and Gas LLC",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 142936,
        "ShortName": "Mansfield Power and Gas LLC",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 142936,
        "ShortName": "Mansfield Power and Gas LLC",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 142936,
        "ShortName": "Mansfield Power and Gas LLC",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 142939,
        "ShortName": "Just Energy",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 142939,
        "ShortName": "Just Energy",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 142939,
        "ShortName": "Just Energy",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 142939,
        "ShortName": "Just Energy",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 142939,
        "ShortName": "Just Energy",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 142939,
        "ShortName": "Just Energy",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 142941,
        "ShortName": "Shipley Energy",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 142941,
        "ShortName": "Shipley Energy",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 142941,
        "ShortName": "Shipley Energy",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 142941,
        "ShortName": "Shipley Energy",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 142941,
        "ShortName": "Shipley Energy",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 142941,
        "ShortName": "Shipley Energy",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 142942,
        "ShortName": "Planet Energy",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 142942,
        "ShortName": "Planet Energy",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 142942,
        "ShortName": "Planet Energy",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 142942,
        "ShortName": "Planet Energy",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 142942,
        "ShortName": "Planet Energy",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 142942,
        "ShortName": "Planet Energy",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 142943,
        "ShortName": "Spring Power & Gas",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 31,
        "TotalByShortName": 31,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 100,
        "NominationPercentageOverall": 0.01,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 142943,
        "ShortName": "Spring Power & Gas",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 31,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 142943,
        "ShortName": "Spring Power & Gas",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 31,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 142943,
        "ShortName": "Spring Power & Gas",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 31,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 142943,
        "ShortName": "Spring Power & Gas",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 31,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 142943,
        "ShortName": "Spring Power & Gas",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 31,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 142944,
        "ShortName": "Twin Eagle Energy",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 142944,
        "ShortName": "Twin Eagle Energy",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 142944,
        "ShortName": "Twin Eagle Energy",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 142944,
        "ShortName": "Twin Eagle Energy",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 142944,
        "ShortName": "Twin Eagle Energy",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 142944,
        "ShortName": "Twin Eagle Energy",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 142968,
        "ShortName": "Indra Energy - DC - 169",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 95,
        "TotalByShortName": 95,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 100,
        "NominationPercentageOverall": 0.05,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 142968,
        "ShortName": "Indra Energy - DC - 169",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 95,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 142968,
        "ShortName": "Indra Energy - DC - 169",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 95,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 142968,
        "ShortName": "Indra Energy - DC - 169",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 95,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 142968,
        "ShortName": "Indra Energy - DC - 169",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 95,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 142968,
        "ShortName": "Indra Energy - DC - 169",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 95,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 142969,
        "ShortName": "Indra Energy - VA - 170",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 100,
        "TotalByShortName": 100,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 100,
        "NominationPercentageOverall": 0.05,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 142969,
        "ShortName": "Indra Energy - VA - 170",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 100,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 142969,
        "ShortName": "Indra Energy - VA - 170",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 100,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 142969,
        "ShortName": "Indra Energy - VA - 170",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 100,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 142969,
        "ShortName": "Indra Energy - VA - 170",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 100,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 142969,
        "ShortName": "Indra Energy - VA - 170",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 100,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 142983,
        "ShortName": "Viridian Energy DUAL",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 142983,
        "ShortName": "Viridian Energy DUAL",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 142983,
        "ShortName": "Viridian Energy DUAL",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 142983,
        "ShortName": "Viridian Energy DUAL",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 142983,
        "ShortName": "Viridian Energy DUAL",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 142983,
        "ShortName": "Viridian Energy DUAL",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 142984,
        "ShortName": "Viridian Energy UCB BR",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 142984,
        "ShortName": "Viridian Energy UCB BR",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 142984,
        "ShortName": "Viridian Energy UCB BR",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 142984,
        "ShortName": "Viridian Energy UCB BR",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 142984,
        "ShortName": "Viridian Energy UCB BR",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 142984,
        "ShortName": "Viridian Energy UCB BR",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 142985,
        "ShortName": "Engie Power & Gas - 173",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 142985,
        "ShortName": "Engie Power & Gas - 173",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 142985,
        "ShortName": "Engie Power & Gas - 173",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 142985,
        "ShortName": "Engie Power & Gas - 173",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 142985,
        "ShortName": "Engie Power & Gas - 173",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 142985,
        "ShortName": "Engie Power & Gas - 173",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 142991,
        "ShortName": "IDT Energy",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 426,
        "TotalByShortName": 426,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 100,
        "NominationPercentageOverall": 0.21,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 142991,
        "ShortName": "IDT Energy",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 426,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 142991,
        "ShortName": "IDT Energy",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 426,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 142991,
        "ShortName": "IDT Energy",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 426,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 142991,
        "ShortName": "IDT Energy",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 426,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 142991,
        "ShortName": "IDT Energy",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 426,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 142992,
        "ShortName": "MPower Energy NJ LLC",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 759,
        "TotalByShortName": 759,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 100,
        "NominationPercentageOverall": 0.37,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 142992,
        "ShortName": "MPower Energy NJ LLC",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 759,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 142992,
        "ShortName": "MPower Energy NJ LLC",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 759,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 142992,
        "ShortName": "MPower Energy NJ LLC",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 759,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 142992,
        "ShortName": "MPower Energy NJ LLC",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 759,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 142992,
        "ShortName": "MPower Energy NJ LLC",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 759,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 142993,
        "ShortName": "PESCO Energy - 175",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 142993,
        "ShortName": "PESCO Energy - 175",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 142993,
        "ShortName": "PESCO Energy - 175",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 142993,
        "ShortName": "PESCO Energy - 175",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 142993,
        "ShortName": "PESCO Energy - 175",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 142993,
        "ShortName": "PESCO Energy - 175",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 142994,
        "ShortName": "PESCO Energy - 176",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 142994,
        "ShortName": "PESCO Energy - 176",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 142994,
        "ShortName": "PESCO Energy - 176",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 142994,
        "ShortName": "PESCO Energy - 176",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 142994,
        "ShortName": "PESCO Energy - 176",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 142994,
        "ShortName": "PESCO Energy - 176",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 142995,
        "ShortName": "Think Energy",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 142995,
        "ShortName": "Think Energy",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 142995,
        "ShortName": "Think Energy",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 142995,
        "ShortName": "Think Energy",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 142995,
        "ShortName": "Think Energy",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 142995,
        "ShortName": "Think Energy",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 142996,
        "ShortName": "Virginia Retail Energy - 178",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 142996,
        "ShortName": "Virginia Retail Energy - 178",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 142996,
        "ShortName": "Virginia Retail Energy - 178",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 142996,
        "ShortName": "Virginia Retail Energy - 178",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 142996,
        "ShortName": "Virginia Retail Energy - 178",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 142996,
        "ShortName": "Virginia Retail Energy - 178",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 142997,
        "ShortName": "Virginia Retail Energy - 179",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 142997,
        "ShortName": "Virginia Retail Energy - 179",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 142997,
        "ShortName": "Virginia Retail Energy - 179",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 142997,
        "ShortName": "Virginia Retail Energy - 179",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 142997,
        "ShortName": "Virginia Retail Energy - 179",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 142997,
        "ShortName": "Virginia Retail Energy - 179",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 142998,
        "ShortName": "Stand Energy - 180",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 142998,
        "ShortName": "Stand Energy - 180",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 142998,
        "ShortName": "Stand Energy - 180",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 142998,
        "ShortName": "Stand Energy - 180",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 142998,
        "ShortName": "Stand Energy - 180",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 142998,
        "ShortName": "Stand Energy - 180",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 142999,
        "ShortName": "Stand Energy - 181",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 142999,
        "ShortName": "Stand Energy - 181",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 142999,
        "ShortName": "Stand Energy - 181",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 142999,
        "ShortName": "Stand Energy - 181",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 142999,
        "ShortName": "Stand Energy - 181",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 142999,
        "ShortName": "Stand Energy - 181",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143009,
        "ShortName": "Clearview Energy",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 143009,
        "ShortName": "Clearview Energy",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143009,
        "ShortName": "Clearview Energy",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 143009,
        "ShortName": "Clearview Energy",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 143009,
        "ShortName": "Clearview Energy",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143009,
        "ShortName": "Clearview Energy",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143010,
        "ShortName": "South Jersey Energy Corp - 184",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 143010,
        "ShortName": "South Jersey Energy Corp - 184",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143010,
        "ShortName": "South Jersey Energy Corp - 184",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 143010,
        "ShortName": "South Jersey Energy Corp - 184",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 143010,
        "ShortName": "South Jersey Energy Corp - 184",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143010,
        "ShortName": "South Jersey Energy Corp - 184",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143011,
        "ShortName": "South Jersey Energy Corp - 185",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 143011,
        "ShortName": "South Jersey Energy Corp - 185",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143011,
        "ShortName": "South Jersey Energy Corp - 185",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 143011,
        "ShortName": "South Jersey Energy Corp - 185",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 143011,
        "ShortName": "South Jersey Energy Corp - 185",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143011,
        "ShortName": "South Jersey Energy Corp - 185",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143012,
        "ShortName": "Indra Energy - MD - 186",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 143012,
        "ShortName": "Indra Energy - MD - 186",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143012,
        "ShortName": "Indra Energy - MD - 186",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 143012,
        "ShortName": "Indra Energy - MD - 186",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 143012,
        "ShortName": "Indra Energy - MD - 186",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143012,
        "ShortName": "Indra Energy - MD - 186",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143013,
        "ShortName": "Tomorrow Energy Corp",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 139,
        "TotalByShortName": 139,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 100,
        "NominationPercentageOverall": 0.07,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 143013,
        "ShortName": "Tomorrow Energy Corp",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 139,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143013,
        "ShortName": "Tomorrow Energy Corp",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 139,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 143013,
        "ShortName": "Tomorrow Energy Corp",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 139,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 143013,
        "ShortName": "Tomorrow Energy Corp",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 139,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143013,
        "ShortName": "Tomorrow Energy Corp",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 139,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143014,
        "ShortName": "Think Energy - 188",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 143014,
        "ShortName": "Think Energy - 188",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143014,
        "ShortName": "Think Energy - 188",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 143014,
        "ShortName": "Think Energy - 188",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 143014,
        "ShortName": "Think Energy - 188",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143014,
        "ShortName": "Think Energy - 188",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143015,
        "ShortName": "American Power & Gas",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 100,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 143015,
        "ShortName": "American Power & Gas",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 100,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143015,
        "ShortName": "American Power & Gas",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 100,
        "TotalByShortName": 100,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 100,
        "NominationPercentageOverall": 0.05,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 143015,
        "ShortName": "American Power & Gas",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 100,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 143015,
        "ShortName": "American Power & Gas",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 100,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143015,
        "ShortName": "American Power & Gas",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 100,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143016,
        "ShortName": "Atlantic Energy",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 258,
        "TotalByShortName": 258,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 100,
        "NominationPercentageOverall": 0.12,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 143016,
        "ShortName": "Atlantic Energy",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 258,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143016,
        "ShortName": "Atlantic Energy",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 258,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 143016,
        "ShortName": "Atlantic Energy",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 258,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 143016,
        "ShortName": "Atlantic Energy",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 258,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143016,
        "ShortName": "Atlantic Energy",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 258,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143017,
        "ShortName": "Median Energy",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 139,
        "TotalByShortName": 139,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 100,
        "NominationPercentageOverall": 0.07,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 143017,
        "ShortName": "Median Energy",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 139,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143017,
        "ShortName": "Median Energy",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 139,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 143017,
        "ShortName": "Median Energy",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 139,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 143017,
        "ShortName": "Median Energy",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 139,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143017,
        "ShortName": "Median Energy",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 139,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143027,
        "ShortName": "Josco Energy - 192",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 143027,
        "ShortName": "Josco Energy - 192",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143027,
        "ShortName": "Josco Energy - 192",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 143027,
        "ShortName": "Josco Energy - 192",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 143027,
        "ShortName": "Josco Energy - 192",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143027,
        "ShortName": "Josco Energy - 192",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143028,
        "ShortName": "Josco Energy - 193",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 143028,
        "ShortName": "Josco Energy - 193",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143028,
        "ShortName": "Josco Energy - 193",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 143028,
        "ShortName": "Josco Energy - 193",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 143028,
        "ShortName": "Josco Energy - 193",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143028,
        "ShortName": "Josco Energy - 193",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143029,
        "ShortName": "CleanSky Energy - DC and MD - 194",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 168,
        "TotalByShortName": 168,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 100,
        "NominationPercentageOverall": 0.08,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 143029,
        "ShortName": "CleanSky Energy - DC and MD - 194",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 168,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143029,
        "ShortName": "CleanSky Energy - DC and MD - 194",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 168,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 143029,
        "ShortName": "CleanSky Energy - DC and MD - 194",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 168,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 143029,
        "ShortName": "CleanSky Energy - DC and MD - 194",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 168,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143029,
        "ShortName": "CleanSky Energy - DC and MD - 194",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 168,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143030,
        "ShortName": "CleanSky Energy - DC and MD - 195",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 143030,
        "ShortName": "CleanSky Energy - DC and MD - 195",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143030,
        "ShortName": "CleanSky Energy - DC and MD - 195",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 143030,
        "ShortName": "CleanSky Energy - DC and MD - 195",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 143030,
        "ShortName": "CleanSky Energy - DC and MD - 195",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143030,
        "ShortName": "CleanSky Energy - DC and MD - 195",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143039,
        "ShortName": "UGI Energy Services - 197",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 143039,
        "ShortName": "UGI Energy Services - 197",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143039,
        "ShortName": "UGI Energy Services - 197",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 143039,
        "ShortName": "UGI Energy Services - 197",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 143039,
        "ShortName": "UGI Energy Services - 197",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143039,
        "ShortName": "UGI Energy Services - 197",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143040,
        "ShortName": "Indra Energy - MD - 198",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 143040,
        "ShortName": "Indra Energy - MD - 198",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143040,
        "ShortName": "Indra Energy - MD - 198",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 143040,
        "ShortName": "Indra Energy - MD - 198",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 143040,
        "ShortName": "Indra Energy - MD - 198",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143040,
        "ShortName": "Indra Energy - MD - 198",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143041,
        "ShortName": "Indra Energy - MD - 199",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 143041,
        "ShortName": "Indra Energy - MD - 199",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143041,
        "ShortName": "Indra Energy - MD - 199",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 143041,
        "ShortName": "Indra Energy - MD - 199",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 143041,
        "ShortName": "Indra Energy - MD - 199",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143041,
        "ShortName": "Indra Energy - MD - 199",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143042,
        "ShortName": "Indra Energy - DC - 200",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 143042,
        "ShortName": "Indra Energy - DC - 200",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143042,
        "ShortName": "Indra Energy - DC - 200",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 143042,
        "ShortName": "Indra Energy - DC - 200",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 143042,
        "ShortName": "Indra Energy - DC - 200",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143042,
        "ShortName": "Indra Energy - DC - 200",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143043,
        "ShortName": "Indra Energy - DC - 201",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 143043,
        "ShortName": "Indra Energy - DC - 201",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143043,
        "ShortName": "Indra Energy - DC - 201",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 143043,
        "ShortName": "Indra Energy - DC - 201",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 143043,
        "ShortName": "Indra Energy - DC - 201",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143043,
        "ShortName": "Indra Energy - DC - 201",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143044,
        "ShortName": "Indra Energy - VA - 202",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 143044,
        "ShortName": "Indra Energy - VA - 202",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143044,
        "ShortName": "Indra Energy - VA - 202",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 143044,
        "ShortName": "Indra Energy - VA - 202",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 143044,
        "ShortName": "Indra Energy - VA - 202",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143044,
        "ShortName": "Indra Energy - VA - 202",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143045,
        "ShortName": "Indra Energy - VA - 203",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 143045,
        "ShortName": "Indra Energy - VA - 203",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143045,
        "ShortName": "Indra Energy - VA - 203",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 143045,
        "ShortName": "Indra Energy - VA - 203",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 143045,
        "ShortName": "Indra Energy - VA - 203",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143045,
        "ShortName": "Indra Energy - VA - 203",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143049,
        "ShortName": "Park Power LLC - DC - 204",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 29,
        "TotalByShortName": 29,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 100,
        "NominationPercentageOverall": 0.01,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 143049,
        "ShortName": "Park Power LLC - DC - 204",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 29,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143049,
        "ShortName": "Park Power LLC - DC - 204",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 29,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 143049,
        "ShortName": "Park Power LLC - DC - 204",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 29,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 143049,
        "ShortName": "Park Power LLC - DC - 204",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 29,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143049,
        "ShortName": "Park Power LLC - DC - 204",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 29,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143050,
        "ShortName": "Park Power LLC - DC - 205",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 143050,
        "ShortName": "Park Power LLC - DC - 205",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143050,
        "ShortName": "Park Power LLC - DC - 205",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 143050,
        "ShortName": "Park Power LLC - DC - 205",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 143050,
        "ShortName": "Park Power LLC - DC - 205",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143050,
        "ShortName": "Park Power LLC - DC - 205",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143051,
        "ShortName": "Park Power LLC - DC - 206",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 143051,
        "ShortName": "Park Power LLC - DC - 206",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143051,
        "ShortName": "Park Power LLC - DC - 206",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 143051,
        "ShortName": "Park Power LLC - DC - 206",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 143051,
        "ShortName": "Park Power LLC - DC - 206",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143051,
        "ShortName": "Park Power LLC - DC - 206",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143063,
        "ShortName": "East Coast Power & Gas - MD - 207",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 143063,
        "ShortName": "East Coast Power & Gas - MD - 207",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143063,
        "ShortName": "East Coast Power & Gas - MD - 207",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 143063,
        "ShortName": "East Coast Power & Gas - MD - 207",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 143063,
        "ShortName": "East Coast Power & Gas - MD - 207",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143063,
        "ShortName": "East Coast Power & Gas - MD - 207",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143064,
        "ShortName": "East Coast Power & Gas - MD - 208",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 143064,
        "ShortName": "East Coast Power & Gas - MD - 208",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143064,
        "ShortName": "East Coast Power & Gas - MD - 208",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 143064,
        "ShortName": "East Coast Power & Gas - MD - 208",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 143064,
        "ShortName": "East Coast Power & Gas - MD - 208",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143064,
        "ShortName": "East Coast Power & Gas - MD - 208",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143065,
        "ShortName": "East Coast Power & Gas - MD - 209",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 143065,
        "ShortName": "East Coast Power & Gas - MD - 209",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143065,
        "ShortName": "East Coast Power & Gas - MD - 209",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 143065,
        "ShortName": "East Coast Power & Gas - MD - 209",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 143065,
        "ShortName": "East Coast Power & Gas - MD - 209",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143065,
        "ShortName": "East Coast Power & Gas - MD - 209",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143066,
        "ShortName": "Statewise Energy - MD - 210",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 196,
        "TotalByShortName": 196,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 100,
        "NominationPercentageOverall": 0.09,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 143066,
        "ShortName": "Statewise Energy - MD - 210",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 196,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143066,
        "ShortName": "Statewise Energy - MD - 210",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 196,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 143066,
        "ShortName": "Statewise Energy - MD - 210",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 196,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 143066,
        "ShortName": "Statewise Energy - MD - 210",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 196,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143066,
        "ShortName": "Statewise Energy - MD - 210",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 196,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143087,
        "ShortName": "Statewise Energy - MD - 211",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 143087,
        "ShortName": "Statewise Energy - MD - 211",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143087,
        "ShortName": "Statewise Energy - MD - 211",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 143087,
        "ShortName": "Statewise Energy - MD - 211",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 143087,
        "ShortName": "Statewise Energy - MD - 211",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143087,
        "ShortName": "Statewise Energy - MD - 211",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143099,
        "ShortName": "NRG Business Market,LLC - 212",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 143099,
        "ShortName": "NRG Business Market,LLC - 212",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143099,
        "ShortName": "NRG Business Market,LLC - 212",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 143099,
        "ShortName": "NRG Business Market,LLC - 212",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 143099,
        "ShortName": "NRG Business Market,LLC - 212",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143099,
        "ShortName": "NRG Business Market,LLC - 212",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143100,
        "ShortName": "NRG Business Market,LLC - 213",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 143100,
        "ShortName": "NRG Business Market,LLC - 213",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143100,
        "ShortName": "NRG Business Market,LLC - 213",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 143100,
        "ShortName": "NRG Business Market,LLC - 213",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 143100,
        "ShortName": "NRG Business Market,LLC - 213",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143100,
        "ShortName": "NRG Business Market,LLC - 213",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143101,
        "ShortName": "NRG Business Market,LLC - 214",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 143101,
        "ShortName": "NRG Business Market,LLC - 214",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143101,
        "ShortName": "NRG Business Market,LLC - 214",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 143101,
        "ShortName": "NRG Business Market,LLC - 214",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 143101,
        "ShortName": "NRG Business Market,LLC - 214",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143101,
        "ShortName": "NRG Business Market,LLC - 214",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143113,
        "ShortName": "Nordic Energy Services - 215",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 69,
        "TotalByShortName": 69,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 100,
        "NominationPercentageOverall": 0.03,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 143113,
        "ShortName": "Nordic Energy Services - 215",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 69,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143113,
        "ShortName": "Nordic Energy Services - 215",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 69,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 143113,
        "ShortName": "Nordic Energy Services - 215",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 69,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 143113,
        "ShortName": "Nordic Energy Services - 215",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 69,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143113,
        "ShortName": "Nordic Energy Services - 215",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 69,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143114,
        "ShortName": "Nordic Energy Services - 216",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 143114,
        "ShortName": "Nordic Energy Services - 216",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143114,
        "ShortName": "Nordic Energy Services - 216",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 143114,
        "ShortName": "Nordic Energy Services - 216",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 143114,
        "ShortName": "Nordic Energy Services - 216",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143114,
        "ShortName": "Nordic Energy Services - 216",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143115,
        "ShortName": "Nordic Energy Services - 217",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 143115,
        "ShortName": "Nordic Energy Services - 217",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143115,
        "ShortName": "Nordic Energy Services - 217",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 143115,
        "ShortName": "Nordic Energy Services - 217",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 143115,
        "ShortName": "Nordic Energy Services - 217",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143115,
        "ShortName": "Nordic Energy Services - 217",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143116,
        "ShortName": "Nordic Energy Services - 218",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 143116,
        "ShortName": "Nordic Energy Services - 218",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143116,
        "ShortName": "Nordic Energy Services - 218",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 143116,
        "ShortName": "Nordic Energy Services - 218",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 143116,
        "ShortName": "Nordic Energy Services - 218",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143116,
        "ShortName": "Nordic Energy Services - 218",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143117,
        "ShortName": "SunSea Energy - DC - 219",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 143117,
        "ShortName": "SunSea Energy - DC - 219",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143117,
        "ShortName": "SunSea Energy - DC - 219",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 143117,
        "ShortName": "SunSea Energy - DC - 219",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 143117,
        "ShortName": "SunSea Energy - DC - 219",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143117,
        "ShortName": "SunSea Energy - DC - 219",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143118,
        "ShortName": "SunSea Energy - DC - 220",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 143118,
        "ShortName": "SunSea Energy - DC - 220",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143118,
        "ShortName": "SunSea Energy - DC - 220",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 143118,
        "ShortName": "SunSea Energy - DC - 220",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 143118,
        "ShortName": "SunSea Energy - DC - 220",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143118,
        "ShortName": "SunSea Energy - DC - 220",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143119,
        "ShortName": "SunSea Energy - DC - 221",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 143119,
        "ShortName": "SunSea Energy - DC - 221",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143119,
        "ShortName": "SunSea Energy - DC - 221",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 143119,
        "ShortName": "SunSea Energy - DC - 221",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 143119,
        "ShortName": "SunSea Energy - DC - 221",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143119,
        "ShortName": "SunSea Energy - DC - 221",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143120,
        "ShortName": "SunSea Energy - DC - 222",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 143120,
        "ShortName": "SunSea Energy - DC - 222",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143120,
        "ShortName": "SunSea Energy - DC - 222",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 143120,
        "ShortName": "SunSea Energy - DC - 222",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 143120,
        "ShortName": "SunSea Energy - DC - 222",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143120,
        "ShortName": "SunSea Energy - DC - 222",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143121,
        "ShortName": "SunSea Energy - MD & VA - 223",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 143121,
        "ShortName": "SunSea Energy - MD & VA - 223",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143121,
        "ShortName": "SunSea Energy - MD & VA - 223",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 143121,
        "ShortName": "SunSea Energy - MD & VA - 223",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 143121,
        "ShortName": "SunSea Energy - MD & VA - 223",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143121,
        "ShortName": "SunSea Energy - MD & VA - 223",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143122,
        "ShortName": "SunSea Energy - MD & VA - 224",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 143122,
        "ShortName": "SunSea Energy - MD & VA - 224",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143122,
        "ShortName": "SunSea Energy - MD & VA - 224",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 143122,
        "ShortName": "SunSea Energy - MD & VA - 224",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 143122,
        "ShortName": "SunSea Energy - MD & VA - 224",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143122,
        "ShortName": "SunSea Energy - MD & VA - 224",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143123,
        "ShortName": "SunSea Energy - MD & VA - 225",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 143123,
        "ShortName": "SunSea Energy - MD & VA - 225",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143123,
        "ShortName": "SunSea Energy - MD & VA - 225",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 143123,
        "ShortName": "SunSea Energy - MD & VA - 225",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 143123,
        "ShortName": "SunSea Energy - MD & VA - 225",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143123,
        "ShortName": "SunSea Energy - MD & VA - 225",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143124,
        "ShortName": "SunSea Energy - MD & VA - 226",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 143124,
        "ShortName": "SunSea Energy - MD & VA - 226",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143124,
        "ShortName": "SunSea Energy - MD & VA - 226",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 143124,
        "ShortName": "SunSea Energy - MD & VA - 226",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 143124,
        "ShortName": "SunSea Energy - MD & VA - 226",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143124,
        "ShortName": "SunSea Energy - MD & VA - 226",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143125,
        "ShortName": "Alpha Gas and Electric - DC - 227",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 4,
        "TotalByShortName": 4,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 100,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 143125,
        "ShortName": "Alpha Gas and Electric - DC - 227",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 4,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143125,
        "ShortName": "Alpha Gas and Electric - DC - 227",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 4,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 143125,
        "ShortName": "Alpha Gas and Electric - DC - 227",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 4,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 143125,
        "ShortName": "Alpha Gas and Electric - DC - 227",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 4,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143125,
        "ShortName": "Alpha Gas and Electric - DC - 227",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 4,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143127,
        "ShortName": "Alpha Gas and Electric - DC - 229",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 143127,
        "ShortName": "Alpha Gas and Electric - DC - 229",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143127,
        "ShortName": "Alpha Gas and Electric - DC - 229",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 143127,
        "ShortName": "Alpha Gas and Electric - DC - 229",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 143127,
        "ShortName": "Alpha Gas and Electric - DC - 229",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143127,
        "ShortName": "Alpha Gas and Electric - DC - 229",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143128,
        "ShortName": "Alpha Gas and Electric - VA - 230",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 143128,
        "ShortName": "Alpha Gas and Electric - VA - 230",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143128,
        "ShortName": "Alpha Gas and Electric - VA - 230",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 143128,
        "ShortName": "Alpha Gas and Electric - VA - 230",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 143128,
        "ShortName": "Alpha Gas and Electric - VA - 230",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143128,
        "ShortName": "Alpha Gas and Electric - VA - 230",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143129,
        "ShortName": "Alpha Gas and Electric - DC - 231",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 143129,
        "ShortName": "Alpha Gas and Electric - DC - 231",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143129,
        "ShortName": "Alpha Gas and Electric - DC - 231",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 143129,
        "ShortName": "Alpha Gas and Electric - DC - 231",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 143129,
        "ShortName": "Alpha Gas and Electric - DC - 231",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143129,
        "ShortName": "Alpha Gas and Electric - DC - 231",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143130,
        "ShortName": "Alpha Gas and Electric - VA - 232",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 143130,
        "ShortName": "Alpha Gas and Electric - VA - 232",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143130,
        "ShortName": "Alpha Gas and Electric - VA - 232",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 143130,
        "ShortName": "Alpha Gas and Electric - VA - 232",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 143130,
        "ShortName": "Alpha Gas and Electric - VA - 232",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143130,
        "ShortName": "Alpha Gas and Electric - VA - 232",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143132,
        "ShortName": "Alpha Gas and Electric - VA - 234",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 143132,
        "ShortName": "Alpha Gas and Electric - VA - 234",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143132,
        "ShortName": "Alpha Gas and Electric - VA - 234",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 143132,
        "ShortName": "Alpha Gas and Electric - VA - 234",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 143132,
        "ShortName": "Alpha Gas and Electric - VA - 234",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143132,
        "ShortName": "Alpha Gas and Electric - VA - 234",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143133,
        "ShortName": "Alpha Gas and Electric - MD - 235",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 32,
        "TotalByShortName": 32,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 100,
        "NominationPercentageOverall": 0.02,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 143133,
        "ShortName": "Alpha Gas and Electric - MD - 235",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 32,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143133,
        "ShortName": "Alpha Gas and Electric - MD - 235",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 32,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 143133,
        "ShortName": "Alpha Gas and Electric - MD - 235",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 32,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 143133,
        "ShortName": "Alpha Gas and Electric - MD - 235",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 32,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143133,
        "ShortName": "Alpha Gas and Electric - MD - 235",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 32,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143134,
        "ShortName": "Alpha Gas and Electric - MD - 236",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 143134,
        "ShortName": "Alpha Gas and Electric - MD - 236",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143134,
        "ShortName": "Alpha Gas and Electric - MD - 236",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 143134,
        "ShortName": "Alpha Gas and Electric - MD - 236",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 143134,
        "ShortName": "Alpha Gas and Electric - MD - 236",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143134,
        "ShortName": "Alpha Gas and Electric - MD - 236",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143135,
        "ShortName": "Alpha Gas and Electric - MD - 237",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 143135,
        "ShortName": "Alpha Gas and Electric - MD - 237",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143135,
        "ShortName": "Alpha Gas and Electric - MD - 237",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 143135,
        "ShortName": "Alpha Gas and Electric - MD - 237",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 143135,
        "ShortName": "Alpha Gas and Electric - MD - 237",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143135,
        "ShortName": "Alpha Gas and Electric - MD - 237",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143136,
        "ShortName": "Alpha Gas and Electric - MD - 238",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 143136,
        "ShortName": "Alpha Gas and Electric - MD - 238",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143136,
        "ShortName": "Alpha Gas and Electric - MD - 238",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 143136,
        "ShortName": "Alpha Gas and Electric - MD - 238",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 143136,
        "ShortName": "Alpha Gas and Electric - MD - 238",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143136,
        "ShortName": "Alpha Gas and Electric - MD - 238",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143145,
        "ShortName": "Green Choice Energy - DC - 239",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 20,
        "TotalByShortName": 20,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 100,
        "NominationPercentageOverall": 0.01,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 143145,
        "ShortName": "Green Choice Energy - DC - 239",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 20,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143145,
        "ShortName": "Green Choice Energy - DC - 239",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 20,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 143145,
        "ShortName": "Green Choice Energy - DC - 239",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 20,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 143145,
        "ShortName": "Green Choice Energy - DC - 239",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 20,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143145,
        "ShortName": "Green Choice Energy - DC - 239",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 20,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143146,
        "ShortName": "Green Choice Energy - DC - 240",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 143146,
        "ShortName": "Green Choice Energy - DC - 240",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143146,
        "ShortName": "Green Choice Energy - DC - 240",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 143146,
        "ShortName": "Green Choice Energy - DC - 240",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 143146,
        "ShortName": "Green Choice Energy - DC - 240",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143146,
        "ShortName": "Green Choice Energy - DC - 240",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143147,
        "ShortName": "Green Choice Energy - DC - 241",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 143147,
        "ShortName": "Green Choice Energy - DC - 241",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143147,
        "ShortName": "Green Choice Energy - DC - 241",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 143147,
        "ShortName": "Green Choice Energy - DC - 241",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 143147,
        "ShortName": "Green Choice Energy - DC - 241",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143147,
        "ShortName": "Green Choice Energy - DC - 241",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143148,
        "ShortName": "Green Choice Energy - DC - 242",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 143148,
        "ShortName": "Green Choice Energy - DC - 242",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143148,
        "ShortName": "Green Choice Energy - DC - 242",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 143148,
        "ShortName": "Green Choice Energy - DC - 242",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 143148,
        "ShortName": "Green Choice Energy - DC - 242",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143148,
        "ShortName": "Green Choice Energy - DC - 242",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143149,
        "ShortName": "Green Choice Energy - MD & VA - 243",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 143149,
        "ShortName": "Green Choice Energy - MD & VA - 243",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143149,
        "ShortName": "Green Choice Energy - MD & VA - 243",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 143149,
        "ShortName": "Green Choice Energy - MD & VA - 243",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 143149,
        "ShortName": "Green Choice Energy - MD & VA - 243",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143149,
        "ShortName": "Green Choice Energy - MD & VA - 243",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143150,
        "ShortName": "Green Choice Energy - MD & VA - 244",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 143150,
        "ShortName": "Green Choice Energy - MD & VA - 244",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143150,
        "ShortName": "Green Choice Energy - MD & VA - 244",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 143150,
        "ShortName": "Green Choice Energy - MD & VA - 244",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 143150,
        "ShortName": "Green Choice Energy - MD & VA - 244",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143150,
        "ShortName": "Green Choice Energy - MD & VA - 244",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143151,
        "ShortName": "Green Choice Energy - MD & VA - 245",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 143151,
        "ShortName": "Green Choice Energy - MD & VA - 245",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143151,
        "ShortName": "Green Choice Energy - MD & VA - 245",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 143151,
        "ShortName": "Green Choice Energy - MD & VA - 245",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 143151,
        "ShortName": "Green Choice Energy - MD & VA - 245",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143151,
        "ShortName": "Green Choice Energy - MD & VA - 245",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143152,
        "ShortName": "Green Choice Energy - MD & VA - 246",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 143152,
        "ShortName": "Green Choice Energy - MD & VA - 246",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143152,
        "ShortName": "Green Choice Energy - MD & VA - 246",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 143152,
        "ShortName": "Green Choice Energy - MD & VA - 246",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 143152,
        "ShortName": "Green Choice Energy - MD & VA - 246",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143152,
        "ShortName": "Green Choice Energy - MD & VA - 246",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143155,
        "ShortName": "Discount Power LLC - DC - 247",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 143155,
        "ShortName": "Discount Power LLC - DC - 247",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143155,
        "ShortName": "Discount Power LLC - DC - 247",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 143155,
        "ShortName": "Discount Power LLC - DC - 247",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 143155,
        "ShortName": "Discount Power LLC - DC - 247",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143155,
        "ShortName": "Discount Power LLC - DC - 247",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143156,
        "ShortName": "Discount Power LLC - DC - 248",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 143156,
        "ShortName": "Discount Power LLC - DC - 248",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143156,
        "ShortName": "Discount Power LLC - DC - 248",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 143156,
        "ShortName": "Discount Power LLC - DC - 248",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 143156,
        "ShortName": "Discount Power LLC - DC - 248",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143156,
        "ShortName": "Discount Power LLC - DC - 248",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143157,
        "ShortName": "Discount Power LLC - DC - 249",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 143157,
        "ShortName": "Discount Power LLC - DC - 249",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143157,
        "ShortName": "Discount Power LLC - DC - 249",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 143157,
        "ShortName": "Discount Power LLC - DC - 249",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 143157,
        "ShortName": "Discount Power LLC - DC - 249",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143157,
        "ShortName": "Discount Power LLC - DC - 249",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143158,
        "ShortName": "Discount Power LLC - DC - 250",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 143158,
        "ShortName": "Discount Power LLC - DC - 250",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143158,
        "ShortName": "Discount Power LLC - DC - 250",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 143158,
        "ShortName": "Discount Power LLC - DC - 250",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 143158,
        "ShortName": "Discount Power LLC - DC - 250",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143158,
        "ShortName": "Discount Power LLC - DC - 250",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143159,
        "ShortName": "Discount Power LLC - MD & VA - 251",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 143159,
        "ShortName": "Discount Power LLC - MD & VA - 251",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143159,
        "ShortName": "Discount Power LLC - MD & VA - 251",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 143159,
        "ShortName": "Discount Power LLC - MD & VA - 251",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 143159,
        "ShortName": "Discount Power LLC - MD & VA - 251",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143159,
        "ShortName": "Discount Power LLC - MD & VA - 251",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143160,
        "ShortName": "Discount Power LLC - MD & VA - 252",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 143160,
        "ShortName": "Discount Power LLC - MD & VA - 252",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143160,
        "ShortName": "Discount Power LLC - MD & VA - 252",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 143160,
        "ShortName": "Discount Power LLC - MD & VA - 252",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 143160,
        "ShortName": "Discount Power LLC - MD & VA - 252",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143160,
        "ShortName": "Discount Power LLC - MD & VA - 252",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143161,
        "ShortName": "Discount Power LLC - MD & VA - 253",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 143161,
        "ShortName": "Discount Power LLC - MD & VA - 253",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143161,
        "ShortName": "Discount Power LLC - MD & VA - 253",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 143161,
        "ShortName": "Discount Power LLC - MD & VA - 253",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 143161,
        "ShortName": "Discount Power LLC - MD & VA - 253",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143161,
        "ShortName": "Discount Power LLC - MD & VA - 253",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143162,
        "ShortName": "Discount Power LLC - MD & VA - 254",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 143162,
        "ShortName": "Discount Power LLC - MD & VA - 254",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143162,
        "ShortName": "Discount Power LLC - MD & VA - 254",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 143162,
        "ShortName": "Discount Power LLC - MD & VA - 254",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 143162,
        "ShortName": "Discount Power LLC - MD & VA - 254",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143162,
        "ShortName": "Discount Power LLC - MD & VA - 254",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143163,
        "ShortName": "Park Power LLC - MD & VA - 255",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 22,
        "TotalByShortName": 22,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 100,
        "NominationPercentageOverall": 0.01,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 143163,
        "ShortName": "Park Power LLC - MD & VA - 255",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 22,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143163,
        "ShortName": "Park Power LLC - MD & VA - 255",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 22,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 143163,
        "ShortName": "Park Power LLC - MD & VA - 255",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 22,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 143163,
        "ShortName": "Park Power LLC - MD & VA - 255",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 22,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143163,
        "ShortName": "Park Power LLC - MD & VA - 255",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 22,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143164,
        "ShortName": "Park Power LLC - MD & VA - 256",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 143164,
        "ShortName": "Park Power LLC - MD & VA - 256",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143164,
        "ShortName": "Park Power LLC - MD & VA - 256",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 143164,
        "ShortName": "Park Power LLC - MD & VA - 256",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 143164,
        "ShortName": "Park Power LLC - MD & VA - 256",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143164,
        "ShortName": "Park Power LLC - MD & VA - 256",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143165,
        "ShortName": "Park Power LLC - MD & VA - 257",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 143165,
        "ShortName": "Park Power LLC - MD & VA - 257",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143165,
        "ShortName": "Park Power LLC - MD & VA - 257",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 143165,
        "ShortName": "Park Power LLC - MD & VA - 257",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 143165,
        "ShortName": "Park Power LLC - MD & VA - 257",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143165,
        "ShortName": "Park Power LLC - MD & VA - 257",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143166,
        "ShortName": "Park Power LLC - MD & VA - 258",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 143166,
        "ShortName": "Park Power LLC - MD & VA - 258",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143166,
        "ShortName": "Park Power LLC - MD & VA - 258",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 143166,
        "ShortName": "Park Power LLC - MD & VA - 258",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 143166,
        "ShortName": "Park Power LLC - MD & VA - 258",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143166,
        "ShortName": "Park Power LLC - MD & VA - 258",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143240,
        "ShortName": "Washington Suburban Sanitary Commission ",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 790,
        "TotalByShortName": 1581,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 49.97,
        "NominationPercentageOverall": 0.38,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 143240,
        "ShortName": "Washington Suburban Sanitary Commission ",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 1581,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143240,
        "ShortName": "Washington Suburban Sanitary Commission ",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 393,
        "TotalByShortName": 1581,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 24.86,
        "NominationPercentageOverall": 0.19,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 143240,
        "ShortName": "Washington Suburban Sanitary Commission ",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 398,
        "TotalByShortName": 1581,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 25.17,
        "NominationPercentageOverall": 0.19,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 143240,
        "ShortName": "Washington Suburban Sanitary Commission ",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 1581,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143240,
        "ShortName": "Washington Suburban Sanitary Commission ",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 1581,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143244,
        "ShortName": "Greenlight Energy Inc.",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 2,
        "TotalByShortName": 2,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 100,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 143244,
        "ShortName": "Greenlight Energy Inc.",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 2,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143244,
        "ShortName": "Greenlight Energy Inc.",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 2,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 143244,
        "ShortName": "Greenlight Energy Inc.",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 2,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 143244,
        "ShortName": "Greenlight Energy Inc.",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 2,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143244,
        "ShortName": "Greenlight Energy Inc.",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 2,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143248,
        "ShortName": "IGS Energy - MD",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 981,
        "TotalByShortName": 1381,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 71.04,
        "NominationPercentageOverall": 0.47,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 143248,
        "ShortName": "IGS Energy - MD",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 1381,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143248,
        "ShortName": "IGS Energy - MD",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 100,
        "TotalByShortName": 1381,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 7.24,
        "NominationPercentageOverall": 0.05,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 143248,
        "ShortName": "IGS Energy - MD",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 200,
        "TotalByShortName": 1381,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 14.48,
        "NominationPercentageOverall": 0.1,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 143248,
        "ShortName": "IGS Energy - MD",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 100,
        "TotalByShortName": 1381,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 7.24,
        "NominationPercentageOverall": 0.05,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143248,
        "ShortName": "IGS Energy - MD",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 1381,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143251,
        "ShortName": "IGS Energy - VA & DC ",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 4038,
        "TotalByShortName": 5418,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 74.53,
        "NominationPercentageOverall": 1.95,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 143251,
        "ShortName": "IGS Energy - VA & DC ",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 5418,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143251,
        "ShortName": "IGS Energy - VA & DC ",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 340,
        "TotalByShortName": 5418,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 6.28,
        "NominationPercentageOverall": 0.16,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 143251,
        "ShortName": "IGS Energy - VA & DC ",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 700,
        "TotalByShortName": 5418,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 12.92,
        "NominationPercentageOverall": 0.34,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 143251,
        "ShortName": "IGS Energy - VA & DC ",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 340,
        "TotalByShortName": 5418,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 6.28,
        "NominationPercentageOverall": 0.16,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143251,
        "ShortName": "IGS Energy - VA & DC ",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 5418,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143255,
        "ShortName": "Engie Power & Gas",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 143255,
        "ShortName": "Engie Power & Gas",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143255,
        "ShortName": "Engie Power & Gas",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 143255,
        "ShortName": "Engie Power & Gas",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 143255,
        "ShortName": "Engie Power & Gas",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143255,
        "ShortName": "Engie Power & Gas",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143263,
        "ShortName": "Wave Energy",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 143263,
        "ShortName": "Wave Energy",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143263,
        "ShortName": "Wave Energy",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 143263,
        "ShortName": "Wave Energy",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 143263,
        "ShortName": "Wave Energy",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143263,
        "ShortName": "Wave Energy",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143298,
        "ShortName": "United Energy Trading ",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 1500,
        "TotalByShortName": 2700,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 55.56,
        "NominationPercentageOverall": 0.72,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 143298,
        "ShortName": "United Energy Trading ",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 2700,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143298,
        "ShortName": "United Energy Trading ",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 1200,
        "TotalByShortName": 2700,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 44.44,
        "NominationPercentageOverall": 0.58,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 143298,
        "ShortName": "United Energy Trading ",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 2700,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 143298,
        "ShortName": "United Energy Trading ",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 2700,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143298,
        "ShortName": "United Energy Trading ",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 2700,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143317,
        "ShortName": "Spark Energy Gas LLC",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 143317,
        "ShortName": "Spark Energy Gas LLC",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143317,
        "ShortName": "Spark Energy Gas LLC",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 143317,
        "ShortName": "Spark Energy Gas LLC",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 143317,
        "ShortName": "Spark Energy Gas LLC",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143317,
        "ShortName": "Spark Energy Gas LLC",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143395,
        "ShortName": "Virginia Light & Power LLC",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 143395,
        "ShortName": "Virginia Light & Power LLC",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143395,
        "ShortName": "Virginia Light & Power LLC",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 143395,
        "ShortName": "Virginia Light & Power LLC",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 143395,
        "ShortName": "Virginia Light & Power LLC",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143395,
        "ShortName": "Virginia Light & Power LLC",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143399,
        "ShortName": "New Wave Energy LLC - MD ",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 143399,
        "ShortName": "New Wave Energy LLC - MD ",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143399,
        "ShortName": "New Wave Energy LLC - MD ",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 143399,
        "ShortName": "New Wave Energy LLC - MD ",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 143399,
        "ShortName": "New Wave Energy LLC - MD ",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143399,
        "ShortName": "New Wave Energy LLC - MD ",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143403,
        "ShortName": "New Wave Energy LLC - DC & VA",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 143403,
        "ShortName": "New Wave Energy LLC - DC & VA",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143403,
        "ShortName": "New Wave Energy LLC - DC & VA",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 143403,
        "ShortName": "New Wave Energy LLC - DC & VA",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 143403,
        "ShortName": "New Wave Energy LLC - DC & VA",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143403,
        "ShortName": "New Wave Energy LLC - DC & VA",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143415,
        "ShortName": "American Power & Gas - DC",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 143415,
        "ShortName": "American Power & Gas - DC",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143415,
        "ShortName": "American Power & Gas - DC",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 143415,
        "ShortName": "American Power & Gas - DC",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 143415,
        "ShortName": "American Power & Gas - DC",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143415,
        "ShortName": "American Power & Gas - DC",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143440,
        "ShortName": "Electric Advisers Inc",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 143440,
        "ShortName": "Electric Advisers Inc",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143440,
        "ShortName": "Electric Advisers Inc",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 143440,
        "ShortName": "Electric Advisers Inc",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 143440,
        "ShortName": "Electric Advisers Inc",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143440,
        "ShortName": "Electric Advisers Inc",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143461,
        "ShortName": "Vista Energy",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 143461,
        "ShortName": "Vista Energy",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143461,
        "ShortName": "Vista Energy",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 143461,
        "ShortName": "Vista Energy",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 143461,
        "ShortName": "Vista Energy",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143461,
        "ShortName": "Vista Energy",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143462,
        "ShortName": "Vista Energy - 303",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 143462,
        "ShortName": "Vista Energy - 303",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143462,
        "ShortName": "Vista Energy - 303",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 143462,
        "ShortName": "Vista Energy - 303",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 143462,
        "ShortName": "Vista Energy - 303",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143462,
        "ShortName": "Vista Energy - 303",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143463,
        "ShortName": "Vista Energy - 304",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 143463,
        "ShortName": "Vista Energy - 304",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143463,
        "ShortName": "Vista Energy - 304",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 143463,
        "ShortName": "Vista Energy - 304",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 143463,
        "ShortName": "Vista Energy - 304",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143463,
        "ShortName": "Vista Energy - 304",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143464,
        "ShortName": "Vista Energy - 305",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 143464,
        "ShortName": "Vista Energy - 305",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143464,
        "ShortName": "Vista Energy - 305",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 143464,
        "ShortName": "Vista Energy - 305",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 143464,
        "ShortName": "Vista Energy - 305",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143464,
        "ShortName": "Vista Energy - 305",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143465,
        "ShortName": "Gas South",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 143465,
        "ShortName": "Gas South",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143465,
        "ShortName": "Gas South",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 143465,
        "ShortName": "Gas South",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 143465,
        "ShortName": "Gas South",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143465,
        "ShortName": "Gas South",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143466,
        "ShortName": "Gas South - 307",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 143466,
        "ShortName": "Gas South - 307",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143466,
        "ShortName": "Gas South - 307",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 143466,
        "ShortName": "Gas South - 307",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 143466,
        "ShortName": "Gas South - 307",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143466,
        "ShortName": "Gas South - 307",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143467,
        "ShortName": "Gas South - 308",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 143467,
        "ShortName": "Gas South - 308",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143467,
        "ShortName": "Gas South - 308",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 143467,
        "ShortName": "Gas South - 308",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 143467,
        "ShortName": "Gas South - 308",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143467,
        "ShortName": "Gas South - 308",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143468,
        "ShortName": "Gas South - 309",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 143468,
        "ShortName": "Gas South - 309",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143468,
        "ShortName": "Gas South - 309",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 143468,
        "ShortName": "Gas South - 309",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 143468,
        "ShortName": "Gas South - 309",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143468,
        "ShortName": "Gas South - 309",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143472,
        "ShortName": "American Power & Gas - 310",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 143472,
        "ShortName": "American Power & Gas - 310",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143472,
        "ShortName": "American Power & Gas - 310",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 143472,
        "ShortName": "American Power & Gas - 310",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 143472,
        "ShortName": "American Power & Gas - 310",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143472,
        "ShortName": "American Power & Gas - 310",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143473,
        "ShortName": "American Power & Gas - DC - 311",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 143473,
        "ShortName": "American Power & Gas - DC - 311",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143473,
        "ShortName": "American Power & Gas - DC - 311",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 143473,
        "ShortName": "American Power & Gas - DC - 311",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 143473,
        "ShortName": "American Power & Gas - DC - 311",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143473,
        "ShortName": "American Power & Gas - DC - 311",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143474,
        "ShortName": "Atlantic Energy - 312",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 143474,
        "ShortName": "Atlantic Energy - 312",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143474,
        "ShortName": "Atlantic Energy - 312",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 143474,
        "ShortName": "Atlantic Energy - 312",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 143474,
        "ShortName": "Atlantic Energy - 312",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143474,
        "ShortName": "Atlantic Energy - 312",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143475,
        "ShortName": "Clearview Energy - 313",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 143475,
        "ShortName": "Clearview Energy - 313",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143475,
        "ShortName": "Clearview Energy - 313",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 143475,
        "ShortName": "Clearview Energy - 313",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 143475,
        "ShortName": "Clearview Energy - 313",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143475,
        "ShortName": "Clearview Energy - 313",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143476,
        "ShortName": "Deca Energy - 314",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 143476,
        "ShortName": "Deca Energy - 314",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143476,
        "ShortName": "Deca Energy - 314",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 143476,
        "ShortName": "Deca Energy - 314",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 143476,
        "ShortName": "Deca Energy - 314",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143476,
        "ShortName": "Deca Energy - 314",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143477,
        "ShortName": "Energy Plus Natural Gas LLC - 316",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 143477,
        "ShortName": "Energy Plus Natural Gas LLC - 316",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143477,
        "ShortName": "Energy Plus Natural Gas LLC - 316",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 143477,
        "ShortName": "Energy Plus Natural Gas LLC - 316",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 143477,
        "ShortName": "Energy Plus Natural Gas LLC - 316",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143477,
        "ShortName": "Energy Plus Natural Gas LLC - 316",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143478,
        "ShortName": "Gateway Energy Services - 317",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 143478,
        "ShortName": "Gateway Energy Services - 317",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143478,
        "ShortName": "Gateway Energy Services - 317",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 143478,
        "ShortName": "Gateway Energy Services - 317",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 143478,
        "ShortName": "Gateway Energy Services - 317",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143478,
        "ShortName": "Gateway Energy Services - 317",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143479,
        "ShortName": "IDT Energy - 318",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 143479,
        "ShortName": "IDT Energy - 318",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143479,
        "ShortName": "IDT Energy - 318",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 143479,
        "ShortName": "IDT Energy - 318",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 143479,
        "ShortName": "IDT Energy - 318",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143479,
        "ShortName": "IDT Energy - 318",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143480,
        "ShortName": "Major Energy - 321",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 143480,
        "ShortName": "Major Energy - 321",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143480,
        "ShortName": "Major Energy - 321",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 143480,
        "ShortName": "Major Energy - 321",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 143480,
        "ShortName": "Major Energy - 321",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143480,
        "ShortName": "Major Energy - 321",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143481,
        "ShortName": "Maryland Gas & Electric - 322",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 143481,
        "ShortName": "Maryland Gas & Electric - 322",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143481,
        "ShortName": "Maryland Gas & Electric - 322",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 143481,
        "ShortName": "Maryland Gas & Electric - 322",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 143481,
        "ShortName": "Maryland Gas & Electric - 322",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143481,
        "ShortName": "Maryland Gas & Electric - 322",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143482,
        "ShortName": "Median Energy - 323",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 143482,
        "ShortName": "Median Energy - 323",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143482,
        "ShortName": "Median Energy - 323",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 143482,
        "ShortName": "Median Energy - 323",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 143482,
        "ShortName": "Median Energy - 323",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143482,
        "ShortName": "Median Energy - 323",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143483,
        "ShortName": "Mpower Energy NJ LLC - 324",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 143483,
        "ShortName": "Mpower Energy NJ LLC - 324",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143483,
        "ShortName": "Mpower Energy NJ LLC - 324",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 143483,
        "ShortName": "Mpower Energy NJ LLC - 324",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 143483,
        "ShortName": "Mpower Energy NJ LLC - 324",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143483,
        "ShortName": "Mpower Energy NJ LLC - 324",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143484,
        "ShortName": "NRG Home - 325",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 143484,
        "ShortName": "NRG Home - 325",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143484,
        "ShortName": "NRG Home - 325",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 143484,
        "ShortName": "NRG Home - 325",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 143484,
        "ShortName": "NRG Home - 325",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143484,
        "ShortName": "NRG Home - 325",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143485,
        "ShortName": "SFE Energy - 326",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 143485,
        "ShortName": "SFE Energy - 326",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143485,
        "ShortName": "SFE Energy - 326",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 143485,
        "ShortName": "SFE Energy - 326",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 143485,
        "ShortName": "SFE Energy - 326",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143485,
        "ShortName": "SFE Energy - 326",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143486,
        "ShortName": "Spring Power & Gas - 327",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 143486,
        "ShortName": "Spring Power & Gas - 327",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143486,
        "ShortName": "Spring Power & Gas - 327",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 143486,
        "ShortName": "Spring Power & Gas - 327",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 143486,
        "ShortName": "Spring Power & Gas - 327",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143486,
        "ShortName": "Spring Power & Gas - 327",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143487,
        "ShortName": "StateWise Energy MD LLC",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 143487,
        "ShortName": "StateWise Energy MD LLC",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143487,
        "ShortName": "StateWise Energy MD LLC",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 143487,
        "ShortName": "StateWise Energy MD LLC",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 143487,
        "ShortName": "StateWise Energy MD LLC",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143487,
        "ShortName": "StateWise Energy MD LLC",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143488,
        "ShortName": "Xoom Energy - 329",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 143488,
        "ShortName": "Xoom Energy - 329",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143488,
        "ShortName": "Xoom Energy - 329",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 143488,
        "ShortName": "Xoom Energy - 329",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 143488,
        "ShortName": "Xoom Energy - 329",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143488,
        "ShortName": "Xoom Energy - 329",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143489,
        "ShortName": "Xoom Energy of VA",
        "PipelineID": 101,
        "PipelineName": "Columbia",
        "Ordinal": 1,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 69.25,
        "GrandTotal": 207255,
        "PipeLineTotal": 143530,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "A"
      },
      {
        "CompanyID": 143489,
        "ShortName": "Xoom Energy of VA",
        "PipelineID": 102,
        "PipelineName": "Cove Pt",
        "Ordinal": 2,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143489,
        "ShortName": "Xoom Energy of VA",
        "PipelineID": 103,
        "PipelineName": "Dominion",
        "Ordinal": 3,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 11.42,
        "GrandTotal": 207255,
        "PipeLineTotal": 23672,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "C"
      },
      {
        "CompanyID": 143489,
        "ShortName": "Xoom Energy of VA",
        "PipelineID": 104,
        "PipelineName": "Transco",
        "Ordinal": 4,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 13.18,
        "GrandTotal": 207255,
        "PipeLineTotal": 27316,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "B"
      },
      {
        "CompanyID": 143489,
        "ShortName": "Xoom Energy of VA",
        "PipelineID": 105,
        "PipelineName": "Transco Z6",
        "Ordinal": 5,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 6.15,
        "GrandTotal": 207255,
        "PipeLineTotal": 12737,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      },
      {
        "CompanyID": 143489,
        "ShortName": "Xoom Energy of VA",
        "PipelineID": 106,
        "PipelineName": "TCO Transit",
        "Ordinal": 6,
        "TotalNomination": 0,
        "TotalByShortName": 0,
        "NominationPercentageSum": 100,
        "NominationPercentGroupWise": 0,
        "GrandTotal": 207255,
        "PipeLineTotal": 0,
        "NominationPercentageByShortName": 0,
        "NominationPercentageOverall": 0,
        "PipelineLabel": "D"
      }
    ],
    "TotalByShortName": null,
    "GrandTotal": null,
    "PipeLineTotal": null,
    "sumByPipeline": null,
    "totalSum": null
  }
}

export const NominationComplianceData ={  
  "Succeeded": true,
  "Message": "Nomination Compliance Report successfully found",
  "Errors": null,
  "Data": {
    "ReportName": "Nomination Compliance Report",
    "MarketerName": "AOC",
    "DateRange": "2024-06-15 to 2024-06-15",
    "DatePublished": "2025-04-28T09:49:39.7243854+00:00",
    "Details": [
      {
        "ShipmentDate": "2024-06-15T00:00:00",
        "RowNum": null,
        "AllocationGroupID": null,
        "AllocationGroup": null,
        "TotalNominationAllocations": null,
        "DailyRequiredVolume": null,
        "TotalUsage": null,
        "totalforecastimbal": null,
        "TotalPenalty": null,
        "Pipeline": "Dominion",
        "TotalNominations": 0,
        "CompanyID": null,
        "IsFirm": null,
        "Name": null
      },
      {
        "ShipmentDate": "2024-06-15T00:00:00",
        "RowNum": null,
        "AllocationGroupID": null,
        "AllocationGroup": null,
        "TotalNominationAllocations": null,
        "DailyRequiredVolume": null,
        "TotalUsage": null,
        "totalforecastimbal": null,
        "TotalPenalty": null,
        "Pipeline": "TCO Transit",
        "TotalNominations": 0,
        "CompanyID": null,
        "IsFirm": null,
        "Name": null
      },
      {
        "ShipmentDate": "2024-06-15T00:00:00",
        "RowNum": null,
        "AllocationGroupID": null,
        "AllocationGroup": null,
        "TotalNominationAllocations": null,
        "DailyRequiredVolume": null,
        "TotalUsage": null,
        "totalforecastimbal": null,
        "TotalPenalty": null,
        "Pipeline": "Transco",
        "TotalNominations": 0,
        "CompanyID": null,
        "IsFirm": null,
        "Name": null
      },
      {
        "ShipmentDate": "2024-06-15T00:00:00",
        "RowNum": null,
        "AllocationGroupID": null,
        "AllocationGroup": null,
        "TotalNominationAllocations": null,
        "DailyRequiredVolume": null,
        "TotalUsage": null,
        "totalforecastimbal": null,
        "TotalPenalty": null,
        "Pipeline": "Transco Z6",
        "TotalNominations": 0,
        "CompanyID": null,
        "IsFirm": null,
        "Name": null
      },
      {
        "ShipmentDate": "2024-06-15T00:00:00",
        "RowNum": 1,
        "AllocationGroupID": 1017,
        "AllocationGroup": "AOC",
        "TotalNominationAllocations": 1367,
        "DailyRequiredVolume": 1167,
        "TotalUsage": 1167,
        "totalforecastimbal": 200,
        "TotalPenalty": 0,
        "Pipeline": "Columbia",
        "TotalNominations": 0,
        "CompanyID": 114,
        "IsFirm": true,
        "Name": "AOC"
      },
      {
        "ShipmentDate": "2024-06-15T00:00:00",
        "RowNum": 2,
        "AllocationGroupID": 1038,
        "AllocationGroup": "AOC IP",
        "TotalNominationAllocations": 2500,
        "DailyRequiredVolume": 2500,
        "TotalUsage": 0,
        "totalforecastimbal": 0,
        "TotalPenalty": 0,
        "Pipeline": "Cove Pt",
        "TotalNominations": 0,
        "CompanyID": 114,
        "IsFirm": false,
        "Name": "AOC IP"
      }
    
    ],
    "MarketerList": [
      {
        "CompanyID": 114,
        "Description": "AOC",
        "MarketerID": 114,
        "MarketerName": "AOC"
      }
    ],
    "TotalPenalty": 0,
    "TotalForecastImbalance": 200,
    "TotalUsage": 1167,
    "DailyRequiredVolume": 3667,
    "TotalNominationAllocations": 3867,
    "TotalNominations": 0
  }
}



export const ActivityInterruptibleData={
  "Succeeded": true,
  "Message": null,
  "Errors": null,
  "Data": {
    "AdjustmentActivityInterruptibleReport": [
      {
        "AllocationGroupID": 33,
        "CompanyID": 136,
        "CompanyName": "WGL Energy Svcs - 35",
        "AllocationGroup": "WGES MD IP",
        "EffectiveDate": "2024-04-01T00:00:00",
        "EndDate": "2024-04-30T00:00:00",
        "PreviousBalanceFirm": 0,
        "PreviousBalanceInterruptible": -9791702,
        "CashOutAdjustmentAmount": 0,
        "ImbalanceAdjustedVolume": 0,
        "DailyRequiredVolume": 870000,
        "ShipmentMonth": "2024-04-01T00:00:00",
        "TotalForecastImbal": 34246,
        "TotalNominationAllocations": 904246,
        "TotalUsage": 877538,
        "ThresholdValue": 131631,
        "MonthEndImbalanceInterruptible": -9764994,
        "MonthEndImbalanceFirm": -9757456,
        "OutsideThresholdAmount": -9633363
      },
      {
        "AllocationGroupID": 149,
        "CompanyID": 136,
        "CompanyName": "WGL Energy Svcs - 35",
        "AllocationGroup": "WGES VA IP",
        "EffectiveDate": "2024-04-01T00:00:00",
        "EndDate": "2024-04-30T00:00:00",
        "PreviousBalanceFirm": 0,
        "PreviousBalanceInterruptible": -49945500,
        "CashOutAdjustmentAmount": 0,
        "ImbalanceAdjustedVolume": 0,
        "DailyRequiredVolume": 129000,
        "ShipmentMonth": "2024-04-01T00:00:00",
        "TotalForecastImbal": -1300,
        "TotalNominationAllocations": 127700,
        "TotalUsage": 136711,
        "ThresholdValue": 20507,
        "MonthEndImbalanceInterruptible": -49954511,
        "MonthEndImbalanceFirm": -49946800,
        "OutsideThresholdAmount": -49934004
      },
      {
        "AllocationGroupID": 183,
        "CompanyID": 136,
        "CompanyName": "WGL Energy Svcs - 35",
        "AllocationGroup": "WGES DC IP",
        "EffectiveDate": "2024-04-01T00:00:00",
        "EndDate": "2024-04-30T00:00:00",
        "PreviousBalanceFirm": 0,
        "PreviousBalanceInterruptible": 72760,
        "CashOutAdjustmentAmount": 0,
        "ImbalanceAdjustedVolume": 0,
        "DailyRequiredVolume": 321000,
        "ShipmentMonth": "2024-04-01T00:00:00",
        "TotalForecastImbal": -33800,
        "TotalNominationAllocations": 287200,
        "TotalUsage": 272801,
        "ThresholdValue": 48150,
        "MonthEndImbalanceInterruptible": 78778,
        "MonthEndImbalanceFirm": 87159,
        "OutsideThresholdAmount": 30628
      }
    ],
    "Marketers": [
      {
        "MarketerID": 326,
        "MarketerName": "Constellation New Energy"
      },
      {
        "MarketerID": 2128,
        "MarketerName": "sdfsd"
      },
      {
        "MarketerID": 55638,
        "MarketerName": "Maryland Gas and Electric"
      },
      {
        "MarketerID": 58038,
        "MarketerName": "testtttt"
      },
      {
        "MarketerID": 65135,
        "MarketerName": "Csonstellation New Energy 2"
      },
      {
        "MarketerID": 70454,
        "MarketerName": "World Energy"
      },
      {
        "MarketerID": 72875,
        "MarketerName": "Energy Plus Natural Gas LLC"
      },
      {
        "MarketerID": 73914,
        "MarketerName": "Deca Energy"
      },
      {
        "MarketerID": 73915,
        "MarketerName": "Ambit Energy12"
      },
      {
        "MarketerID": 76734,
        "MarketerName": "IGS Energy - MD - 128"
      },
      {
        "MarketerID": 89135,
        "MarketerName": "Engie Power & Gas - 135"
      },
      {
        "MarketerID": 90954,
        "MarketerName": "Constellation Energy Gas Choice"
      },
      {
        "MarketerID": 100535,
        "MarketerName": "Viridian Energy"
      },
      {
        "MarketerID": 100554,
        "MarketerName": "Xoom Energy"
      },
      {
        "MarketerID": 100914,
        "MarketerName": "NRG Business Market,LLC - 145"
      },
      {
        "MarketerID": 103174,
        "MarketerName": "Engie Power & Gas - 144"
      },
      {
        "MarketerID": 104474,
        "MarketerName": "Stand Energy UCB RR"
      },
      {
        "MarketerID": 122214,
        "MarketerName": "Enspire Energy"
      },
      {
        "MarketerID": 123275,
        "MarketerName": "CEGC"
      },
      {
        "MarketerID": 136034,
        "MarketerName": "Direct Energy Services,LLC-156"
      },
      {
        "MarketerID": 142214,
        "MarketerName": "SFE Energy"
      },
      {
        "MarketerID": 142215,
        "MarketerName": "AGERA Energy - 159"
      },
      {
        "MarketerID": 142216,
        "MarketerName": "AGERA Energy - 160"
      },
      {
        "MarketerID": 142876,
        "MarketerName": "NOVEC Energy Solutions – 164"
      },
      {
        "MarketerID": 142895,
        "MarketerName": "Dominion Energy Solutions - 150"
      },
      {
        "MarketerID": 142909,
        "MarketerName": "MAJOR Energy"
      },
      {
        "MarketerID": 142922,
        "MarketerName": "NRG Home"
      },
      {
        "MarketerID": 142936,
        "MarketerName": "Mansfield Power and Gas LLC"
      },
      {
        "MarketerID": 142939,
        "MarketerName": "Just Energy"
      },
      {
        "MarketerID": 142941,
        "MarketerName": "Shipley Energy"
      },
      {
        "MarketerID": 142942,
        "MarketerName": "Planet Energy"
      },
      {
        "MarketerID": 142943,
        "MarketerName": "Spring Power & Gas"
      },
      {
        "MarketerID": 142944,
        "MarketerName": "Twin Eagle Energy"
      },
      {
        "MarketerID": 142968,
        "MarketerName": "Indra Energy - DC - 169"
      },
      {
        "MarketerID": 142969,
        "MarketerName": "Indra Energy - VA - 170"
      },
      {
        "MarketerID": 142983,
        "MarketerName": "Viridian Energy DUAL"
      },
      {
        "MarketerID": 142984,
        "MarketerName": "Viridian Energy UCB BR"
      },
      {
        "MarketerID": 142985,
        "MarketerName": "Engie Power & Gas - 173"
      },
      {
        "MarketerID": 142991,
        "MarketerName": "IDT Energy"
      },
      {
        "MarketerID": 142992,
        "MarketerName": "MPower Energy NJ LLC"
      },
      {
        "MarketerID": 142993,
        "MarketerName": "PESCO Energy - 175"
      },
      {
        "MarketerID": 142994,
        "MarketerName": "PESCO Energy - 176"
      },
      {
        "MarketerID": 142995,
        "MarketerName": "Think Energy"
      },
      {
        "MarketerID": 142996,
        "MarketerName": "Virginia Retail Energy - 178"
      },
      {
        "MarketerID": 142997,
        "MarketerName": "Virginia Retail Energy - 179"
      },
      {
        "MarketerID": 142998,
        "MarketerName": "Stand Energy - 180"
      },
      {
        "MarketerID": 142999,
        "MarketerName": "Stand Energy - 181"
      },
      {
        "MarketerID": 143009,
        "MarketerName": "Clearview Energy"
      },
      {
        "MarketerID": 143010,
        "MarketerName": "South Jersey Energy Corp - 184"
      },
      {
        "MarketerID": 143011,
        "MarketerName": "South Jersey Energy Corp - 185"
      },
      {
        "MarketerID": 143012,
        "MarketerName": "Indra Energy - MD - 186"
      },
      {
        "MarketerID": 143013,
        "MarketerName": "Tomorrow Energy Corp"
      },
      {
        "MarketerID": 143014,
        "MarketerName": "Think Energy - 188"
      },
      {
        "MarketerID": 143015,
        "MarketerName": "American Power & Gas"
      },
      {
        "MarketerID": 143016,
        "MarketerName": "Atlantic Energy"
      },
      {
        "MarketerID": 143017,
        "MarketerName": "Median Energy"
      },
      {
        "MarketerID": 143027,
        "MarketerName": "Josco Energy - 192"
      },
      {
        "MarketerID": 143028,
        "MarketerName": "Josco Energy - 193"
      },
      {
        "MarketerID": 143029,
        "MarketerName": "CleanSky Energy - DC and MD - 194"
      },
      {
        "MarketerID": 143030,
        "MarketerName": "CleanSky Energy - DC and MD - 195"
      },
      {
        "MarketerID": 143039,
        "MarketerName": "UGI Energy Services - 197"
      },
      {
        "MarketerID": 143040,
        "MarketerName": "Indra Energy - MD - 198"
      },
      {
        "MarketerID": 143041,
        "MarketerName": "Indra Energy - MD - 199"
      },
      {
        "MarketerID": 143042,
        "MarketerName": "Indra Energy - DC - 200"
      },
      {
        "MarketerID": 143043,
        "MarketerName": "Indra Energy - DC - 201"
      },
      {
        "MarketerID": 143044,
        "MarketerName": "Indra Energy - VA - 202"
      },
      {
        "MarketerID": 143045,
        "MarketerName": "Indra Energy - VA - 203"
      },
      {
        "MarketerID": 143049,
        "MarketerName": "Park Power LLC - DC - 204"
      },
      {
        "MarketerID": 143050,
        "MarketerName": "Park Power LLC - DC - 205"
      },
      {
        "MarketerID": 143051,
        "MarketerName": "Park Power LLC - DC - 206"
      },
      {
        "MarketerID": 143063,
        "MarketerName": "East Coast Power & Gas - MD - 207"
      },
      {
        "MarketerID": 143064,
        "MarketerName": "East Coast Power & Gas - MD - 208"
      },
      {
        "MarketerID": 143065,
        "MarketerName": "East Coast Power & Gas - MD - 209"
      },
      {
        "MarketerID": 143066,
        "MarketerName": "Statewise Energy - MD - 210"
      },
      {
        "MarketerID": 143087,
        "MarketerName": "Statewise Energy - MD - 211"
      },
      {
        "MarketerID": 143099,
        "MarketerName": "NRG Business Market,LLC - 212"
      },
      {
        "MarketerID": 143100,
        "MarketerName": "NRG Business Market,LLC - 213"
      },
      {
        "MarketerID": 143101,
        "MarketerName": "NRG Business Market,LLC - 214"
      },
      {
        "MarketerID": 143113,
        "MarketerName": "Nordic Energy Services - 215"
      },
      {
        "MarketerID": 143114,
        "MarketerName": "Nordic Energy Services - 216"
      },
      {
        "MarketerID": 143115,
        "MarketerName": "Nordic Energy Services - 217"
      },
      {
        "MarketerID": 143116,
        "MarketerName": "Nordic Energy Services - 218"
      },
      {
        "MarketerID": 143117,
        "MarketerName": "SunSea Energy - DC - 219"
      },
      {
        "MarketerID": 143118,
        "MarketerName": "SunSea Energy - DC - 220"
      },
      {
        "MarketerID": 143119,
        "MarketerName": "SunSea Energy - DC - 221"
      },
      {
        "MarketerID": 143120,
        "MarketerName": "SunSea Energy - DC - 222"
      },
      {
        "MarketerID": 143121,
        "MarketerName": "SunSea Energy - MD & VA - 223"
      },
      {
        "MarketerID": 143122,
        "MarketerName": "SunSea Energy - MD & VA - 224"
      },
      {
        "MarketerID": 143123,
        "MarketerName": "SunSea Energy - MD & VA - 225"
      },
      {
        "MarketerID": 143124,
        "MarketerName": "SunSea Energy - MD & VA - 226"
      },
      {
        "MarketerID": 143125,
        "MarketerName": "Alpha Gas and Electric - DC - 227"
      },
      {
        "MarketerID": 143127,
        "MarketerName": "Alpha Gas and Electric - DC - 229"
      },
      {
        "MarketerID": 143128,
        "MarketerName": "Alpha Gas and Electric - VA - 230"
      },
      {
        "MarketerID": 143129,
        "MarketerName": "Alpha Gas and Electric - DC - 231"
      },
      {
        "MarketerID": 143130,
        "MarketerName": "Alpha Gas and Electric - VA - 232"
      },
      {
        "MarketerID": 143132,
        "MarketerName": "Alpha Gas and Electric - VA - 234"
      },
      {
        "MarketerID": 143133,
        "MarketerName": "Alpha Gas and Electric - MD - 235"
      },
      {
        "MarketerID": 143134,
        "MarketerName": "Alpha Gas and Electric - MD - 236"
      },
      {
        "MarketerID": 143135,
        "MarketerName": "Alpha Gas and Electric - MD - 237"
      },
      {
        "MarketerID": 143136,
        "MarketerName": "Alpha Gas and Electric - MD - 238"
      },
      {
        "MarketerID": 143145,
        "MarketerName": "Green Choice Energy - DC - 239"
      },
      {
        "MarketerID": 143146,
        "MarketerName": "Green Choice Energy - DC - 240"
      },
      {
        "MarketerID": 143147,
        "MarketerName": "Green Choice Energy - DC - 241"
      },
      {
        "MarketerID": 143148,
        "MarketerName": "Green Choice Energy - DC - 242"
      },
      {
        "MarketerID": 143149,
        "MarketerName": "Green Choice Energy - MD & VA - 243"
      },
      {
        "MarketerID": 143150,
        "MarketerName": "Green Choice Energy - MD & VA - 244"
      },
      {
        "MarketerID": 143151,
        "MarketerName": "Green Choice Energy - MD & VA - 245"
      },
      {
        "MarketerID": 143152,
        "MarketerName": "Green Choice Energy - MD & VA - 246"
      },
      {
        "MarketerID": 143155,
        "MarketerName": "Discount Power LLC - DC - 247"
      },
      {
        "MarketerID": 143156,
        "MarketerName": "Discount Power LLC - DC - 248"
      },
      {
        "MarketerID": 143157,
        "MarketerName": "Discount Power LLC - DC - 249"
      },
      {
        "MarketerID": 143158,
        "MarketerName": "Discount Power LLC - DC - 250"
      },
      {
        "MarketerID": 143159,
        "MarketerName": "Discount Power LLC - MD & VA - 251"
      },
      {
        "MarketerID": 143160,
        "MarketerName": "Discount Power LLC - MD & VA - 252"
      },
      {
        "MarketerID": 143161,
        "MarketerName": "Discount Power LLC - MD & VA - 253"
      },
      {
        "MarketerID": 143162,
        "MarketerName": "Discount Power LLC - MD & VA - 254"
      },
      {
        "MarketerID": 143163,
        "MarketerName": "Park Power LLC - MD & VA - 255"
      },
      {
        "MarketerID": 143164,
        "MarketerName": "Park Power LLC - MD & VA - 256"
      },
      {
        "MarketerID": 143165,
        "MarketerName": "Park Power LLC - MD & VA - 257"
      },
      {
        "MarketerID": 143166,
        "MarketerName": "Park Power LLC - MD & VA - 258"
      },
      {
        "MarketerID": 143240,
        "MarketerName": "Washington Suburban Sanitary Commission "
      },
      {
        "MarketerID": 143244,
        "MarketerName": "Greenlight Energy Inc."
      },
      {
        "MarketerID": 143248,
        "MarketerName": "IGS Energy - MD"
      },
      {
        "MarketerID": 143251,
        "MarketerName": "IGS Energy - VA & DC "
      },
      {
        "MarketerID": 143255,
        "MarketerName": "Engie Power & Gas"
      },
      {
        "MarketerID": 143263,
        "MarketerName": "Wave Energy"
      },
      {
        "MarketerID": 143298,
        "MarketerName": "United Energy Trading "
      },
      {
        "MarketerID": 143317,
        "MarketerName": "Spark Energy Gas LLC"
      },
      {
        "MarketerID": 143395,
        "MarketerName": "Virginia Light & Power LLC"
      },
      {
        "MarketerID": 143399,
        "MarketerName": "New Wave Energy LLC - MD "
      },
      {
        "MarketerID": 143403,
        "MarketerName": "New Wave Energy LLC - DC & VA"
      },
      {
        "MarketerID": 143415,
        "MarketerName": "American Power & Gas - DC"
      },
      {
        "MarketerID": 143440,
        "MarketerName": "Electric Advisers Inc"
      },
      {
        "MarketerID": 143461,
        "MarketerName": "Vista Energy"
      },
      {
        "MarketerID": 143462,
        "MarketerName": "Vista Energy - 303"
      },
      {
        "MarketerID": 143463,
        "MarketerName": "Vista Energy - 304"
      },
      {
        "MarketerID": 143464,
        "MarketerName": "Vista Energy - 305"
      },
      {
        "MarketerID": 143465,
        "MarketerName": "Gas South"
      },
      {
        "MarketerID": 143466,
        "MarketerName": "Gas South - 307"
      },
      {
        "MarketerID": 143467,
        "MarketerName": "Gas South - 308"
      },
      {
        "MarketerID": 143468,
        "MarketerName": "Gas South - 309"
      },
      {
        "MarketerID": 143472,
        "MarketerName": "American Power & Gas - 310"
      },
      {
        "MarketerID": 143473,
        "MarketerName": "American Power & Gas - DC - 311"
      },
      {
        "MarketerID": 143474,
        "MarketerName": "Atlantic Energy - 312"
      },
      {
        "MarketerID": 143475,
        "MarketerName": "Clearview Energy - 313"
      },
      {
        "MarketerID": 143476,
        "MarketerName": "Deca Energy - 314"
      },
      {
        "MarketerID": 143477,
        "MarketerName": "Energy Plus Natural Gas LLC - 316"
      },
      {
        "MarketerID": 143478,
        "MarketerName": "Gateway Energy Services - 317"
      },
      {
        "MarketerID": 143479,
        "MarketerName": "IDT Energy - 318"
      },
      {
        "MarketerID": 143480,
        "MarketerName": "Major Energy - 321"
      },
      {
        "MarketerID": 143481,
        "MarketerName": "Maryland Gas & Electric - 322"
      },
      {
        "MarketerID": 143482,
        "MarketerName": "Median Energy - 323"
      },
      {
        "MarketerID": 143483,
        "MarketerName": "Mpower Energy NJ LLC - 324"
      },
      {
        "MarketerID": 143484,
        "MarketerName": "NRG Home - 325"
      },
      {
        "MarketerID": 143485,
        "MarketerName": "SFE Energy - 326"
      },
      {
        "MarketerID": 143486,
        "MarketerName": "Spring Power & Gas - 327"
      },
      {
        "MarketerID": 143487,
        "MarketerName": "StateWise Energy MD LLC"
      },
      {
        "MarketerID": 143488,
        "MarketerName": "Xoom Energy - 329"
      },
      {
        "MarketerID": 143489,
        "MarketerName": "Xoom Energy of VA"
      },
      {
        "MarketerID": 143490,
        "MarketerName": "Raghav"
      },
      {
        "MarketerID": 143491,
        "MarketerName": "test markter"
      },
      {
        "MarketerID": 143492,
        "MarketerName": "tessttttttttt"
      },
      {
        "MarketerID": 143493,
        "MarketerName": "teststttt majid tesst"
      },
      {
        "MarketerID": 143494,
        "MarketerName": "EnerNocqwertgyhj"
      },
      {
        "MarketerID": 143495,
        "MarketerName": "wertyuwertyu"
      },
      {
        "MarketerID": 143496,
        "MarketerName": "wertyuiuytre"
      },
      {
        "MarketerID": 143497,
        "MarketerName": "testttttt234"
      },
      {
        "MarketerID": 143498,
        "MarketerName": "tesssssssssssssssst"
      },
      {
        "MarketerID": 143499,
        "MarketerName": "teeeeeeeeeeeeeeeeest"
      },
      {
        "MarketerID": 143500,
        "MarketerName": "tttttttttesssttt"
      },
      {
        "MarketerID": 143501,
        "MarketerName": "majidtest"
      },
      {
        "MarketerID": 143502,
        "MarketerName": "mounikatessstttt"
      },
      {
        "MarketerID": 143503,
        "MarketerName": "datetessstttt"
      },
      {
        "MarketerID": 143504,
        "MarketerName": "datetest2"
      },
      {
        "MarketerID": 143505,
        "MarketerName": "datetest2222"
      },
      {
        "MarketerID": 143506,
        "MarketerName": "datetestt3"
      },
      {
        "MarketerID": 143507,
        "MarketerName": "datetest333434"
      },
      {
        "MarketerID": 143508,
        "MarketerName": "ravitesssst"
      },
      {
        "MarketerID": 143509,
        "MarketerName": "Marketer001"
      },
      {
        "MarketerID": 143510,
        "MarketerName": "Marketer002"
      },
      {
        "MarketerID": 143511,
        "MarketerName": "TEstDEMo"
      },
      {
        "MarketerID": 143512,
        "MarketerName": "Colonial"
      },
      {
        "MarketerID": 143513,
        "MarketerName": "Test Marketer 1"
      },
      {
        "MarketerID": 143514,
        "MarketerName": "jhgfdsdfjhgfd"
      },
      {
        "MarketerID": 143515,
        "MarketerName": "asdfnbvcxhgfdgf"
      },
      {
        "MarketerID": 143516,
        "MarketerName": "cvbvbcvbdfgdfg"
      },
      {
        "MarketerID": 143517,
        "MarketerName": "lkjhjkl"
      }
    ]
  }
}


export const PipelineConfirmationDefaltData ={
  "TotalNominationForEachMarketer": [
           
      {
        "Marketer": "-",
        "TotalNomination": 0
      },
      
    ],
    "TotalNominationForPipeline": 0,
     "ReportBody": [
      {
        "Marketer": "-",
        "ContractNumber": "-",
        "Nomination": 0
      },
       {
        "Marketer": "-",
        "ContractNumber": "-",
        "Nomination": 0
      },
     
    ],
}